window.theme = window.theme || {};
window.slate = window.slate || {}; 

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },


  // Not from Slate, but fit in the a11y category
  lockMobileScrolling: function(namespace, $element) {
    if ($element) {
      var $el = $element;
    } else {
      var $el = $(document.documentElement).add('body');
    }
    $el.on('touchmove' + namespace, function () {
      return false;
    });
  },

  unlockMobileScrolling: function(namespace, $element) {
    if ($element) {
      var $el = $element;
    } else {
      var $el = $(document.documentElement).add('body');
    }
    $el.off(namespace);
  }
};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
  createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt, subSection, subSectionId) {
    var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];

    if (!container) {
      return;
    }

    this.createInstance(container);

    var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

    if (!subSection) {
      this._loadSubSections();
    }

    // Run JS only in case of the section being selected in the editor
    // before merchant clicks "Add"
    if (instance && typeof instance.onLoad === 'function') {
      instance.onLoad(evt);
    }
  },

  _loadSubSections: function() {
    $('[data-subsection]').each(function(evt, el) {
      this._onSectionLoad(null, el, $(el).data('section-d'));
    }.bind(this));
  },

  _onSectionUnload: function(evt) {
    var instance = this._removeInstance(evt.detail.sectionId);
    if (instance && typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }
  },

  _onSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  _findInstance: function(id) {
    for (var i = 0; i < this.instances.length; i++) {
      if (this.instances[i].id === id) {
        return this.instances[i];
      }
    }
  },

  _removeInstance: function(id) {
    var i = this.instances.length;
    var instance;

    while(i--) {
      if (this.instances[i].id === id) {
        instance = this.instances[i];
        this.instances.splice(i, 1);
        break;
      }
    }

    return instance;
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this.createInstance(container, constructor);
    }.bind(this));
  }
});


/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '$';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();


/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    if (!src) {
      return '620x'; // default based on theme
    }

    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

slate.Variants = (function() {

  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = this._compact(currentOptions);

      return currentOptions;
    },

    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var match = true;
        var options = variant.options;

        selectedValues.forEach(function(option) {
          // console.log('try to match ' + option.value + ' with ' + variant[option.index]);

          if (match) {
            match = (variant[option.index] === option.value);
          }
        });

        if (match) {
          found = variant;
        }
      });

      return found || null;
    },

    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },

    // _.compact from lodash
    // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
    _compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
  });

  return Variants;
})();


/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="table-wrapper"></div>');
  }
};


theme.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active',
      closingClass: 'modal--is-closing',
      bodyOpenClass: 'modal-open',
      bodyOpenSolidClass: 'modal-open--solid',
      bodyClosingClass: 'modal-closing',
      closeOffContentClick: true
    };

    this.id = id;
    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('html').add('body'),
      $modalContent: this.$modal.find('.modal__inner')
    };

    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.isSolid = this.config.solid;

    this.init();
  }

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', this.open.bind(this));
    this.$modal.find(this.config.close).on('click', this.close.bind(this));

    // Close modal if a drawer is opened
    $('body').on('drawerOpen', function() {
      this.close();
    }.bind(this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.$modal
      .prepareTransition()
      .addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.bodyOpenClass);

    if (this.isSolid) {
      this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = true;

    slate.a11y.trapFocus({
      $container: this.$modal,
      $elementToFocus: this.$focusOnOpen,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    $('body').trigger('modalOpen.' + this.id);

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal
      .prepareTransition()
      .removeClass(this.config.openClass)
      .addClass(this.config.closingClass);
    this.nodes.$parent.removeClass(this.config.bodyOpenClass);
    this.nodes.$parent.addClass(this.config.bodyClosingClass);
    var o = this;
    window.setTimeout(function() {
      o.nodes.$parent.removeClass(o.config.bodyClosingClass);
      o.$modal.removeClass(o.config.closingClass);
    }, 500); // modal close css transition

    if (this.isSolid) {
      this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = false;

    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    $('body').trigger('modalClose.' + this.id);

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$parent.on('keyup.modal', function(evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }.bind(this));

    if (this.config.closeOffContentClick) {
      // Clicking outside of the modal content also closes it
      this.$modal.on('click.modal', this.close.bind(this));

      // Exception to above: clicking anywhere on the modal content will NOT close it
      this.nodes.$modalContent.on('click.modal', function(evt) {
        evt.stopImmediatePropagation();
      });
    }
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$parent.off('.modal');

    if (this.config.closeOffContentClick) {
      this.$modal.off('.modal');
      this.nodes.$modalContent.off('.modal');
    }
  };

  return Modal;
})();

theme.Drawers = (function() {
  function Drawer(id, name) {
    this.config = {
      id: id,
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + name,
      openClass: 'js-drawer-open',
      closingClass: 'js-drawer-closing',
      activeDrawer: 'drawer--is-open',
      namespace: '.drawer-' + name
    };

    this.$nodes = {
      parent: $(document.documentElement).add('body'),
      page: $('#MainContent')
    };

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.isOpen = false;
    this.init();
  };

  Drawer.prototype = $.extend({}, Drawer.prototype, {
    init: function() {
      var $openBtn = $(this.config.open);

      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');

      $openBtn.on('click', this.open.bind(this));
      this.$drawer.find(this.config.close).on('click', this.close.bind(this));
    },

    open: function(evt) {
      if (evt) {
        evt.preventDefault();
      }

      if (this.isOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }

      this.$drawer.prepareTransition().addClass(this.config.activeDrawer);

      this.$nodes.parent.addClass(this.config.openClass);
      this.isOpen = true;

      slate.a11y.trapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      $('body').trigger('drawerOpen.' + this.config.id);

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }

      this.bindEvents();
    },

    close: function() {
      if (!this.isOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);

      this.$nodes.parent.removeClass(this.config.openClass);
      this.$nodes.parent.addClass(this.config.closingClass);
      var o = this;
      window.setTimeout(function() {
        o.$nodes.parent.removeClass(o.config.closingClass);
      }, 500);

      this.isOpen = false;

      slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false');
      }

      this.unbindEvents();
    },

    bindEvents: function() {
      slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);

      // Clicking out of drawer closes it
      this.$nodes.page.on('click' + this.config.namespace, function () {
        this.close();
        return false;
      }.bind(this));

      // Pressing escape closes drawer
      this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
    },

    unbindEvents: function() {
      slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
      this.$nodes.parent.off(this.config.namespace);
    }
  });

  return Drawer;
})();

theme.cart = {
  getCart: function() {
    return $.getJSON('/cart.js');
  },

  changeItem: function(key, qty) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id=' + key,
      dataType: 'json'
    });
  },

  addItemFromForm: function(data) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json'
    });
  },

  _updateCart: function(params) {
    return $.ajax(params)
      .then(function(cart) {
        return cart;
      }.bind(this))
  },

  updateNote: function(note) {
    var params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + theme.cart.attributeToString(note),
      dataType: 'json',
      success: function(cart) {},
      error: function(XMLHttpRequest, textStatus) {}
    };

    $.ajax(params);
  },

  attributeToString: function(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return $.trim(attribute);
  }
}

$(function() {
  // Add a loading indicator on the cart checkout button (/cart and drawer)
  $('body').on('click', '.cart__checkout', function() {
    $(this).addClass('btn--loading');
  });

  $('body').on('change', 'textarea[name="note"]', function() {
    var newNote = $(this).val();
    theme.cart.updateNote(newNote);
  });


  // Custom JS to prevent checkout without confirming terms and conditions
  $('body').on('click', '.cart__checkout--ajax', function(evt) {
    if ($('#CartAgree').is(':checked')) {
    } else {
      alert(theme.strings.cartTermsConfirmation);
      $(this).removeClass('btn--loading');
      return false;
    }
  });

  $('body').on('click', '.cart__checkout--page', function(evt) {
    if ($('#CartPageAgree').is(':checked')) {
    } else {
      alert(theme.strings.cartTermsConfirmation);
      $(this).removeClass('btn--loading');
      return false;
    }
  });
});

theme.QtySelector = (function() {
  var classes = {
    input: '.js-qty__num',
    plus: '.js-qty__adjust--plus',
    minus: '.js-qty__adjust--minus'
  };

  function QtySelector($el, options) {
    this.$wrapper = $el;
    this.$originalInput = $el.find('input[type="number"]');
    this.minValue = this.$originalInput.attr('min') || 1;

    var defaults = {
      namespace: null
    };

    this.options = $.extend(defaults, options);

    this.source = $('#JsQty').html();
    this.template = Handlebars.compile(this.source);

    var quantities = {
      current: this._getOriginalQty(),
      add: this._getOriginalQty() + 1,
      minus: this._getOriginalQty() - 1
    };

    this.data = {
      key: this._getProductKey(),
      itemQty: quantities.current,
      itemAdd: quantities.add,
      itemMinus: quantities.minus,
      inputName: this._getInputName(),
      inputId: this._getId()
    }

    // Append new quantity selector then remove original
    this.$originalInput.after(this.template(this.data)).remove();
    this.$input = this.$wrapper.find(classes.input);
    this.$plus = this.$wrapper.find(classes.plus);
    this.$minus = this.$wrapper.find(classes.minus);

    this.initEventListeners();
  };

  QtySelector.prototype = $.extend({}, QtySelector.prototype, {
    _getProductKey: function() {
      return this.$originalInput.data('id') || null;
    },

    _getOriginalQty: function() {
      return parseInt(this.$originalInput.val());
    },

    _getInputName: function() {
      return this.$originalInput.attr('name');
    },

    _getId: function() {
      return this.$originalInput.attr('id');
    },

    initEventListeners: function() {
      this.$plus.on('click', function() {
        var qty = this.validateQty(this.$input.val());
        this.addQty(qty);
      }.bind(this));

      this.$minus.on('click', function() {
        var qty = this.validateQty(this.$input.val());
        this.subtractQty(qty);
      }.bind(this));

      this.$input.on('change', function() {
        var qty = this.validateQty(this.$input.val());
        this.changeQty(qty);
      }.bind(this));
    },

    addQty: function(number) {
      var qty = number + 1;
      this.changeQty(qty);
    },

    subtractQty: function(number) {
      var qty = number - 1;
      if (qty <= this.minValue) {
        qty = this.minValue;
      }
      this.changeQty(qty);
    },

    changeQty: function(qty) {
      this.$input.val(qty);
      $('body').trigger('qty' + this.options.namespace, [this.data.key, qty]);
    },

    validateQty: function(number) {
      if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
        // We have a valid number!
      } else {
        // Not a number. Default to 1.
        number = 1;
      }
      return parseInt(number);
    }
  });

  return QtySelector;
})();

theme.CartDrawer = (function() {
  var config = {
    namespace: '.ajaxcart'
  };

  var selectors = {
    drawer: '#CartDrawer',
    container: '#CartContainer',
    template: '#CartTemplate',
    fixedFooter: '.drawer__footer--fixed',
    fixedInnerContent: '.drawer__inner--has-fixed-footer',
    cartBubble: '.cart-link__bubble'
  };

  function CartDrawer() {
    this.status = {
      loaded: false,
      loading: false
    };

    this.qtySelectors = [];

    this.drawer = new theme.Drawers('CartDrawer', 'cart');

    // Prep handlebars template
    var source = $(selectors.template).html();
    this.template = Handlebars.compile(source);

    // Build cart on page load so it's ready in the drawer
    if (!theme.config.isIframe) {
      theme.cart.getCart().then(this.buildCart.bind(this));
    }

    this.initEventListeners();
  };

  CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
    initEventListeners: function() {
      $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
      $('body').on('updateCart' + config.namespace, this.sizeFooter.bind(this));
      $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
      $('body').on('drawerOpen.CartDrawer', this.sizeFooter.bind(this));

      $(window).on('resize' + config.namespace, $.debounce(150, this.sizeFooter.bind(this)));

      $('body').on('added.ajaxProduct', function() {
        theme.cart.getCart().then(function(cart) {
          this.buildCart(cart, true);
        }.bind(this));
      }.bind(this));
    },

    buildCart: function(cart, openDrawer) {
      this.loading(true);
      this.emptyCart();

      if (cart.item_count === 0) {
        $(selectors.container).append('<p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty +'</p>');
      } else {
        var items = [];
        var item = {};
        var data = {};
        var animation_row = 1;

        $.each(cart.items, function(index, product) {

          var prodImg;
          if (product.image !== null) {
            prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
          } else {
            prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
          }

          if (product.properties !== null) {
            $.each(product.properties, function(key, value) {
              if (key.charAt(0) === '_' || !value) {
                 delete product.properties[key];
               }
            });
          }

          animation_row+=2;

          item = {
            key: product.key,
            url: product.url,
            img: prodImg,
            animationRow: animation_row,
            name: product.product_title,
            variation: product.variant_title,
            properties: product.properties,
            itemQty: product.quantity,
            price: theme.Currency.formatMoney(product.price, theme.settings.moneyFormat),
            discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.settings.moneyFormat),
            discounts: product.discounts,
            discountsApplied: product.price === (product.price - product.total_discount) ? false : true,
            vendor: product.vendor
          };

          items.push(item);
        });

        animation_row+=2;

        data = {
          items: items,
          note: cart.note,
          lastAnimationRow: animation_row,
          totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat),
          totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings.replace('[savings]', theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat))
        };

        $(selectors.container).append(this.template(data));
      }

      this.status.loaded = true;
      this.loading(false);

      if ($('body').hasClass('currencies-enabled')) {
        theme.currencySwitcher.ajaxrefresh();
      }

      $('body').trigger('updateCart' + config.namespace, cart);

      // If specifically asked, open the cart drawer (only happens after product added from form)
      if (openDrawer === true) {
        this.drawer.open();
      }
    },

    initQtySelectors: function() {
      this.qtySelectors = [];

      $(selectors.container).find('.js-qty').each(function(index, el) {
        var selector = new theme.QtySelector($(el), {
          namespace: '.cart-drawer'
        });
        this.qtySelectors.push(selector);
      }.bind(this));

      $('body').on('qty.cart-drawer', this.updateItem.bind(this));
    },

    updateItem: function(evt, key, qty) {
      if (this.status.loading) {
        return;
      }

      this.loading(true);

      theme.cart.changeItem(key, qty)
        .then(function(cart) {
          this.updateSuccess(cart);
        }.bind(this))
        .catch(function(XMLHttpRequest) {
          this.updateError(XMLHttpRequest)
        }.bind(this))
        .always(function() {
          this.loading(false);
        }.bind(this));
    },

    loading: function(state) {
      this.status.loading = state;

      if (state) {
        $(selectors.container).addClass('is-loading');
      } else {
        $(selectors.container).removeClass('is-loading');
      }
    },

    emptyCart: function() {
      $(selectors.container).empty();
    },

    updateSuccess: function(cart) {
      this.buildCart(cart)
    },

    updateError: function(XMLHttpRequest) {
      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);
      }
    },

    // Update elements after cart is updated
    sizeFooter: function() {
      // Stop if our drawer doesn't have a fixed footer
      if (!$(selectors.drawer).hasClass('drawer--has-fixed-footer')) {
        return;
      }

      // Elements are reprinted regularly so selectors are not cached
      var $cartFooter = $(selectors.drawer).find(selectors.fixedFooter).removeAttr('style');
      var $cartInner = $(selectors.drawer).find(selectors.fixedInnerContent).removeAttr('style');
      var cartFooterHeight = $cartFooter.outerHeight();

      $cartInner.css('bottom', cartFooterHeight);
      $cartFooter.css('height', cartFooterHeight);
    },

    updateCartNotification: function(evt, cart) {
      if (cart.items.length > 0) {
        $(selectors.cartBubble).addClass('cart-link__bubble--visible');
      } else {
        $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
      }
    }
  });

  return CartDrawer;
})();

theme.AjaxProduct = (function() {
  var status = {
    loading: false
  };

  function ProductForm($form) {
    this.$form = $form;
    this.$addToCart = this.$form.find('.add-to-cart');

    if (this.$form.length) {
      this.$form.on('submit', this.addItemFromForm.bind(this));
    }
  };

  ProductForm.prototype = $.extend({}, ProductForm.prototype, {
    addItemFromForm: function(evt, callback){
//       evt.preventDefault();

//       if (status.loading) {
//         console.warn('already adding item to cart | bail');
//         return;
//       }

//       // Loading indicator on add to cart button
//       this.$addToCart.addClass('btn--loading');

//       status.loading = true;

//       var data = this.$form.serialize();

//       theme.cart.addItemFromForm(data)
//         .then(function(product) {
//           this.success(product);
//         }.bind(this))
//         .catch(function(XMLHttpRequest) {
//           this.error(XMLHttpRequest)
//         }.bind(this))
//         .always(function() {
//           status.loading = false;
//           this.$addToCart.removeClass('btn--loading');
//         }.bind(this));
      jQuery('form[action="cart/add"]').submit();
    },

    success: function(product) {
      this.$form.find('.errors').remove();
      $('body').trigger('added.ajaxProduct');
    },

    error: function(XMLHttpRequest) {
      this.$form.find('.errors').remove();

      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);

        this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
      }
    }
  });

  return ProductForm;
})();

theme.collapsibles = (function() {

  var selectors = {
    trigger: '.collapsible-trigger',
    module: '.collapsible-content',
    moduleInner: '.collapsible-content__inner'
  };

  var classes = {
    hide: 'hide',
    open: 'is-open',
    autoHeight: 'collapsible--auto-height'
  };

  var isTransitioning = false;

  function init() {
    $(selectors.trigger).each(function() {
      var $el = $(this);
      var state = $el.hasClass(classes.open);
      $el.attr('aria-expanded', state);
    });

    // Event listeners (hack for modals)
    $('body, .modal__inner').on('click', selectors.trigger, function() {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var $el = $(this);
      var isOpen = $el.hasClass(classes.open);
      var moduleId = $el.attr('aria-controls');
      var $module = $('#' + moduleId);
      var height = $module.find(selectors.moduleInner).outerHeight();
      var isAutoHeight = $el.hasClass(classes.autoHeight);

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight($module, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      $el
        .attr('aria-expanded', !isOpen)
        .toggleClass(classes.open, !isOpen);

      setTransitionHeight($module, height, isOpen, isAutoHeight);
    });
  }

  function setTransitionHeight($module, height, isOpen, isAutoHeight) {
    $module
      .removeClass(classes.hide)
      .prepareTransition()
      .css('height', height)
      .toggleClass(classes.open, !isOpen);

    if (!isOpen && isAutoHeight) {
      var o = $module;
      window.setTimeout(function() {
        o.css('height','auto');
        isTransitioning = false;
      }, 500);
    } else {
      isTransitioning = false;
    }
  }

  return {
    init: init
  };
})();

theme.headerNav = (function() {

  var $parent = $(document.documentElement).add('body');
  var $page = $('#MainContent');
  var selectors = {
    wrapper: '.header-wrapper',
    siteHeader: '.site-header',
    searchBtn: '.js-search-header',
    closeSearch: '.js-search-header-close',
    searchContainer: '.site-header__search-container',
    logoContainer: '.site-header__logo',
    logo: '.site-header__logo img',
    navigation: '.site-navigation',
    navContainerWithLogo: '.header-item--logo',
    navLinks: '.site-nav__link',
    navDropdownLinks: '.site-nav__dropdown-link--second-level',

    hasDropdownClass: 'site-nav--has-dropdown',
    hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
    reverseLastDropdown: 'header-item--reverse'
  };

  var config = {
    namespace: '.siteNav',
    wrapperOverlayed: false,
    overlayedClass: 'is-light',
    stickyEnabled: false,
    stickyActive: false,
    stickyClass: 'site-header--stuck',
    openTransitionClass: 'site-header--opening',
    lastScroll: 0
  };

  // Elements used in resize functions, defined in init
  var $window;
  var $navContainerWithLogo;
  var $logoContainer;
  var $nav;
  var $wrapper;
  var $siteHeader;

  function init() {
    $window = $(window);
    $navContainerWithLogo = $(selectors.navContainerWithLogo);
    $logoContainer = $(selectors.logoContainer);
    $nav = $(selectors.navigation);
    $wrapper = $(selectors.wrapper);
    $siteHeader = $(selectors.siteHeader);

    var enableFitNav = $(selectors.navigation).hasClass('site-nav--activate-compress');

    if (enableFitNav) {
      fitNav();
      $window.on('load' + config.namespace, fitNav);
      $window.on('resize' + config.namespace, $.debounce(150, fitNav));
    }

    config.stickyEnabled = $siteHeader.data('sticky');
    if (config.stickyEnabled) {
      config.wrapperOverlayed = $wrapper.hasClass(config.overlayedClass);
      stickyHeader();
    }

    accessibleDropdowns();
    searchDrawer();

    $window.on('load' + config.namespace, resizeLogo);
    $window.on('resize' + config.namespace, $.debounce(150, resizeLogo));
  }

  function unload() {
    $(window).off(config.namespace);
    $(selectors.searchBtn).off(config.namespace);
    $(selectors.closeSearch).off(config.namespace);
    $parent.off(config.namespace);
    $(selectors.navLinks).off(config.namespace);
    $(selectors.navDropdownLinks).off(config.namespace);
  }

  function searchDrawer() {
    $(selectors.searchBtn).on('click' + config.namespace, function(evt) {
      evt.preventDefault();
      openSearchDrawer();
    });

    $(selectors.closeSearch).on('click' + config.namespace, function() {
      closeSearchDrawer();
    });
  }

  function openSearchDrawer() {
    $(selectors.searchContainer).addClass('is-active');
    $parent.addClass('js-drawer-open js-drawer-open--search');

    slate.a11y.trapFocus({
      $container: $(selectors.searchContainer),
      namespace: 'header_search',
      $elementToFocus: $(selectors.searchContainer).find('input')
    });

    // If sticky is enabled, scroll to top on mobile when close to it
    // so you don't get an invisible search box
    if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
      window.scrollTo(0,0);
    }

    // Bind events
    slate.a11y.lockMobileScrolling(config.namespace);

    // Clicking out of container closes it
    $page.on('click' + config.namespace, function () {
      closeSearchDrawer();
      return false;
    });

    $parent.on('keyup' + config.namespace, function(evt) {
      if (evt.keyCode === 27) {
        closeSearchDrawer();
      }
    });
  }

  function closeSearchDrawer() {
    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    $parent.removeClass('js-drawer-open js-drawer-open--search').off(config.namespace);
    $(selectors.searchContainer).removeClass('is-active');

    slate.a11y.removeTrapFocus({
      $container: $(selectors.searchContainer),
      namespace: 'header_search'
    });

    slate.a11y.unlockMobileScrolling(config.namespace);
    $page.off('click' + config.namespace);
    $parent.off('keyup' + config.namespace);
  }

  function resizeLogo() {
    // Using .each() as there can be a reversed logo too
    $(selectors.logo).each(function() {
      var $el = $(this),
          logoWidthOnScreen = $el.width(),
          containerWidth = $el.closest('.grid__item').width();
      // If image exceeds container, let's make it smaller
      if (logoWidthOnScreen > containerWidth) {
        $el.css('maxWidth', containerWidth);
      }
      else {
        $el.removeAttr('style');
      }
    });
  }

  function fitNav() {
    // Measure children of site nav on load and resize.
    // If wider than parent (minus logo), switch to mobile nav.
    // Subtract 20 from width to account for inline-block spacing
    var availableNavSpace = $navContainerWithLogo.width() - $logoContainer.outerWidth() - 20;
    var navItemWidth = 0;
    $nav.find('> li').each(function() {
      var $el = $(this);
      if (!$el.hasClass('site-nav--compress__menu')) {
        // Round up to be safe
        navItemWidth += Math.ceil($(this).width());
      }
    });

    // Set class to make third level nav float to left so it stays in the screen
    if ((availableNavSpace - navItemWidth) < 180) {
      $navContainerWithLogo.addClass(selectors.reverseLastDropdown)
    } else {
      $navContainerWithLogo.removeClass(selectors.reverseLastDropdown)
    }

    if (navItemWidth > availableNavSpace) {
      $wrapper.addClass('site-nav--compress');
    } else {
      $wrapper.removeClass('site-nav--compress');
    }
  }

  function accessibleDropdowns() {
    var hasActiveDropdown = false;
    var hasActiveSubDropdown = false;

    // Open/hide top level dropdowns
    $(selectors.navLinks).on('focusin' + config.namespace, function() {
      if (hasActiveDropdown) {
        closeSecondLevelDropdown();
      }

      if (hasActiveSubDropdown) {
        closeThirdLevelDropdown();
      }

      if ($(this).parent().hasClass(selectors.hasDropdownClass)) {
        $(this).addClass('is-focused');
        hasActiveDropdown = true;
      }
    });

    // Force remove focus on sitenav links because focus sometimes gets stuck
    $(selectors.navLinks).on('mouseleave' + config.namespace, function() {
      closeSecondLevelDropdown();
    });

    // Open/hide sub level dropdowns
    $(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
      if (hasActiveSubDropdown) {
        closeThirdLevelDropdown();
      }

      if ($(this).parent().hasClass(selectors.hasSubDropdownClass)) {
        $(this).addClass('is-focused');
        hasActiveSubDropdown = true;
      }
    });

    // Private dropdown methods
    function closeSecondLevelDropdown() {
      $(selectors.navLinks).blur().removeClass('is-focused');
    }

    function closeThirdLevelDropdown() {
      $(selectors.navDropdownLinks).removeClass('is-focused');
    }
  }

  function stickyHeader() {
    config.lastScroll = 0;
    $siteHeader.wrap('<div class="site-header-sticky"></div>');

    stickyHeaderHeight();
    $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
    $window.on('scroll' + config.namespace, $.throttle(15, stickyHeaderScroll));
  }

  function stickyHeaderHeight() {
    var $stickyHeader = $('.site-header-sticky').css('height', $siteHeader.outerHeight(true));
  }

  function stickyHeaderScroll() {
    var scroll = $window.scrollTop();
    var threshold = 250;

    if (scroll > threshold) {
      if (config.stickyActive) {
        return;
      }

      config.stickyActive = true;

      $siteHeader.addClass(config.stickyClass);
      if (config.wrapperOverlayed) {
        $wrapper.removeClass(config.overlayedClass);
      }

      // Add open transition class after element is set to fixed
      // so CSS animation is applied correctly
      setTimeout(function() {
        $siteHeader.addClass(config.openTransitionClass);
      }, 100);
    } else {
      if (!config.stickyActive) {
        return;
      }

      config.stickyActive = false;

      $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
      if (config.wrapperOverlayed) {
        $wrapper.addClass(config.overlayedClass);
      }
    }

    config.lastScroll = scroll;
  }

  return {
    init: init,
    unload: unload
  };
})();

theme.articleImages = (function() {

  var cache = {};

  function init() {
    cache.$rteImages = $('.rte--indented-images');

    if (!cache.$rteImages.length) {
      return;
    }

    $(window).on('load', setImages);
  }

  function setImages() {
    cache.$rteImages.find('img').each(function() {
      var $el = $(this);
      var attr = $el.attr('style');

      // Check if undefined or float: none
      if (!attr || attr == 'float: none;') {
        // Remove grid-breaking styles if image isn't wider than parent
        if ($el.width() < cache.$rteImages.width()) {
          $el.addClass('rte__no-indent');
        }
      }
    });
  }

  return {
    init: init
  };
})();

theme.backButton = (function() {

  function init() {
    if (!document.referrer || !$('.return-link').length || !window.history.length) {
      return;
    }

    //$('.return-link').on('click', backHistory);
  }

  function backHistory() {
    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(document.url);

    if (shopDomain === referrerDomain) {
      history.back();
      return false;
    }
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  }

  return {
    init: init
  };
})();

theme.Slideshow = (function() {
  this.$slideshow = null;

  var classes = {
    next: 'is-next',
    init: 'is-init',
    header: 'header-wrapper',
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el, args) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: args.arrows ? true : false,
      dots: args.dots ? true : false,
      draggable: true,
      touchThreshold: 5,
      pauseonHover: false,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('init', this.init.bind(this));

    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this._togglePause.bind(this));
  }

  slideshow.prototype = $.extend({}, slideshow.prototype, {
    init: function(event, obj) {
      this.$slideshowList = obj.$list;
      this.$slickDots = obj.$dots;
      this.$allSlides = obj.$slides;
      this.slideCount = obj.slideCount;

      this.$slideshow.addClass(classes.init);
      this._a11y();
      this._clonedLazyloading();
    },
    destroy: function() {
      this.$slideshow.slick('unslick');
    },

    // Playback
    _play: function() {
      this.$slideshow.slick('slickPause');
      $(classes.pauseButton).addClass('is-paused');
    },
    _pause: function() {
      this.$slideshow.slick('slickPlay');
      $(classes.pauseButton).removeClass('is-paused');
    },
    _togglePause: function() {
      var slideshowSelector = this._getSlideshowId(this.$pause);
      if (this.$pause.hasClass(classes.isPaused)) {
        this.$pause.removeClass(classes.isPaused);
        $(slideshowSelector).slick('slickPlay');
      } else {
        this.$pause.addClass(classes.isPaused);
        $(slideshowSelector).slick('slickPause');
      }
    },

    // Helpers
    _getSlideshowId: function($el) {
      return '#Slideshow-' + $el.data('id');
    },
    _activeSlide: function() {
      return this.$slideshow.find('.slick-active');
    },
    _currentSlide: function() {
      return this.$slideshow.find('.slick-current');
    },
    _nextSlide: function(index) {
      return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
    },

    // a11y fixes
    _a11y: function() {
      var $list = this.$slideshowList;
      var autoplay = this.settings.autoplay;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live
      $(classes.wrapper).on('focusin', function(evt) {
        if (!$(classes.wrapper).has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');
        if (autoplay) {
          this._pause();
        }
      }.bind(this));

      // Resume autoplay
      $(classes.wrapper).on('focusout', function(evt) {
        if (!$(classes.wrapper).has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');
        if (autoplay) {
          this._play();
        }
      }.bind(this));
    },

    // Make sure lazyloading works on cloned slides
    _clonedLazyloading: function() {
      var $slideshow = this.$slideshow;

      $slideshow.find('.slick-slide').each(function(index, el) {
        var $slide = $(el);
        if ($slide.hasClass('slick-cloned')) {
          var slideId = $slide.data('id');
          var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');

          // Get inline style attribute from non-cloned slide with arbitrary timeout
          // so the image is loaded
          setTimeout(function() {
            var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');

            if (loadedImageStyle) {
              $slideImg.attr('style', loadedImageStyle);
            }

          }, this.settings.autoplaySpeed / 1.5);

        }
      }.bind(this));
    }
  });

  return slideshow;
})();

theme.announcementBar = (function() {
  var selectors = {
    announcementBar: '.announcement',
    announcementText: '.announcement__text',
    announcementClose: '.announcement__close'
  }

  function init() {
    if (!$(selectors.announcementClose).length || theme.config.isIframe) {
      return;
    }

    if (theme.config.hasSessionStorage && sessionStorage[announcementBarText()] !== 'hidden') {
      window.setTimeout(function() {
        announcementBarShow();
      }, 2000);
    }

    // Probably in the editor, so show it anyway
    if (!theme.config.hasSessionStorage) {
      window.setTimeout(function() {
        announcementBarShow();
      }, 2000);
    }

    $(selectors.announcementClose).on('click', function(evt) {
      evt.preventDefault();
      announcementBarClose();
    });
  }

  function announcementBarShow() {
    $(selectors.announcementBar).removeClass('announcement--closed');
    var barHeight = $(selectors.announcementBar).height();
    $(selectors.announcementBar).addClass('announcement--opening').prepareTransition().css({height: barHeight});
    $(selectors.announcementClose).css({height: barHeight});
  }

  function announcementBarClose() {
    if (theme.config.hasSessionStorage) {
      sessionStorage.setItem(announcementBarText(), 'hidden');
    }

    var barHeight = $(selectors.announcementBar).height();

    $(selectors.announcementBar).addClass('announcement--closed');
  }

  function announcementBarText() {
    return $(selectors.announcementText).data('text');
  }

  return {
    init: init
  };
})();

theme.currencySwitcher = (function() {

  var selectors = {
    dataDiv: '#CurrencyData',
    picker: '.currency-input'
  };

  var data = {};

  function init() {
    var $dataDiv = $(selectors.dataDiv);

    if (!$dataDiv.length) {
      return;
    }

    $primaryPicker = $('#CurrencyPicker-header');
    $secondaryPicker = $('#CurrencyPicker-footer');

    // Keep primary and secondary currency pickers in sync
    if ($secondaryPicker.length) {
      $secondaryPicker.on('change', function() {
        $primaryPicker.val($(this).val());
      });

      $primaryPicker.on('change', function() {
        $secondaryPicker.val($(this).val());
      });
    }

    data = {
      currency: $dataDiv.data('shop-currency'),
      default: $dataDiv.data('default-currency'),
      format: $dataDiv.data('format'),
      moneyFormat: $dataDiv.data('money-format'),
      moneyCurrencyFormat: $dataDiv.data('money-currency-format')
    };

    Currency.format = data.format;

    // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
    Currency.money_format[data.currency] = data.moneyFormat;
    Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;

    // Fix for customer account page
    $('span.money span.money').each(function() {
      $(this).parents('span.money').removeClass('money');
    });

    // Save current price
    $('span.money').each(function() {
      $(this).attr('data-currency-' + data.currency, $(this).html());
    });

    checkCookie();

    $(selectors.picker).val(Currency.currentCurrency).on('change', refresh);
  }

  function refresh() {
    var newCurrency = $(selectors.picker).val();
    Currency.convertAll(Currency.currentCurrency, newCurrency);
  }

  function ajaxrefresh() {
    var newCurrency = $(selectors.picker).val();
    // Ajax cart always returns shop's currency, not what theme settings defines
    Currency.convertAll(data.currency, newCurrency);
  }

  function checkCookie() {
    var cookieCurrency = Currency.cookie.read();

    if (cookieCurrency == null) {
      if (data.currency !== data.default) {
        Currency.convertAll(data.currency, data.default);
      }
      else {
        Currency.currentCurrency = data.default;
      }
    } else if ($(selectors.picker).length && $(selectors.picker).find('option[value=' + cookieCurrency + ']').length === 0) {
      // If the cookie value does not correspond to any value in the currency dropdown
      Currency.currentCurrency = data.currency;
      Currency.cookie.write(data.currency);
    }
    else if (cookieCurrency === data.currency) {
      Currency.currentCurrency = data.currency;
    }
    else {
      Currency.convertAll(data.currency, cookieCurrency);
    }
  }

  return {
    init: init,
    refresh: refresh,
    ajaxrefresh: ajaxrefresh
  };
})();

theme.initQuickShop = function() {
  $('.quick-product__btn').each(function() {
    var productId = $(this).data('product-id');
    var modalId = 'QuickShopModal-' + productId;
    var modalName = 'quick-modal-' + productId;
    new theme.Modals(modalId, modalName);
  });
};

theme.videoModal = function() {
  var videoModalPlayer = null;
  var videoOptions = {
    width: 1280,
    height: 720,
    playerVars: {
      autohide: 0,
      autoplay: 1,
      loop:1,
      branding: 0,
      cc_load_policy: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      quality: 'hd720',
      rel: 0,
      showinfo: 0,
      wmode: 'opaque'
    }
  };

  var selectors = {
    triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
  };

  if (!$(selectors.triggers).length) {
    return;
  }

  var modal = new theme.Modals('VideoModal', 'video-modal', {
    closeOffContentClick: true,
    solid: true
  });

  // We have at least one video that may open in a modal. Prep YouTube API
  window.loadYouTube();
  $('body').on('youTubeReady', function() {
    $(selectors.triggers).on('click', startVideoOnClick);
  });

  function startVideoOnClick(evt) {
    evt.preventDefault();
    var $el = $(this);

    // get video ID from URL
    var videoId = getYoutubeVideoId($el.attr('href'));

    var args = $.extend({}, videoOptions, {
      videoId: videoId
    });

    // Disable plays inline on mobile
    args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;

    var videoModalPlayer = new YT.Player('VideoHolder', args);
    modal.open();

    $('body').on('modalClose.VideoModal', function() {
      // Slight timeout so it is destroyed after the modal closes
      setTimeout(function() {
        videoModalPlayer.destroy();
      }, 500); // modal close css transition
    });
  }

  function getYoutubeVideoId(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  }
};



theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submitted
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


theme.Product = (function() {
  var youtubeReady;
  var videos = {};
  var youtubePlayers = [];
  var youtubeVideoOptions = {
    height: '480',
    width: '850',
    playerVars :{
      autohide: 0,
      autoplay: 1,
      loop:1,
      branding: 0,
      cc_load_policy: 0,
      controls: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      quality: 'hd720',
      rel: 0,
      showinfo: 0,
      wmode: 'opaque'
    },
    events: {
      onReady: onVideoPlayerReady,
      onStateChange: onVideoStateChange
    }
  };

  var vimeoReady;
  var vimeoPlayers = [];
  var vimeoVideoOptions = {
    byline: false,
    title: false,
    portrait: false,
    loop: true,
    autopause: false
  };

  var selectors = {
    videoParent: '.product__video-wrapper'
  };

  var classes = {
    loading: 'loading',
    loaded: 'loaded',
    interactable: 'video-interactable',
    currentSlide: 'slick-current',
    productVideo: 'product__video',
    zoomInit: 'photo-zoom-init'
  };

  function onVideoPlayerReady(evt) {
    var $player = $(evt.target.a);
    var playerId = $player.attr('id');
    youtubePlayers[playerId] = evt.target; // update stored player
    var player = youtubePlayers[playerId];
    setParentAsLoading($player);
    if (videos[playerId].style === 'muted') {
      youtubePlayers[playerId].mute().playVideo().pauseVideo();
    } else {
      setParentAsLoaded($player);
    }

    // If first slide or only photo, start video
    if ($player.closest('.' + classes.currentSlide).length || $player.data('image-count') === 1) {
      youtubePlayers[playerId].playVideo();
      initCheckVisibility(playerId);
    }
  }

  function initCheckVisibility(playerId) {
    // Add out of view pausing
    videoVisibilityCheck(playerId);
    $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
  }

  function videoVisibilityCheck(id) {
    var playerId;

    if (typeof id === 'string') {
      playerId = id;
    } else {
      // Data comes in as part of the scroll event
      playerId = id.data.id;
    }

    if (theme.isElementVisible($('#' + playerId))) {
      playVisibleVideo(playerId);
    } else {
      pauseHiddenVideo(playerId);
    }
  }

  function playVisibleVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
      youtubePlayers[id].playVideo();
    }
  }

  function pauseHiddenVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
      youtubePlayers[id].pauseVideo();
    }
  }

  function onVideoStateChange(evt) {
    var $player = $(evt.target.a);
    var playerId = $player.attr('id');
    var player = youtubePlayers[playerId];

    switch (evt.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (videos[playerId].attemptedToPlay) {
          setParentAsLoaded($player);
          setVideoToBeInteractedWith($player);
        }
        break;
      case 0: // ended
        player.playVideo();
        break;
      case 1: // playing
        setParentAsLoaded($player);
        break;
      case 3: // buffering
        videos[playerId].attemptedToPlay = true;
        break;
    }
  }

  function setParentAsLoading($el) {
    $el
      .closest(selectors.videoParent)
      .addClass(classes.loading);
  }

  function setParentAsLoaded($el) {
    $el
      .closest(selectors.videoParent)
      .removeClass(classes.loading)
      .addClass(classes.loaded);
  }

  function setVideoToBeInteractedWith($el) {
    $el
      .closest(selectors.videoParent)
      .addClass(classes.interactable);
  }

  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');

    this.inModal = $container.closest('.modal').length;
    this.$modal;

    this.settings = {
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId,
      zoom: $container.data('image-zoom') || false,
      inventory: $container.data('inventory') || false,
      modalInit: false,
      lazyLoadModalContent: $container.data('lazyload-content') || false,
      modalContentLoaded: false,
      slickInitialized: false,
      hasColorSwatches: false,
      hasImages: true,
      hasMultipleImages: false,
      imageSize: '620x'
    };

    // Overwrite some settings when loaded in modal
    if (this.inModal) {
      this.settings.enableHistoryState = false;
      this.settings.namespace = '.product-' + sectionId + '-modal';
      this.$modal = $('#QuickShopModal-' + sectionId);
    }

    this.classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal'
    };

    this.selectors = {
      productJson: 'ProductJson-' + sectionId,

      video: 'ProductVideo-' + sectionId,
      photoThumbs: '.product__thumb-' + sectionId,
      thumbSlider: '#ProductThumbs-' + sectionId,
      mainSlider: '#ProductPhotos-' + sectionId,
      productVideo: '.product__video',

      priceWrapper: '.product__price-wrap-' + sectionId,
      price: '#ProductPrice-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      priceA11y: '#PriceA11y-' + sectionId,
      comparePriceA11y: '#ComparePriceA11y-' + sectionId,
      sku: '#Sku-' + sectionId,
      inventory: '#ProductInventory-' + sectionId,

      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,

      originalSelectorId: '#ProductSelect-' + sectionId,
      singleOptionSelector: '.variant__input-' + sectionId,
      variantColorLabel: '#VariantColorLabel-' + sectionId,

      formContainer: '#AddToCartForm-' + sectionId,
    };

    if (!$('#' + this.selectors.productJson).html()) {
      return;
    }

    this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);

    this.$mainSlider = $(this.selectors.mainSlider);
    this.$thumbSlider = $(this.selectors.thumbSlider);
    this.$firstProductImage = this.$mainSlider.find('img').first();

    if (!this.$firstProductImage.length) {
      this.settings.hasImages = false;
    }

    this.init();
  }

  Product.prototype = $.extend({}, Product.prototype, {
    init: function() {
      if (this.inModal) {
        this.$container.addClass(this.classes.isModal);
        $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
        $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
      }

      this.stringOverrides();
      this.setImageSizes();
      this.initQtySelector();
      this.initAjaxProductForm();
      this.initVariants();
      this.initImageSwitch();

      if (!this.inModal) {
        this.checkIfVideos();
        this.createImageCarousels();
      }
    },

    stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    setImageSizes: function() {
      if (!this.settings.hasImages) {
        return;
      }

      // Get srcset image src, works on most modern browsers
      // otherwise defaults to settings.imageSize
      var currentImage = this.$firstProductImage[0].currentSrc;

      if (currentImage) {
        this.settings.imageSize = theme.Images.imageSize(currentImage);
      }

      if (this.settings.zoom) {
        this.settings.imageZoomSize = theme.Images.imageSize(this.$firstProductImage.parent().data('zoom-size'));
      }
    },

    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productObject
      };

      if ($(this.selectors.variantColorLabel).length) {
        this.settings.hasColorSwatches = true;
        this.$colorSwatchLabel = $(this.selectors.variantColorLabel);
        this.colorOptionIndex = this.$colorSwatchLabel.data('option-index');
        this.$container.on('variantChange' + this.settings.namespace, this.updateColorName.bind(this));
      }

      this.variants = new slate.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
      if ($(this.selectors.sku).length) {
        this.$container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
      }
      if (this.settings.inventory) {
        this.$container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
      }
    },

    // Variant change functions
    updateColorName: function(evt) {
      var variant = evt.variant;
      // Temp fix to prevent JS error. Still need to update color label if variant does not exist
      if (variant && variant.options) {
        var colorName = variant.options[this.colorOptionIndex];
        this.$colorSwatchLabel.text(colorName);
      } else {
        this.$colorSwatchLabel.empty();
      }
    },

    updateCartButton: function(evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          // Available, enable the submit button and change text
          $(this.selectors.addToCart).removeClass(this.classes.disabled).prop('disabled', false);
          $(this.selectors.addToCartText).html(theme.strings.addToCart);
        } else {
          // Sold out, disable the submit button and change text
          $(this.selectors.addToCart).addClass(this.classes.disabled).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.soldOut);
        }
      } else {
        // The variant doesn't exist, disable submit button
        $(this.selectors.addToCart).addClass(this.classes.disabled).prop('disabled', true);
        $(this.selectors.addToCartText).html(theme.strings.unavailable);
      }
    },

    updatePrice: function(evt) {
      var variant = evt.variant;

      if (variant) {
        // Regular price
        $(this.selectors.price).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();

        // Sale price, if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
          $(this.selectors.priceWrapper).removeClass('hide');
          $(this.selectors.price).addClass(this.classes.onSale);
          $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
          $(this.selectors.priceA11y).attr('aria-hidden', 'false');
        } else {
          $(this.selectors.priceWrapper).addClass('hide');
          $(this.selectors.price).removeClass(this.classes.onSale);
          $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
          $(this.selectors.priceA11y).attr('aria-hidden', 'true');
        }

        if ($('body').hasClass('currencies-enabled')) {
          theme.currencySwitcher.ajaxrefresh();
        }
      }
    },

    updateSku: function(evt) {
      var variant = evt.variant;
      var newSku = '';

      if (variant) {
        if (variant.sku) {
          newSku = variant.sku;
        }

        $(this.selectors.sku).html(newSku);
      }
    },

    updateInventory: function(evt) {
      var variant = evt.variant;
      var showInventory = false;
      var $inventoryLabel = $(this.selectors.inventory);

      if (variant && variant.inventory_management === 'shopify') {
        showInventory = true;

        if (variant.inventory_quantity === 0) {
          showInventory = false;
        }
      }

      if (!showInventory) {
        $inventoryLabel.addClass('hide');
      } else {
        $inventoryLabel
          .removeClass('hide')
          .text(theme.strings.stockLabel.replace('[count]', variant.inventory_quantity));
      }
    },

    updateVariantImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      var zoomSizedImgUrl;

      if (this.settings.zoom) {
        zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
      }

      var $newImage = $('.product__thumb[data-id="' + variant.featured_image.id + '"]');
      var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));

      // If there is no index, slider is not initalized
      if (typeof imageIndex === 'undefined') {
        return;
      }
      this.$mainSlider.slick('slickGoTo', imageIndex);
    },

    // Image/thumbnail toggling
    initImageSwitch: function() {
      if (!$(this.selectors.photoThumbs).length) {
        return;
      }

      var self = this;

      $(this.selectors.photoThumbs).on('click', function(evt) {
        evt.preventDefault();
      });
    },

    checkIfVideos: function() {
      var $productVideos = this.$mainSlider.find(this.selectors.productVideo);

      // Stop if there are 0 videos
      if (!$productVideos.length) {
        return false;
      }

      var videoTypes = [];

      $productVideos.each(function() {
        var type = $(this).data('video-type');

        if (videoTypes.indexOf(type) < 0) {
          videoTypes.push(type);
        }
      });

      // Load YouTube API if not already loaded
      if (videoTypes.indexOf('youtube') > -1) {
        if (!theme.config.youTubeReady) {
          window.loadYouTube();
          $('body').on('youTubeReady' + this.settings.namespace, function() {
            this.loadYoutubeVideos($productVideos);
          }.bind(this));
        } else {
          this.loadYoutubeVideos($productVideos);
        }
      }

      // Load Vimeo API if not already loaded
      if (videoTypes.indexOf('vimeo') > -1) {
        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.settings.namespace, function() {
            this.loadVimeoVideos($productVideos);
          }.bind(this))
        } else {
          this.loadVimeoVideos($productVideos);
        }
      }

      // Add mp4 video players
      if (videoTypes.indexOf('mp4') > -1) {
        this.loadMp4Videos($productVideos);
      }

      return videoTypes;
    },

    loadMp4Videos: function($videos) {
      $videos.each(function() {
        var $el = $(this);
        if ($el.data('video-type') != 'mp4') {
          return;
        }

        var id = $el.attr('id');
        var videoId = $el.data('video-id');

        videos[this.id] = {
          type: 'mp4',
          divId: id,
          style: $el.data('video-style')
        };
      });
    },

    loadVimeoVideos: function($videos) {
      $videos.each(function() {
        var $el = $(this);
        if ($el.data('video-type') != 'vimeo') {
          return;
        }

        var id = $el.attr('id');
        var videoId = $el.data('video-id');

        videos[this.id] = {
          type: 'vimeo',
          divId: id,
          id: videoId,
          style: $el.data('video-style'),
          width: $el.data('video-width'),
          height: $el.data('video-height')
        };
      });

      // Create a new player for each Vimeo video
      for (var key in videos) {
        if (videos[key].type != 'vimeo') {
          continue;
        }

        var args = $.extend({}, vimeoVideoOptions, videos[key]);
        vimeoPlayers[key] = new Vimeo.Player(videos[key].divId, args);
      }

      vimeoReady = true;
    },

    autoplayVimeoVideo: function(id) {
      console.log('2905');
      // Do not autoplay on mobile though
      if (!theme.config.bpSmall) {
        this.requestToPlayVimeoVideo(id);
      } else {
        // Set as loaded on mobile so you can see the image
        var $player = $('#' + id);
        setParentAsLoaded($player);
      }
    },

    requestToPlayVimeoVideo: function(id) {
      // The slider may initialize and attempt to play the video before
      // the API is even ready, because it sucks.
	  console.log('2919');	
      var $player = $('#' + id);
      setParentAsLoading($player);

      if (!vimeoReady) {
        // Wait for the trigger, then play it
        $('body').on('vimeoReady' + this.settings.namespace, function() {
          this.playVimeoVideo(id);
        }.bind(this))
        return;
      }

      this.playVimeoVideo(id);
    },

    playVimeoVideo: function(id) {
      vimeoPlayers[id].play();

      if (videos[id].style === 'muted') {
        vimeoPlayers[id].setVolume(0);
      }

      var $player = $('#' + id);
      setParentAsLoaded($player);
    },

    stopVimeoVideo: function(id) {
      if (!theme.config.vimeoReady) {
        return;
      }

      if (id) {
        vimeoPlayers[id].pause();
      } else {
        for (key in vimeoPlayers) {
          if (typeof vimeoPlayers[key].pause === 'function') {
            vimeoPlayers[key].pause();
          }
        }
      }
    },

    loadYoutubeVideos: function($videos) {
      $videos.each(function() {
        var $el = $(this);
        if ($el.data('video-type') != 'youtube') {
          return;
        }

        var id = $el.attr('id');
        var videoId = $el.data('youtube-id');

        videos[this.id] = {
          type: 'youtube',
          id: id,
          videoId: videoId,
          style: $el.data('video-style'),
          width: $el.data('video-width'),
          height: $el.data('video-height'),
          attemptedToPlay: false
        };
      });

      // Create a player for each YouTube video
      for (var key in videos) {
        if (videos[key].type === 'youtube') {
          if (videos.hasOwnProperty(key)) {
            var args = $.extend({}, youtubeVideoOptions, videos[key]);

            if (args.style === 'muted') {
              // default youtubeVideoOptions, no need to change anything
            } else {
              args.playerVars.controls = 1;
              args.playerVars.autoplay = 1;
              args.playerVars.loop = 1;
            }

            youtubePlayers[key] = new YT.Player(key, args);
          }
        }
      }

      youtubeReady = true;
    },

    requestToPlayYoutubeVideo: function(id, forcePlay) {
      if (!theme.config.youTubeReady) {
        return;
      }

      var $player = $('#' + id);
      setParentAsLoading($player);

      // If video is requested too soon, player might not be ready.
      // Set arbitrary timeout to request it again in a second
      if (typeof youtubePlayers[id].playVideo != 'function') {
        var o = this;
        setTimeout(function() {
          o.playYoutubeVideo(id, forcePlay);
        }, 1000);
        return;
      }

      this.playYoutubeVideo(id, forcePlay);
    },

    playYoutubeVideo: function (id, forcePlay) {
      var $player = $('#' + id);
      setParentAsLoaded($player);
      if (typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }

      // forcePlay is sent as true from beforeSlideChange so the visibility
      // check isn't fooled by the next slide positioning
      if (!forcePlay) {
        initCheckVisibility(id);
      }
    },

    stopYoutubeVideo: function(id) {
      if (!theme.config.youTubeReady) {
        return;
      }

      if (id && youtubePlayers[id]) {
        youtubePlayers[id].pauseVideo();
        $(window).off('scroll.' + id);
      } else {
        for (key in youtubePlayers) {
          if (typeof youtubePlayers[key].pauseVideo === 'function') {
            youtubePlayers[key].pauseVideo();
            $(window).off('scroll.' + key);
          }
        }
      }
    },

    playMp4Video: function(id) {
      var $player = $('#' + id);
      setParentAsLoaded($player);

      $player[0].play();
    },

    stopMp4Video: function(id) {
      if (id) {
        $('#' + id)[0].pause();
      } else {
        // loop through all mp4 videos to stop them
        for (var key in videos) {
          if (videos[key].type === 'mp4') {
            var player = $('#' + videos[key].divId)[0];
            if (typeof player.pause === 'function') {
              player.pause();
            }
          }
        }
      }
    },

    // Init zoom for each image in the main carousel
    initZoom: function($image) {
      var largeImage = $image.parent().data('zoom-size');
      $image.parent()
      .on('click', function(evt) {
        evt.preventDefault();
      })
      .zoom({
        on: 'click',
        url: largeImage,
        duration: 180,
        touch: false,
        onZoomIn: function() {
          $(this).addClass('photo-zoom-linked');
        },
        onZoomOut: function() {
          $(this).removeClass('photo-zoom-linked');
        }
      });
    },

    createImageCarousels: function() {
      // Init zoom on non-lazy loaded image
      if (this.settings.zoom) {
        this.initZoom($('.photo-zoom-link__initial'));
      }

      if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
        // Single product image. Init video if it exists
        var $video = $('.product-image-main').find('.product__video');
        if ($video.length) {
          this.initVideo($video);
        }
        return;
      }

      this.settings.hasMultipleImages = true;

      // Set starting slide (for both sliders)
      var $activeSlide = this.$mainSlider.find('.starting-slide');
      var startIndex = this._slideIndex($activeSlide);

      // Lame way to prevent duplicate event listeners
      this.$mainSlider.off('init');
      this.$mainSlider.off('beforeChange');
      this.$mainSlider.on('init', this.mainSlideInit.bind(this));
      this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));

      
      this.$mainSlider.slick({
        asNavFor: this.selectors.thumbSlider,
        infinite: false,
        arrows: false,
        dots: true,
        initialSlide: startIndex,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              adaptiveHeight:true
            }
          }
        ]
      });

      var thumbnailsVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;
      
      this.$thumbSlider.slick({
        asNavFor: this.selectors.mainSlider,
        slidesToShow: thumbnailsVertical ? 3 : 5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        vertical: thumbnailsVertical,
        verticalSwiping: thumbnailsVertical,
        focusOnSelect: true,
        infinite: false,
        customHeightMatching: thumbnailsVertical,
        customSlideAdvancement: true,
        initialSlide: startIndex,
        responsive: [
          {
            breakpoint: 768,
            settings: {
            vertical: false,
            verticalSwiping: false,
              slidesToShow:4
            }
          }
        ]
      });

      this.settings.slickInitialized = true;
    },

    destroyImageCarousels: function() {
      if (!this.settings.slickInitialized) {
        return;
      }

      if (this.$mainSlider) {
        this.$mainSlider.slick('unslick');
      }

      if (this.$thumbSlider) {
        this.$thumbSlider.slick('unslick');
      }

      this.settings.slickInitialized = false;
    },

    mainSlideInit: function(event, slick) {
      console.log('Got here 3192');
      var $slider = slick.$slider;
      var $currentSlide = $slider.find('.' + classes.currentSlide);
      var $video = $currentSlide.find('.' + classes.productVideo);

      if (!$video.length) {
        return;
      }

      this.initVideo($video);
    },

    initVideo: function($video) {
      var videoType = $video.data('video-type');
      var divId = $video.attr('id');

      if (videoType === 'mp4' && videos[divId].style === 'muted') {
        this.playMp4Video(divId);
      }

      if (videoType === 'youtube') {
        if (youtubeReady && videos[divId].style === 'muted') {
          this.requestToPlayYoutubeVideo(divId);
        }
      }

      if (videoType === 'vimeo') {
        if (vimeoReady && videos[divId].styles === 'muted') {
          // Because the vimeo API might not be ready, this autoplay check
          // is handled elsewhere
          this.autoplayVimeoVideo(divId);
        }
      }

      // Hacky way to trigger resetting the slider layout in modals
      if (this.inModal) {
        this.resizeSlides();
      }
    },

    getVideoType: function($video) {
      return $video.data('video-type');
    },

    getVideoId: function($video) {
      return $video.attr('id');
    },

    beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find('.' + classes.currentSlide);
      var $prevVideo = $currentSlide.find('.product__video');
      var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
      var $nextVideo = $nextSlide.find('.product__video');

      // Pause any existing slide video
      if (currentSlide !== nextSlide && $prevVideo.length) {
        var prevVideoType = this.getVideoType($prevVideo);
        var prevVideoId = this.getVideoId($prevVideo);

        if (prevVideoId) {
          if (prevVideoType === 'youtube') {
            this.stopYoutubeVideo(prevVideoId);
          }

          if (prevVideoType === 'mp4') {
            this.stopMp4Video(prevVideoId);
          }

          if (prevVideoType === 'vimeo') {
            this.stopVimeoVideo(prevVideoId);
          }
        }
      }

      // Prep next slide video
      if ($nextVideo.length) {
        var nextVideoType = this.getVideoType($nextVideo);
        var nextVideoId = this.getVideoId($nextVideo);

        // Prep Vimeo with a backup in case the API isn't ready
        if (nextVideoId && nextVideoType === 'vimeo') {
          if (vimeoReady) {
            if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
              this.autoplayVimeoVideo(nextVideoId);
            }
          } else {
            $('body').on('vimeoReady' + this.settings.namespace, function() {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.autoplayVimeoVideo(nextVideoId);
              }
            }.bind(this))
          }
        }

        // Prep YouTube with a backup in case API isn't ready
        if (nextVideoId && nextVideoType === 'youtube') {
          if (youtubeReady) {
            if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
              this.requestToPlayYoutubeVideo(nextVideoId, true);
            }
          } else {
            $('body').on('youTubeReady' + this.settings.namespace, function() {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            }.bind(this))
          }
        }

        // Autoplay muted MP4 videos
        if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
          if (nextVideoType === 'mp4') {
            this.playMp4Video(nextVideoId);
          }
        }

        // Set unmuted videos to loaded state
        if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
          setParentAsLoaded($('#' + nextVideoId));
        }
      }

      // Layload zoom image
      if (this.settings.zoom) {
        if ($nextSlide.hasClass(classes.zoomInit)) {
          return;
        }
        var $image = $nextSlide.addClass(classes.zoomInit).find('img').addClass('lazyload');
        this.initZoom($image);
      }
    },

    resizeSlides: function() {
      if (!this.settings.hasMultipleImages) {
        return;
      }

      $(window).trigger('resize');
      setTimeout(function() {
        this.$mainSlider.slick('setPosition');
        this.$thumbSlider.slick('setPosition');
      }.bind(this), 500); // same timing as modal open transition
    },

    _slideIndex: function($el) {
      return $el.data('index');
    },

    // Ajax cart and qty
    initQtySelector: function() {
      this.$container.find('.js-qty').each(function() {
        new theme.QtySelector($(this), {
          namespace: '.product'
        });
      });
    },

    initAjaxProductForm: function() {
      if (theme.settings.cartType === 'drawer') {
        new theme.AjaxProduct($(this.selectors.formContainer));
      }
    },

    openModalProduct: function() {
      if (!this.settings.modalInit) {
        this.loadModalContent();
        this.createImageCarousels();
        this.settings.modalInit = true;
      }

      this.resizeSlides();
    },

    closeModalProduct: function() {
      this.stopYoutubeVideo();
      this.stopVimeoVideo();
      this.stopMp4Video();
    },

    loadModalContent: function() {
      if (this.settings.modalContentLoaded) {
        return;
      }

      // Load images
      var imageCount = $(this.selectors.photoThumbs).length * 2; // thumbs and main images
      var loadCount = 0;

      this.$modal.find('img[data-modal-lazy]').each(function(i, img) {
        var $el = $(img);
        var image = $el.data('modal-lazy');
        $el.attr('src', image);
        loadCount++;

        if (loadCount == imageCount) {
          this.settings.modalContentLoaded = true;
        }
      }.bind(this));

      // Load videos if they exist
      var videoTypes = this.checkIfVideos();

      // Lazyload mp4 videos similar to images
      if (videoTypes && videoTypes.indexOf('mp4') > -1) {
        this.$modal.find('.product__video[data-video-type="mp4"]').each(function(i, video) {
          var $el = $(video);
          var src = $el.data('video-src');
          var source = document.createElement('source');
          source.setAttribute('src', src);
          $el.append(source);
        }.bind(this));
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
      $('body').off(this.settings.namespace);
      this.destroyImageCarousels();
    }
  });

  return Product;
})();

theme.Collection = (function() {
  var classes = {
    tags: '.tags',
    activeTag: 'tag--active'
  };

  function Collection(container) {
    this.container = container;
    this.sectionId = $(container).attr('data-section-id');
    this.namespace = '.collection-' + this.sectionId;

    var $heroImageContainer = $(container).find('.collection-hero');
    if ($heroImageContainer.length) {
      theme.loadImageSection($heroImageContainer);
    }

    // Ajax pagination
    $(window).on('popstate', function(state) {
      if (state) {
        this.getNewCollectionContent(location.href);
      }
    }.bind(this));

    this.init();
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    init: function() {
      // init is called on load and when tags are selected
      this.$container = $(this.container);
      this.sectionId = this.$container.attr('data-section-id');

      this.sortBy();
      this.sortTags();
      this.initTagAjax();
    },

    initTagAjax: function() {
      this.$container.on('click' + this.namespace, '.tags a', function(evt) {
        evt.preventDefault();
        var $el = $(evt.currentTarget);
        var newUrl = $el.attr('href');
        $(classes.tags).find('.' + classes.activeTag).removeClass(classes.activeTag);
        $el.parent().addClass(classes.activeTag);
        history.pushState({}, '', newUrl);
        $('.grid-product').addClass('unload');
        this.getNewCollectionContent(newUrl);
      }.bind(this));
    },

    getNewCollectionContent: function(url) {
      $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function() {
        this.reInit();
      }.bind(this));
    },

    sortBy: function() {
      var $sortBy = $('#SortBy');

      if (!$sortBy.length) {
        return;
      }

      $sortBy.on('change', function() {
        location.href = '?sort_by=' + $(this).val();
      });
    },

    sortTags: function() {
      var $sortTags = $('#SortTags');

      if (!$sortTags.length) {
        return;
      }

      $sortTags.on('change', function() {
        location.href = $(this).val();
      });
    },

    reInit: function() {
      // Reload collection template (it can be anywhere in the sections.instance array)
      for (var i = 0; i < sections.instances.length; i++) {
        var instance = sections.instances[i];
        if (instance['type'] === 'collection-template') {
          instance.forceReload();
        }
      }

      // Reload quick shop buttons
      theme.initQuickShop();

      // Reload products inside each quick shop
      sections.register('product-template', theme.Product);
    },

    forceReload: function() {
      this.onUnload();
      this.init();
    },

    onUnload: function() {
      $(window).off(this.namespace);
      this.$container.off(this.namespace);
    }

  });

  return Collection;
})();

theme.HeaderSection = (function() {

  var selectors = {
    drawer: '#NavDrawer',
    mobileSubNavToggle: '.mobile-nav__toggle-btn',
    hasSublist: '.mobile-nav__has-sublist'
  };

  var classes = {
    navExpanded: 'mobile-nav--expanded'
  };

  function Header(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Reload any slideshow if when the header is reloaded to make sure the
    // sticky header works as expected (it can be anywhere in the sections.instance array)
    for (var i = 0; i < sections.instances.length; i++) {
      var instance = sections.instances[i];
      if (instance['type'] === 'slideshow-section') {
        instance.forceReload();
      }
    }

    theme.currencySwitcher.init()
    this.initDrawers();
    theme.headerNav.init();
    theme.announcementBar.init();
  }

  Header.prototype = $.extend({}, Header.prototype, {
    initDrawers: function() {
      theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
      if (theme.settings.cartType === 'drawer') {
        new theme.CartDrawer();
      }

      this.drawerMenuButtons();
    },

    drawerMenuButtons: function() {
      $(selectors.drawer).find('.js-drawer-close').on('click', function(evt){
        evt.preventDefault();
        theme.NavDrawer.close();
      });

      var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);

      $mobileSubNavToggle.attr('aria-expanded', 'false');
      $mobileSubNavToggle.each(function (i, el) {
        var $el = $(el);
        $el.attr('aria-controls', $el.attr('data-aria-controls'));
      });

      $mobileSubNavToggle.on('click', function() {
        var $el = $(this);
        var currentlyExpanded = $el.attr('aria-expanded');
        var toggleState = false;

        // Updated aria-expanded value based on state pre-click
        if (currentlyExpanded === 'true') {
          $el.attr('aria-expanded', 'false');
        } else {
          $el.attr('aria-expanded', 'true');
          toggleState = true;
        }

        // Toggle class that expands/collapses sublist
        $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
      });
    },

    onUnload: function() {
      theme.NavDrawer.close();
      theme.headerNav.unload();
    }
  });

  return Header;

})();

theme.FeaturedContentSection = (function() {

  function FeaturedContent() {
    $('.rte').find('a:not(:has(img))').addClass('text-link');
  }

  return FeaturedContent;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {

  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var $section = $container.parent();
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    var $imageContainer = $(container).find('.hero');
    if ($imageContainer.length) {
      theme.loadImageSection($imageContainer);
    }

    this.init();
  }

  SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
    init: function() {
      var args = {
        arrows: $(this.slideshow).data('arrows'),
        dots: $(this.slideshow).data('dots')
      };

      theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
    },

    forceReload: function() {
      this.onUnload();
      this.init();
    },

    onUnload: function() {
      theme.slideshows[this.slideshow].destroy();
      delete theme.slideshows[this.slideshow];
    },

    onSelect: function() {
      $(this.slideshow).slick('slickPause');
    },

    onDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    }
  });

  return SlideshowSection;
})();

theme.VideoSection = (function() {
  var youtubeReady;
  var videos = [];
  var youtubePlayers = [];
  var youtubeVideoOptions = {
    width: 1280,
    height: 720,
    playerVars: {
      autohide: 0,
      branding: 0,
      autoplay: 1,
      loop:1,
      cc_load_policy: 0,
      controls: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      quality: 'hd720',
      rel: 0,
      showinfo: 0,
      wmode: 'opaque'
    },
    events: {
      onReady: onVideoPlayerReady,
      onStateChange: onVideoStateChange
    }
  };

  var vimeoReady = false;
  var vimeoVideoOptions = {
    byline: false,
    title: false,
    portrait: false,
    loop: true,
    autopause: false
  };

  var selectors = {
    videoParent: '.video-parent-section'
  };

  var classes = {
    loading: 'loading',
    loaded: 'loaded',
    interactable: 'video-interactable'
  };

  function videoSection(container) {
    if (theme.config.isIframe) {
      return;
    }

    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
    this.namespace = '.' + youtubePlayerId;
    var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
    var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
    var mp4Video = 'Mp4Video-' + this.sectionId;

    var $youtubeDiv = $('#' + youtubePlayerId);
    var $vimeoDiv = $('#' + vimeoPlayerId);
    var $mp4Div = $('#' + mp4Video);

    this.vimeoPlayer = [];

    if ($youtubeDiv.length) {
      this.youtubeVideoId = $youtubeDiv.data('video-id');
      this.initYoutubeVideo();
    }

    if ($vimeoDiv.length) {
      this.vimeoVideoId = $vimeoDiv.data('video-id');
      this.initVimeoVideo();
      console.log('3756');
    }

    if ($mp4Div.length) {
      setParentAsLoaded($mp4Div);

      startMp4Playback(mp4Video).then(function() {
        // Video played as expected, don't do anything
      }).catch(function(error) {
        // Video cannot be played with autoplay, so let
        // user interact with video element itself
        setVideoToBeInteractedWith($mp4Div);
      })
    }
  }

  function startMp4Playback(mp4Video) {
    return document.querySelector('#' + mp4Video).play();
  }

  function onVideoPlayerReady(evt) {
    var $player = $(evt.target.a);
    var playerId = $player.attr('id');
    youtubePlayers[playerId] = evt.target; // update stored player
    var player = youtubePlayers[playerId];

    setParentAsLoading($player);

    youtubePlayers[playerId].mute();

    // Remove from tabindex because YouTube iframes are annoying and you can focus
    // on the YouTube logo and it breaks
    $player.attr('tabindex', '-1');

    // Add out of view pausing
    videoVisibilityCheck(playerId);
    $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
  }

  function videoVisibilityCheck(id) {
    var playerId;

    if (typeof id === 'string') {
      playerId = id;
    } else {
      // Data comes in as part of the scroll event
      playerId = id.data.id;
    }

    if (theme.isElementVisible($('#' + playerId))) {
      playVisibleVideo(playerId);
    } else {
      pauseHiddenVideo(playerId);
    }
  }

  function playVisibleVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
      youtubePlayers[id].playVideo();
    }
  }

  function pauseHiddenVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
      youtubePlayers[id].pauseVideo();
    }
  }

  function onVideoStateChange(evt) {
    var $player = $(evt.target.a);
    var playerId = $player.attr('id');
    var player = youtubePlayers[playerId];

    switch (evt.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (videos[playerId].attemptedToPlay) {
          setParentAsLoaded($player);
          setVideoToBeInteractedWith($player);
        }
        break;
      case 0: // ended
        player.playVideo();
        break;
      case 1: // playing
        setParentAsLoaded($player);
        break;
      case 3: // buffering
        videos[playerId].attemptedToPlay = true;
        break;
    }
  }

  function setParentAsLoading($el) {
    $el
      .closest(selectors.videoParent)
      .addClass(classes.loading);
  }

  function setParentAsLoaded($el) {
    $el
      .closest(selectors.videoParent)
      .removeClass(classes.loading)
      .addClass(classes.loaded);
  }

  function setVideoToBeInteractedWith($el) {
    $el
      .closest(selectors.videoParent)
      .addClass(classes.interactable);
  }

  videoSection.prototype = $.extend({}, videoSection.prototype, {
    initYoutubeVideo: function() {
      videos[this.youtubePlayerId] = {
        id: this.youtubePlayerId,
        videoId: this.youtubeVideoId,
        type: 'youtube',
        attemptedToPlay: false
      };

      if (!youtubeReady) {
        window.loadYouTube();
        $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
      } else {
        this.loadYoutubeVideo();
      }
    },

    loadYoutubeVideo: function() {
      var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
      args.playerVars.controls = 0;
      youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);

      youtubeReady = true;
    },

    initVimeoVideo: function() {
      console.log('3895');
      videos[this.vimeoPlayerId] = {
        divId: this.vimeoPlayerId,
        id: this.vimeoVideoId,
        type: 'vimeo'
      };

      var $player = $('#' + this.vimeoPlayerId);
      setParentAsLoading($player);

      // Button to play video on mobile
      this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
        // $(evt.currentTarget).addClass('hide');
        this.requestToPlayVimeoVideo(this.vimeoPlayerId);
      }.bind(this));

      if (!vimeoReady) {
        window.loadVimeo();
        $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
      } else {
        this.loadVimeoVideo();
      }
    },

    loadVimeoVideo: function() {
      console.log('3910');
      var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
      this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);

      vimeoReady = true;

      // Only autoplay on larger screens
      if (!theme.config.bpSmall) {
        this.requestToPlayVimeoVideo(this.vimeoPlayerId);
      } else {
        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoaded($player);
      }
    },

    requestToPlayVimeoVideo: function(id) {
      // The slider may initialize and attempt to play the video before
      // the API is even ready, because it sucks.

      console.log('3935',vimeoReady);
      if (!vimeoReady) {
        // Wait for the trigger, then play it
        $('body').on('vimeoReady' + this.namespace, function() {
          this.playVimeoVideo(id);
        }.bind(this))
        return;
      }

      this.playVimeoVideo(id);
    },

    playVimeoVideo: function(id) {
      this.vimeoPlayer[id].play();
      this.vimeoPlayer[id].setVolume(0);

      var $player = $('#' + id);
      setParentAsLoaded($player);
    },

    onUnload: function(evt) {
      var sectionId = evt.target.id.replace('shopify-section-', '');
      var playerId = 'YouTubeVideo-' + sectionId;
      youtubePlayers[playerId].destroy();
      $(window).off('scroll' + this.namespace);
      $('body').off('vimeoReady' + this.namespace);
    }
  });

  return videoSection;
})();

theme.Testimonials = (function() {
  var slideCount = 0;
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Testimonials(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.testimonials-wrapper';
    var slider = this.slider = '#Testimonials-' + sectionId;
    var $slider = $(slider);

    this.sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = slideCount;
      defaults.slidesToScroll = slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    if (theme.config.bpSmall) {
      this.init($slider, mobileOptions);
    } else {
      this.init($slider, defaults);
    }

    $('body').on('matchSmall', function() {
      this.init($slider, mobileOptions);
    }.bind(this));

    $('body').on('matchLarge', function() {
      this.init($slider, defaults);
    }.bind(this));
  }

  Testimonials.prototype = $.extend({}, Testimonials.prototype, {
    onUnload: function() {
      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    init: function(obj, args) {
      if (this.sliderActive) {
        obj.slick('unslick');
        this.sliderActive = false;
      }

      obj.slick(args);
      this.sliderActive = true;
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Testimonials;
})();

theme.Instagram = (function() {
  var defaults = {

  };

  function Instagram(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var $target = $('#Instafeed-' + sectionId);

    if (!$target.length) {
      return;
    }

    var userId = $target.data('user-id');
    var clientId = $target.data('client-id');
    var count = $target.data('count');

    var feed = this.feed = new Instafeed({
      target: $target[0],
      accessToken: clientId,
      get: 'user',
      userId: userId,
      limit: count,
      template: '<div class="grid__item small--one-half medium-up--one-fifth" data-aos="row-of-5"><div class="image-wrap"><a href="{{link}}" target="_blank" style="background-image: url({{image}}); display: block; padding-bottom: 100%; background-size: cover;"></a></div></div>',
      resolution: 'standard_resolution'
    });

    feed.run();
  }

  Instagram.prototype = $.extend({}, Instagram.prototype, {
    onUnload: function() {

    }
  });

  return Instagram;
})();


theme.NewsletterPopup = (function() {
  function NewsletterPopup(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    this.cookieName = 'newsletter-' + sectionId;

    if (!$container.length) {
      return;
    }

    this.data = {
      secondsBeforeShow: $container.data('delay-seconds'),
      daysBeforeReappear: $container.data('delay-days'),
      cookie: $.cookie(this.cookieName),
      testMode: $container.data('test-mode')
    };

    this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');

    // Open modal if errors or success message exist
    if ($container.find('.errors').length || $container.find('.note--success').length) {
      this.modal.open();
    }

    // Set cookie as opened if success message
    if ($container.find('.note--success').length) {
      this.closePopup();
      return;
    }

    $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));

    if (!this.data.cookie || this.data.testMode) {
      this.initPopupDelay();
    }
  }

  NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
    initPopupDelay: function() {
      setTimeout(function() {
        this.modal.open();
      }.bind(this), this.data.secondsBeforeShow * 1000);
    },

    closePopup: function() {
      // Remove a cookie in case it was set in test mode
      if (this.data.testMode) {
        $.removeCookie(this.cookieName, { path: '/' });
        return;
      }

      $.cookie(this.cookieName, 'opened', { expires: this.data.daysBeforeReappear });
    },

    onLoad: function() {
      this.modal.open();
    },

    onSelect: function() {
      this.modal.open();
    },

    onDeselect: function() {
      this.modal.close();
    },

    onUnload: function() {}
  });

  return NewsletterPopup;
})();

theme.FadingImages = (function() {

  var classes = {
    activeImage: 'active-image',
    finishedImage: 'finished-image',
    activeTitles: 'active-titles',
    finishedTitles: 'finished-titles',
    compensation: 'compensation'
  };

  function FadingImages(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var namespace = this.namespace = '.fading-images-' + sectionId;

    if (!$container.length) {
      return;
    }

    var $imageContainer = $container.find('.fading-images');
    theme.loadImageSection($imageContainer);

    this.data = {
      isInit: false,
      interval: $container.data('interval'),
      block_count: $container.data('count'),
      finish_interval: 1000,
      timer_offset: 400,
      active_image: 1,
      active_title: 1,
      removed_compensation: false
    };

    this.selectors = {
      $allTitles: $container.find('.fading-images-overlay__titles')
    };

    this.checkVisibility();
    $(window).on('scroll' + this.namespace, $.throttle(100, this.checkVisibility.bind(this)));
  }

  FadingImages.prototype = $.extend({}, FadingImages.prototype, {
    checkVisibility: function() {
      if (this.data.isInit) {
        $(window).off('scroll' + this.namespace);
        return;
      }

      if (theme.isElementVisible(this.$container)) {
        this.startImages();
        this.startTitles();
        this.data.isInit = true;
      }
    },

    nextImage: function() {
      var $container = this.$container;

      if (!this.data.removed_compensation) {
        $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').removeClass(classes.compensation);
        this.data.removed_compensation = true;
      }

      $container
        .find('.fading-images__item[data-slide-index=' + this.data.active_image + ']')
        .removeClass(classes.activeImage)
        .addClass(classes.finishedImage);

      var target_image = this.data.active_image;
      window.setTimeout(function() {
        $container.find('.fading-images__item[data-slide-index=' + target_image + ']').removeClass(classes.finishedImage);
      }, this.data.finish_interval);

      this.data.active_image++;
      if (this.data.active_image > this.data.block_count) {
        this.data.active_image = 1;
      }

      $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage);
    },

    nextTitle: function() {
      var $container = this.$container;
      var $allTitles = this.selectors.$allTitles;

      this.selectors.$allTitles.removeClass(classes.activeTitles).addClass(classes.finishedTitles);

      this.data.active_title++;
      if (this.data.active_title > this.data.block_count) {
        this.data.active_title = 1;
      }

      var target_title = this.data.active_title;
      window.setTimeout(function() {
        var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
        var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
        $container.find('.fading-images-overlay__title--1').text(newText1);
        $container.find('.fading-images-overlay__title--2').text(newText2);
        $allTitles.removeClass(classes.finishedTitles).addClass(classes.activeTitles);
      }, this.data.finish_interval - 200);
    },

    startImages: function() {
      // Prep and show first image
      this.$container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage).addClass(classes.compensation);

      // Begin timer
      var o = this;
      window.setTimeout(function() {
        var fading_images_timer = window.setInterval(o.nextImage.bind(o), o.data.interval);
      }, this.data.timer_offset);
    },

    startTitles: function() {
      var $container = this.$container;
      var $allTitles = this.selectors.$allTitles;
      // Prep and show first titles
      var target_title = this.data.active_title;
      window.setTimeout(function() {
        var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
        var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
        $container.find('.fading-images-overlay__title--1').text(newText1);
        $container.find('.fading-images-overlay__title--2').text(newText2);
        $allTitles.addClass(classes.activeTitles);
      }, 750);

      // Begin timer
      var fading_titles_timer = window.setInterval(this.nextTitle.bind(this), this.data.interval);
    },

    onLoad: function() {
    },

    onSelect: function() {
    },

    onDeselect: function() {
    },

    onUnload: function() {
    }
  });

  return FadingImages;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.sectionId = this.$container.attr('data-section-id');
    this.namespace = '.map-' + this.sectionId;
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (!this.key) {
      return;
    }

    // Lazyload API
    this.checkVisibility();
    $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = $.extend({}, Map.prototype, {
    prepMapApi: function() {
      if (apiStatus === 'loaded') {
        this.createMap();
      } else {
        mapsToLoad.push(this);

        if (apiStatus !== 'loading') {
          apiStatus = 'loading';
          if (typeof window.google === 'undefined') {
            $.getScript(
              'https://maps.googleapis.com/maps/api/js?key=' + this.key
            ).then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
          }
        }
      }
    },

    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              backgroundColor: 'none',
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    checkVisibility: function() {
      if (theme.isElementVisible(this.$container, 600)) {
        this.prepMapApi();
        $(window).off(this.namespace);
      }
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      // Causes a harmless JS error when a section without an active map is reloaded
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

theme.Blog = (function() {

  function Blog(container) {
    this.tagFilters();
  }

  Blog.prototype = $.extend({}, Blog.prototype, {
    tagFilters: function() {
      var $filterBy = $('#BlogTagFilter');

      if (!$filterBy.length) {
        return;
      }

      $filterBy.on('change', function() {
        location.href = $(this).val();
      });
    },

    onUnload: function() {

    }
  });

  return Blog;
})();

theme.Photoswipe = (function() {
  var selectors = {
    photoswipeImg: '.photoswipe__image'
  }

  function Photoswipe(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    this.namespace = '.photoswipe-' + this.sectionId;
    var $images = this.$images = $container.find(selectors.photoswipeImg);
    this.gallery;

    if (!$container.length) {
      return;
    }

    this.init();
  }

  Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
    init: function() {
      var haveImages = false;
      var items = [];
      var options = {};

      this.$images.each(function() {
        var haveImages = true;
        var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
        var item = {
          msrc: smallSrc,
          src: $(this).data('photoswipe-src'),
          w: $(this).data('photoswipe-width'),
          h: $(this).data('photoswipe-height'),
          el: $(this)[0]
        };

        items.push(item);
      });

      this.$images.on('click' + this.namespace, function(evt) {
        index = $(evt.currentTarget).data('index');
        this.initGallery(items, index);
      }.bind(this));
    },

    initGallery: function(items, index) {
      var pswpElement = document.querySelectorAll('.pswp')[0];

      var options = {
        history: false,
        index: index - 1,
        getThumbBoundsFn: function(index) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var thumbnail = items[index].el;
          var rect = thumbnail.getBoundingClientRect();
          return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
        }
      }

      this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      this.gallery.init();
    },

    onUnload: function() {
      this.$images.off('click' + this.namespace);
      this.gallery.destroy()
    }
  });

  return Photoswipe;
})();



theme.inIframe = function() {
  try {
    return parent.document.location.hostname !== document.location.hostname;
  } catch (e) {
    return true;
  }
}

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  mediaQuerySmall: 'screen and (max-width: 589px)',
  mediaQueryMediumUp: 'screen and (min-width: 590px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: false,
  isIframe: theme.inIframe()
};

function onYouTubeIframeAPIReady() {
  theme.config.youTubeReady = true;
  $('body').trigger('youTubeReady');
}

function loadYouTube() {
  if (theme.config.youtubeReady) {
    return;
  }

  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function loadVimeo() {
  console.log(theme.config);
  if (theme.config.vimeoLoading) {
    return;
  }

  if (!theme.config.vimeoReady) {
    theme.config.vimeoLoading = true;
    var tag = document.createElement('script');
    tag.src = "https://player.vimeo.com/api/player.js";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function() {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        $('body').trigger('vimeoReady');
      })
      .fail(function() {
        // No vimeo API to talk to
      });
  }
}

function checkIfVimeoIsReady() {
  var deferred = $.Deferred();
  var wait;
  var timeout;

  wait = setInterval(function() {
    if (typeof Vimeo == 'undefined') {
      return;      
    }
    if(!Vimeo){
      return;  
    }

    clearInterval(wait);
    clearTimeout(timeout);
    deferred.resolve();
  }, 500);

  timeout = setTimeout(function() {
    clearInterval(wait);
    deferred.reject();
  }, 8000); // subjective. test up to 8 times over 4 seconds

  return deferred;
}

theme.init = function() {
  theme.setGlobals();
  theme.pageTransitions();
  theme.initQuickShop();
  theme.videoModal();
  theme.articleImages.init();
  theme.backButton.init();
  theme.customerTemplates.init();
  theme.collapsibles.init();

  slate.rte.wrapTable();

  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60
  });
};

theme.setGlobals = function() {
  theme.config.hasSessionStorage = theme.isSessionStorageSupported() || theme.config.isIframe;

  window.addEventListener('touchstart', function onFirstTouch() {
    theme.config.isTouch = true;
    window.removeEventListener('touchstart', onFirstTouch, false);
    $('body').addClass('supports-touch');
  });

  enquire.register(theme.config.mediaQuerySmall, {
    match: function() {
      theme.config.bpSmall = true;
      $('body').trigger('matchSmall');
    },
    unmatch: function() {
      theme.config.bpSmall = false;
      $('body').trigger('unmatchSmall');
    }
  });

  enquire.register(theme.config.mediaQueryMediumUp, {
    match: function() {
      $('body').trigger('matchLarge');
    },
    unmatch: function() {
      $('body').trigger('unmatchLarge');
    }
  });
};

theme.loadImageSection = function($container) {
  // Wait until images inside container have lazyloaded class
  function setAsLoaded() {
    $container.removeClass('loading loading--delayed').addClass('loaded');
  }

  function checkForLazyloadedImage() {
    return $container.find('.lazyloaded').length;
  }

  // If it has SVGs it's in the onboarding state so set as loaded
  if ($container.find('svg').length) {
    setAsLoaded();
    return;
  };

  if (checkForLazyloadedImage() > 0) {
    setAsLoaded();
    return;
  }

  var interval = setInterval(function() {
    if (checkForLazyloadedImage() > 0) {
      clearInterval(interval);
      setAsLoaded();
    }
  }, 80);
}

theme.isSessionStorageSupported = function() {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  var testKey = 'test';
  var storage = window.sessionStorage;
  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

theme.isElementVisible = function($el, threshold) {
  var rect = $el[0].getBoundingClientRect();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  threshold = threshold ? threshold : 0;

  return (
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (windowHeight + threshold) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

theme.pageTransitions = function() {
  if ($('body').data('transitions') == true) {

    // Hack test to fix Safari page cache issue.
    // window.onpageshow doesn't always run when navigating
    // back to the page, so the unloading class remains, leaving
    // a white page. Setting a timeout to remove that class when leaving
    // the page actually finishes running when they come back.
    if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
      $('a').on('click', function() {
        window.setTimeout(function() {
          $('body').removeClass('unloading');
        }, 1200);
      });
    }

    // Add disable transition class to malito, anchor, and YouTube links
    $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function() {
      $(this).addClass('js-no-transition');
    });

    $('a:not(.js-no-transition)').bind('click', function(evt) {
      if (evt.metaKey) return true;
      evt.preventDefault();
      $('body').addClass('unloading');
      var src = $(this).attr('href');
      window.setTimeout(function() {
        location.href = src;
      }, 50);
    });

    $('.mobile-nav__link').bind('click', function() {
      theme.NavDrawer.close();
    });
  }
};

window.onpageshow = function(evt) {
  // Removes unload class when returning to page via history
  if (evt.persisted) {
    $('body').removeClass('unloading');
  }
};

$(document).ready(function() {
  theme.init();

  window.sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('video-section', theme.VideoSection);
  sections.register('product', theme.Product);
  sections.register('product-template', theme.Product);
  sections.register('collection-template', theme.Collection);
  sections.register('featured-content-section', theme.FeaturedContentSection);
  sections.register('testimonials', theme.Testimonials);
  sections.register('instagram', theme.Instagram);
	var page_url = window.location.href;
  var delay_days = $('.newslatter-modal-popup').data('delay-days');
  if($.cookie('pagecount')){
  var count = JSON.parse($.cookie('pagecount'));
  if(count.length == 1){
    if(count.indexOf(page_url) === -1 ){
      count.push(page_url);
      $.cookie('pagecount',JSON.stringify(count),{ expires: delay_days ,path:'/' });   
    }
  } else if(count.length == 2 ){
      if(count.indexOf(page_url) === -1 ){
        
        console.log($.cookie('newsletter-newsletter-popup'));
        
        if($.cookie('newsletter-newsletter-popup') == 'opened') {
          console.log('already opened once');
        } else {
          sections.register('newsletter-popup', theme.NewsletterPopup);
        }      
      }
    }  
  }
  else{
  var value_array = [page_url];
    $.cookie('pagecount',JSON.stringify(value_array),{ expires: delay_days,path:'/' });
  }
 
  sections.register('fading-images', theme.FadingImages);
  sections.register('map', theme.Maps);
  sections.register('blog', theme.Blog);
  sections.register('photoswipe', theme.Photoswipe);
  $('.product__slider-main').on('afterChange', function(event, slick, currentSlide, nextSlide){
    if($(".slick-active").hasClass('loading')) {
      $(".slick-active").removeClass('loading');
      $(".slick-active").addClass('loaded');
    }
  });
});


/* Custom.js */
jQuery(document).ready(function(){
  if(jQuery(".collection_filtersidebar").length)
  {
    jQuery(".collection_filtersidebar")
    jQuery(".collection_filtersidebar").each(function(){
      if(jQuery(".collection_filtersidebar").find('.sidebar_filter li').length)
      {
        jQuery(".collection_filtersidebar").find('.sidebar_filter li').each(function(){
          if(jQuery(this).find('.submenu_filter').length)
          {

          }
          else
          {
            jQuery(this).find('.sidebar_top').removeClass('sidebar_top');
          }
        });
      }
    });
  }
});
jQuery(document).ready(function() {
  jQuery(".showMoreProductDescription > a").on('click', function(e){
    e.preventDefault();
    jQuery(this).parent().prev(".productDescription").slideDown();
    jQuery(this).hide();
  });
  if(jQuery(".cartPage").length)
  {
    if(jQuery(".productDescription").length)
    {
      jQuery(".productDescription").each(function(){
        var currentValue = jQuery.trim(jQuery(this).text());
        currentValue = currentValue.replace(/\s/g, ''); 
        if(typeof currentValue != "undefined" && currentValue != "" && currentValue != null)
        {

        }
        else
        {
          jQuery(this).next(".showMoreProductDescription").find("a").hide();
        }
      });
    }
    jQuery(".plusButton").on('click', function(e) {
      e.preventDefault();
      var productQuantity = jQuery(this).next(".cart__product-qty").val();
      productQuantity = parseInt(productQuantity) + 1;
      jQuery(this).next(".cart__product-qty").val(productQuantity);
      jQuery(this).next(".cart__product-qty").attr('value', productQuantity);
      var increseValueVaraintId = jQuery.trim(jQuery(this).next(".cart__product-qty").attr("data-variant-id"));
      jQuery(".formInputElement").each(function(){
        var variantId = jQuery.trim(jQuery(this).attr("data-variant-id"));
        if(variantId == increseValueVaraintId)
        {
          jQuery(this).val(productQuantity);
          jQuery(this).attr('value', productQuantity);
        }
      });
    });
    jQuery(".minusButton").on('click', function(e) {
      e.preventDefault();
      var productQuantity = jQuery(this).prev(".cart__product-qty").val();
      productQuantity = parseInt(productQuantity) - 1;
      var increseValueVaraintId = jQuery.trim(jQuery(this).prev(".cart__product-qty").attr("data-variant-id"));
      if(productQuantity > 0)
      {
        jQuery(this).prev(".cart__product-qty").val(productQuantity);
        jQuery(this).prev(".cart__product-qty").attr('value', productQuantity);
        jQuery(".formInputElement").each(function() {
          var variantId = jQuery.trim(jQuery(this).attr("data-variant-id"));
          if(variantId == increseValueVaraintId)
          {
            jQuery(this).val(productQuantity);
            jQuery(this).attr('value', productQuantity);
          }
        });
      }
    });
    if(jQuery("select.select-item").length)
    {
      jQuery("select.select-item").each(function(){
        if(jQuery(this).hasClass('disabled'))
        {
          $(this).prop('disabled', true);
          $(this).attr('disabled', 'disabled');
        }
      });
    }
  }
  jQuery('.OtherMethodInput').on('ifChecked', function() {
    jQuery(this).parent().parent().next('.hideElementWrap').slideDown();
  });
  jQuery('.OtherMethodInput').on('ifUnchecked', function() {
    jQuery(this).parent().parent().next('.hideElementWrap').slideUp();
    jQuery(this).parent().parent().next('.hideElementWrap input').val("");
  });
  jQuery('.formSingleInputElement input[name=InternationalFormSpeakEnglish]').on('ifClicked', function() {
    var currentValue = jQuery(this).val();
    if(currentValue == "Yes")
    {
      jQuery(".InternationalFormOtherLanguage").slideUp();
      jQuery(".InternationalFormOtherLanguage input").val("");
    }
    else if(currentValue == "No")
    {
      jQuery(".InternationalFormOtherLanguage").slideDown();
    }
  });
  jQuery('.formSingleInputElement input[name=InternationalFormPreferredContact]').on('ifChecked', function() {
    jQuery(this).parent().parent().next('.hideElementWrap').slideDown();
  });
  jQuery('.formSingleInputElement input[name=InternationalFormPreferredContact]').on('ifUnchecked', function() {
    jQuery(this).parent().parent().next('.hideElementWrap').slideUp();
    jQuery(this).parent().parent().next('.hideElementWrap input').val("");
  });
  if(jQuery(".formSingleInputElement input[type=radio]"))
  {
    jQuery('.formSingleInputElement input[type=radio]').iCheck({
      radioClass: 'iradio_square'
    });
  }
  if(jQuery(".formSingleInputElement input[type=checkbox]"))
  {
    jQuery('.formSingleInputElement input[type=checkbox]').iCheck({
      checkboxClass: 'icheckbox_square'
    });
  }
  if(jQuery("#internationalOrderForm").length)
  {
    jQuery("#internationalOrderForm").validate({
      rules: {
        "InternationalFormShipping": "required",
        "InternationalFormCountry": "required",
        "InternationalFormName": "required",
        "InternationalFormAddress1": "required",
        "InternationalFormSpeakEnglish": "required",
        "InternationalFormOtherLanguage": "required",
        "InternationalFormPreferredContact": "required",
        "InternationalFormEmail": {
          required: true,
          email: true
        },
        "InternationalFormSkypeName": "required",
        "InternationalFormWhatsapp": "required",
        "InternationalFormPreferredPayment[]": "required",
        "InternationalFormOtherPaymentMethod": "required"
      },
      messages: {
        'InternationalFormShipping': "Shipping is required.",
        'InternationalFormCountry': "Country is required.",
        'InternationalFormName': "Name is required.",
        'InternationalFormAddress1': "Address Line 1 is required.",
        'InternationalFormSpeakEnglish': "Communication is required.",
        'InternationalFormOtherLanguage': "Other Language is required.",
        'InternationalFormPreferredContact': "Preferred Contact is required.",
        'InternationalFormEmail': {
          required: "Contact Email is required.",
          email: "Enter valid email address."
        },
        'InternationalFormSkypeName': "Skype Name is required.",
        'InternationalFormWhatsapp': "Contact Info is required.",
        'InternationalFormPreferredPayment[]': "Payment Method is required.",
        'InternationalFormOtherPaymentMethod': "Other Payment Method is required."
      }
    });
    jQuery(".internationalCheckoutSubmitBtn").on("click", function(e){
      e.preventDefault();
      $captcha = $('#internationalCaptcha');
      response = grecaptcha.getResponse(html_internationalCaptcha);
      if (!$captcha.hasClass("error")) {
        $captcha.addClass("error");
      } else {
        jQuery('#internationalOrderForm .msg-error').text('');
        $captcha.removeClass("error");
      }
      if (response.length === 0) {
        jQuery('#internationalOrderForm .msg-error').text("Please check the captcha form.");
        jQuery('#internationalOrderForm .msg-error').show();
      } else {
        jQuery('#internationalOrderForm .msg-error').hide();
      }
      if(jQuery("#internationalOrderForm").valid())
      {
        if (response.length === 0) {
          jQuery('#internationalOrderForm .msg-error').text("Please check the captcha form.");
          jQuery('#internationalOrderForm .msg-error').show();
          return;
        }
        jQuery('body').append("<div class='customFormLoader'></div>");
        jQuery(document).find('.customFormLoader').show();
        $.getJSON("/cart.js", function( getData ) {
          if(jQuery(getData).length)
          {
            var formData = new FormData(jQuery('#internationalOrderForm')[0]);
            jQuery.each($("#internationalOrderForm").serializeArray(), function(i, item) {
              formData.append(item.name, item.value);
            });
            var obj = JSON.stringify(getData);
            formData.append('cart', obj);
            jQuery.ajax({
              url: "https://shopify.tadpoleadaptive.com/productapp/app/add_international_checkout",
              type: "POST",
              contentType: false,
              cache: false,
              processData:false,
              data: formData,
              success: function(result) {
                var data = JSON.parse(result);
                if(data.success == 'true')
                {
                  grecaptcha.reset(html_internationalCaptcha);
                  jQuery("#internationalOrderForm")[0].reset();
                  jQuery("#internationalOrderForm .hideElementWrap").removeAttr('style');
                  if(jQuery("#internationalOrderForm .formSingleInputElement input[type=radio]"))
                  {
                    jQuery('#internationalOrderForm .formSingleInputElement input[type=radio]').iCheck({
                      radioClass: 'iradio_square'
                    });
                  }
                  if(jQuery("#internationalOrderForm .formSingleInputElement input[type=checkbox]"))
                  {
                    jQuery('#internationalOrderForm .formSingleInputElement input[type=checkbox]').iCheck({
                      checkboxClass: 'icheckbox_square'
                    });
                  }
                }
                jQuery(document).find('.customFormLoader').remove();
                swal({
                  type: (data.success == 'true' ? 'success' : 'error'),
                  html: data.message
                });
              }
            });
          }
        });
      }
    });
  }
  if($('.cartPurchaseOrderFormBtn').length > 0) {
    $("#cartQuoteForm").validate({
      rules: {
        'name': "required",
        'street': "required",
        'city': "required",
        'state': "required",
        'zipcode': "required",
        'phoneNumber': "required",
        'userMobile': { 
           required: '#canWeText1[value="1"]:checked'
         }
      },
      messages: {
        'name': "Name is required.",
        'street': "Street address is required.",
        'city': "City is required.",
        'state': "State is required.",
        'zipcode': "Zip code/postal code is required.",
        'phoneNumber': "Phone number is required.",
        'userMobile': {
            required: "Mobile Number is required."
         }
      }
    });  
    $('.submitCartQuote').unbind('click');
    $('.submitCartQuote').on("click", function(e) {
      e.preventDefault();

      $captcha = $('#dvCaptcha_quote');
      response = grecaptcha.getResponse(html_element_quote);

      if (!$captcha.hasClass("error")) {
        $captcha.addClass("error");
      } else {
        $('.msg-error').text('');
        $captcha.removeClass("error");
      }
      if (response.length === 0) {
        $('.msg-error').show();
        $('.msg-error').text("Please check the captcha form.");
      } else {
        $('.msg-error').hide();
      }

      if($("#cartQuoteForm").valid()) {
        if (response.length === 0) {
          $('.msg-error').show();
          $('.msg-error').text("Please check the captcha form.");
          return;
        }
        jQuery('body').append("<div class='customFormLoader'></div>");
        jQuery(document).find('.customFormLoader').show();
        $.getJSON("/cart.js", function( getData ) {
          if(jQuery(getData).length)
          {
            var formData = new FormData(jQuery('#cartQuoteForm')[0]);
            jQuery.each($("#cartQuoteForm").serializeArray(), function(i, item) {
              formData.append(item.name, item.value);
            });
            var obj = JSON.stringify(getData);
            formData.append('cart', obj);
            jQuery.ajax({
              url: "https://shopify.tadpoleadaptive.com/productapp/app/add_cart_quote",
              type: "POST",
              contentType: false,
              cache: false,
              processData:false,
              data: formData,
              success: function(result) {
                var data = JSON.parse(result);
                if(data.success == 'true')
                {
                  grecaptcha.reset(html_element_quote);
                  jQuery("#cartQuoteForm")[0].reset();
                }
                jQuery(document).find('.customFormLoader').remove();
                swal({
                  type: (data.success == 'true' ? 'success' : 'error'),
                  html: data.message
                });
              }
            });
          }
        });
      }
    });
  }
  if($('.cartPurchaseOrderFormBtn').length > 0) {
    $("#cartPurchaseOrder").validate({
      rules: {
        'billStreet': "required",
        'billCity': "required",
        'billState': "required",
        'billZipcode': "required",
        'shipStreet': "required",
        'shipCity': "required",
        'shipState': "required",
        'shipZipcode': "required",
        'name': "required",
        'email': {
          required: true,
          email: true
        },
      },
      messages: {
        'billStreet': "Billing Street address is required.",
        'billCity': "Billing City is required.",
        'billState': "Billing State is required.",
        'billZipcode': "Billing Zip code/postal code is required.",
        'shipStreet': "Shipping Street address is required.",
        'shipCity': "Shipping City is required.",
        'shipState': "Shipping State is required.",
        'shipZipcode': "Shipping Zip code/postal code is required.",
        'name': "Contact Name is required.",
        'email': {
          required: "E-Mail Address is required.",
          email: "Enter valid E-Mail Address."
        },
      }
    });  
    $('.cartPurchaseOrderFormBtn').unbind('click');
    $('.cartPurchaseOrderFormBtn').on("click", function(e) {
      e.preventDefault();

      $captcha = $('#dvCaptcha_po');
      response = grecaptcha.getResponse(html_purchaseOrder);

      if (!$captcha.hasClass("error")) {
        $captcha.addClass("error");
      } else {
        $('.msg-error').text('');
        $captcha.removeClass("error");
      }
      if (response.length === 0) {
        $('.msg-error').show();
        $('.msg-error').text("Please check the captcha form.");
      } else {
        $('.msg-error').hide();
      }

      if($("#cartPurchaseOrder").valid()) {
        if (response.length === 0) {
          $('.msg-error').show();
          $('.msg-error').text("Please check the captcha form.");
          return;
        }
        jQuery('body').append("<div class='customFormLoader'></div>");
        jQuery(document).find('.customFormLoader').show();
        $.getJSON("/cart.js", function( getData ) {
          if(jQuery(getData).length)
          {
            var formData = new FormData(jQuery('#cartPurchaseOrder')[0]);
            jQuery.each($("#cartPurchaseOrder").serializeArray(), function(i, item) {
              // formData.append(item.name, item.value);
            });
            var obj = JSON.stringify(getData);
            formData.append('cart', obj);
            jQuery.ajax({
              url: "https://shopify.tadpoleadaptive.com/productapp/app/add_cart_purchase_order",
              type: "POST",
              contentType: false,
              cache: false,
              processData:false,
              data: formData,
              success: function(result) {
                var data = JSON.parse(result);
                if(data.success == 'true')
                {
                  grecaptcha.reset(html_purchaseOrder);
                  jQuery("#cartPurchaseOrder")[0].reset();
                }
                jQuery(document).find('.customFormLoader').remove();
                swal({
                  type: (data.success == 'true' ? 'success' : 'error'),
                  html: data.message
                });
              }
            });
          }
        });
      }
    });
  }

  if($('.cartContactFormSubmitBtn').length > 0) {
    $("#cartContactForm").validate({
      rules: {
        'name': "required",
        'email': {
          required: true,
          email: true
        },
      },
      messages: {
        'name': "Contact Name is required.",
        'email': {
          required: "E-Mail Address is required.",
          email: "Enter valid E-Mail Address."
        },
      }
    });  
    $('.cartContactFormSubmitBtn').unbind('click');
    $('.cartContactFormSubmitBtn').on("click", function(e) {
      e.preventDefault();

      $captcha = $('#dvCaptcha_contact');
      response = grecaptcha.getResponse(html_contact_form);

      if (!$captcha.hasClass("error")) {
        $captcha.addClass("error");
      } else {
        $('.msg-error').text('');
        $captcha.removeClass("error");
      }
      if (response.length === 0) {
        $('.msg-error').show();
        $('.msg-error').text("Please check the captcha form.");
      } else {
        $('.msg-error').hide();
      }

      if($("#cartContactForm").valid()) {
        if (response.length === 0) {
          $('.msg-error').show();
          $('.msg-error').text("Please check the captcha form.");
          return;
        }
        jQuery('body').append("<div class='customFormLoader'></div>");
        jQuery(document).find('.customFormLoader').show();
        $.getJSON("/cart.js", function( getData ) {
          if(jQuery(getData).length)
          {
            var formData = new FormData(jQuery('#cartContactForm')[0]);
            jQuery.each($("#cartContactForm").serializeArray(), function(i, item) {
              formData.append(item.name, item.value);
            });
            var obj = JSON.stringify(getData);
            formData.append('cart', obj);
            jQuery.ajax({
              url: "https://shopify.tadpoleadaptive.com/productapp/app/add_cart_contact_details",
              type: "POST",
              contentType: false,
              cache: false,
              processData:false,
              data: formData,
              success: function(result) {
                var data = JSON.parse(result);
                if(data.success == 'true')
                {
                  grecaptcha.reset(html_contact_form);
                  jQuery("#cartContactForm")[0].reset();
                }
                jQuery(document).find('.customFormLoader').remove();
                swal({
                  type: (data.success == 'true' ? 'success' : 'error'),
                  html: data.message
                });
              }
            });
          }
        });
      }
    });
  }
});
jQuery(window).on('load', function() {
  jQuery(document).find(".customLoader").remove();
  if(jQuery(".wishlistpage").length)
  {
    jQuery(".wishlistpage").prepend('<div class="pageTopCallout"><div class="page-width"><h2>My<span> Wishlist <img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/desktopWishlistIcon.png?v=125133944238369236051757629306"></span></h2></div></div><div class="pageTopBanner" data-aos="zoom-in" data-aos-duration="1000" data-aos-once="false"><div class="pageTopSubBannerWrap" style="background-image: url(//tadpoleadaptive.com/cdn/shop/files/wishlistBannerImage_25c9a16d-9e19-4ec5-a753-fb70cedd931a_2000x.jpg?v=1787110775);background-size:cover;background-position:center;position:absolute;left:0;right:0;top:0;bottom:0;"><div class="page-width"><h3>My Wishlist</h3></div></div></div>');
    AOS.init();
  }
});


$.fn.adjust_video_sizes = function() {
  var current_width = $(this).width();
  var new_height = ( current_width * 720 ) / 1280;
  $(this).css('height',new_height+'px');
};


$(document).ready(function(e){
  $("[data-video-type]").adjust_video_sizes();
  $(window).resize(function(e){
    $("#product__slider [data-video-type]").adjust_video_sizes();
  });
});

/* richtext-editor.js.liquid */
var richTextEditor = {
  bindEvents: function() {
    this.bindDesignModeToggle();
    this.bindToolbarButtons();
  },

  bindDesignModeToggle: function() {
    $('#page').on('click', function(e) {
      document.designMode = 'on';
    });

    $(document.body).on('click', function(e) {
      var $target = $(e.target);

      if ($target.is('body')) {
        document.designMode = 'off';
      }
    });
  },

  bindToolbarButtons: function() {
    $('#toolbar').on('mousedown', '.icon', function(e) {
      e.preventDefault();
      var btnId = $(e.target).attr('id');
      this.editStyle(btnId);
    }.bind(this));
  },

  editStyle: function(btnId) {
    var value = null;

    if (btnId === 'createLink') {
      if (this.isSelection()) value = prompt('Enter a link:');
    }

    document.execCommand(btnId, true, value);
  },

  isSelection: function() {
    var selection = window.getSelection();
    return selection.anchorOffset !== selection.focusOffset
  },

  init: function() {
    this.bindEvents();
  },
}

richTextEditor.init();


/* home.js */
var waitForEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 100);
  }
};

// $(window).resize(function(){
//   if($('.purchase_ordercontent').length > 0 && $(window).width() > 768){
//     var height = $('.fetured_ordercontent_section').outerHeight();$('.featured_imagewrapper').height(height);
//   }
// });

$(document).ready(function(){
  $('.productsorting_rightwrap .product_list a').on('click' , function(e){
    e.preventDefault();
    
    
    
    var href = $(this).attr('href');
    
    $('.productsorting_rightwrap .product_list').removeClass('active');
    $(this).parent('li').addClass('active');
    $('.collection_productlist_wrapper').removeClass('active');
    $('.collection_productlist_wrapper').fadeOut(200);
    $(href).addClass('active');
    
    $(href).fadeIn(300);
    $(href).find('.product_collectionslider').removeClass('ready_section');
    $(href).find('.product_collectionslider').each(function(){
      setTimeout(function(){
      $(href).find('.product_collectionslider').addClass('ready_section');
      },200);
    })


    // $('.product_collectionslider').each(function(key, item) {

    //   var sliderIdName = 'slider' + key;

    //   this.id = sliderIdName;

    //   var sliderId = '#' + sliderIdName;

    //   $(sliderId).slick('unslick');

    //   $(sliderId).slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     dots:true,
    //     fade: true
    //   });
    // });
    
    if($(window).width() > 768){
      $('.match_productheight').matchHeight();
    }
    
  });

  if($('.wishlistpage ').length > 0){
    $('.section_forwishlist').addClass('show');
  }

  if ( $('.product__slider-main').length ) {
    var $slider = $('.product__slider-main')
    .on('init', function(slick) {
      //$('.product__slider-main').fadeIn(1000);
      $('.product__slider-main').css('opacity','1');
      $('.images-may-contain').insertAfter('.product__slider-main .slick-dots');
    })
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      dots:true,
      infinite: false,
      autoplaySpeed: 3000,
      asNavFor: '.product__slider-thmb',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            infinite: false,
            arrows: false
          }
        }
      ]
    });

    var $slider2 = $('.product__slider-thmb')
    .on('init', function(slick) {
      //$('.product__slider-thmb').fadeIn(1000);
    })
    .slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product__slider-main',
      dots: false,
      infinite: false,
      arrows: false,
      verticalSwiping: true,
      vertical: true,
      centerMode: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            vertical: false,
            slidesToShow: 4,
            infinite: false,
            verticalSwiping: false
          }
        }
      ]
    });

    //remove active class from all thumbnail slides
    $('.product__slider-thmb .slick-slide').removeClass('slick-active');

    //set active class to first thumbnail slides
    $('.product__slider-thmb .slick-slide').eq(0).addClass('slick-active');

    // On before slide change match active thumbnail to current slide
    $('.product__slider-main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      $('.product__slider-thmb .slick-slide').removeClass('slick-active');
      $('.product__slider-thmb .slick-slide').eq(mySlideNumber).addClass('slick-active');
    });

    var options = {
      progressbarSelector    : '.bJS_progressbar'
      , slideSelector        : '.bJS_slider'
      , previewSlideSelector : '.bJS_previewSlider'
      , progressInterval     : ''
      // add your own progressbar animation function to sync it i.e. with a video
      // function will be called if the current preview slider item (".b_previewItem") has the data-customprogressbar="true" property set
      , onCustomProgressbar : function($slide, $progressbar) {}
    }

    // slick slider options
    // see: https://kenwheeler.github.io/slick/
    var sliderOptions = {
      slidesToShow   : 1,
      slidesToScroll : 1,
      arrows         : false,
      fade           : true,
      autoplay       : true
    }

    // slick slider options
    // see: https://kenwheeler.github.io/slick/
    var previewSliderOptions = {
      slidesToShow   : 4,
      slidesToScroll : 1,
      dots           : false,
      verticalSwiping: true,
      vertical: true,
      focusOnSelect  : true,
      centerMode     : true
    }
    }

  $('.logo_blockwrapper').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    infinite: true,
    arrows:false,
    dots:true,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 340,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  if($('.share_icon').length > 0){
    $('.share_icon').on('click' , function(e){
      e.preventDefault();
      var href = $(this).attr('href');
      $(href).slideToggle(500);
    });
  }


  // if($('.purchase_ordercontent').length > 0 && $(window).width() > 768){
  //   var height = $('.fetured_ordercontent_section').outerHeight();
  //   $('.featured_imagewrapper').height(height);
  // }


  if($('.purchase_orderwrapper').length > 0){
    $('.purchase_orderwrapper > .feature-row__item').matchHeight();
  }

  if($('.support_block').length > 0){
    $('.support_block').matchHeight();
  }

  if($('.product_info_block').length > 0){
    $('.product_info_block').matchHeight();
  }

  if($('.shipping_blocks').length > 0){
    $('.shipping_blocks').matchHeight();
  }

  if($('.product_tabswrapper').length > 0){
    $(document).on('click touchend', '.product_tabswrapper li a', function (e) {
      e.preventDefault();
      var href = $(this).attr('href');
      $('.product_tabswrapper li').removeClass('active');
      $(this).parent('li').addClass('active');
      $('.product_tabscontent_wrapper').fadeOut();
      $(href).fadeIn();
    });
  }

  if($('.product_singleinfo_block').length > 0){
    $('.accessory_btnwrapper .customize_btn').on('click' , function(e){
    	e.preventDefault();
      	$('.accessory_quote').trigger('click');
    });
    
    $('.blocks_productbtn .customize_btn').on('click' , function(e){
      e.preventDefault();
      
      var drawer = 0;
      $('#AddToCartForm-product-template .mw-options-container').each(function(){
        drawer = drawer + 1;
      });
      if(drawer == 0){
        $('#AddToCartForm-product-template #AddToCart-product-template').trigger('click');
      }else{
        $(this).toggleClass('active');
        enableButton();
      	$('body').addClass('js-drawer-open');
        $('#drawer').addClass('drawer--is-open');
        $('.product-single__form').removeClass('product_singleinfo_block');	
      }
    });
    $('.customize_sectionwrapper .drawer__close-button').on('click' , function(e){
      e.preventDefault();
      $(this).removeClass('active');

      $('body').removeClass('js-drawer-open');
      $('body').addClass('js-drawer-closing');
      $('.product-single__form').addClass('product_singleinfo_block');
      $('#drawer').removeClass('drawer--is-open');

      setTimeout(function(){
        $('body').removeClass('js-drawer-closing');
      },1000);

    });
  }
/**
  $('.product_tagswrapper').readmore({
    collapsedHeight: 65,
    moreLink: '<div><a href="#" class="read_taglink">View All Tags + <div></a> </div>' ,
    lessLink: '<div><a href="#" class="read_taglink">Hide Tags -</a> </div>'
  });


  $(document).ready(function () {
  var tagWrapper = $('.product_tagswrapper');
  var tagCount = tagWrapper.find('li').length; // Count the tags inside

  if (tagCount > 5) { // Only apply readmore if there are more than 5 tags
    tagWrapper.readmore({
      collapsedHeight: 65,
      moreLink: '<div><a href="#" class="read_taglink">View All Tags +</a></div>',
      lessLink: '<div><a href="#" class="read_taglink">Hide Tags -</a></div>'
    });
  }
});
**/
  $('.collection_info_title').on('click' , function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).parents('.skrim_contentwrapper').find('.collection_submenu_dropdown').slideToggle(1000);
  });


  $('.logo-bar__item').matchHeight();
});

function enableButton(){
  var counter = 0;
  var valid = 0;
  $('#product_drawerform .mw-validate-required-option').each(function(){
    if($(this).is(":visible")){
      valid = valid+1;
      if($(this).hasClass('valid')){

      } else {
        counter = counter+1;
      }   
    } else {
    }
  });


  if(counter > 0){
    $('.customize_sectionwrapper').removeClass('valid_form');
  } else if(valid == 0){
  	$('.customize_sectionwrapper').addClass('valid_form');
  } 
  else {
    $('.customize_sectionwrapper').addClass('valid_form');
  }
}

$(window).on('load' , function(){
  $('.product_tabswrapper li').eq(0).find('a').trigger('click');
  setTimeout(function(){
    <!-- Dhara 21/5/19 -->
     
    <!-- Dhara 21/5/19 end-->
  },500);

  
  // if($('.featured_imagewrapper .image-wrap').length > 0){
  //   $('.featured_imagewrapper .image-wrap').each(function () {
  //     var img = $('.featured_imagewrapper .image-wrap > img');
  //     var image_url = img.prop('currentSrc') || img.prop('src');

  //     if (image_url && $(window).width() > 768) {
  //       $(this).backstretch(image_url);
  //       $(this).find('img').css('display', 'none');
  //     }
  //   });
  // }

  if($('.support_zoomimage').length > 0){
    $('.support_zoomimage').each(function () {
      var img = $('.support_zoomimage > img');
      var image_url = img.prop('currentSrc') || img.prop('src');
      

      if (image_url) {
        $(this).backstretch(image_url);
        $(this).find('img').css('display', 'none');
      }
    });
  }

  $('.product__slider-main .slide').zoom({
    "on":"click"
  });

  if($(window).width() < 769){
    $('.product__slider-thmb .slide.slick-slide').matchHeight();
  }

  setTimeout(function(){
    if($('.collection_sectionblocks').length > 0){
      $('.collection_sectionblocks').matchHeight();
    }

  },500);

  setTimeout(function(){
    $('.wishlistpage #bookmarks .product').matchHeight();
  },1000);

  function checkFunction(){
    $('.mw-option').each(function(){    
      if($(this).find('.mw_options_list li .iradio_square').hasClass('checked')){
        $(this).addClass('active');
        $(this).find('.icheckbox_square').first().addClass('checked');
      }
    });
  }
  function checkSwatch(){
    $('.mw-option-swatch').each(function(){    
      if($(this).find('.swatch-option .swatch-value-container').hasClass('swatch-selected')){
        $(this).addClass('active');
        $(this).find('.icheckbox_square').first().addClass('checked');
      }
    });
  }
  function checkButton(){
    $('.customize_sectionwrapper .mw-option').each(function(){
      if($(this).find('.button-option .button-value-container').length > 0){
        var button_element = $(this).find('.button-option .button-value-container');
        if(button_element.hasClass('active')){
          $(this).addClass('active');
          $(this).addClass('valid');
          $(this).find('.icheckbox_square').first().iCheck('check');
          $(this).find('.icheckbox_square').first().trigger('change');
        } else {          
          $(this).removeClass('active');
          $(this).removeClass('valid');
          $(this).find('.icheckbox_square').first().iCheck('uncheck');
          $(this).find('.icheckbox_square').first().trigger('change');
        } 
      }
    });
  }
  function check(){
    $('.mw-option').each(function(){    
      if($(this).find('.mw_options_list li').find('.icheckbox_square').hasClass('checked')){
        $(this).addClass('active');
        $(this).find('.icheckbox_square').first().iCheck('check');
        $(this).find('.icheckbox_square').first().trigger('change');
      }else{
        $(this).removeClass('active');
        $(this).find('.icheckbox_square').first().iCheck('uncheck');
        $(this).find('.icheckbox_square').first().trigger('change');
      }
    });
  }



  function checkError(){
    $('.product-single__form .mw-option').each(function(i){
      if($(this).has('.validation-error').length>0){
        var count = i+1;
        $('.customize_sectionwrapper .mw-option').each(function(index){
          var index = index+1;
          if(index == count){
            $(this).find('.mw_optiondesc').append('<span class="validation-error">This option is required.</span>');
            $(this).find('.first_check').addClass('error');
            if($(this).hasClass('section_active')){
            }else{
              $(this).find('.mw_product_option_label').trigger('click');
            }
          } else {
            $(this).find('.first_check').removeClass('error');
          }
        });
      }
    });

    if($('.product-single__form').has('.validation-error').length>0){

    } else {
      $('.customize_sectionwrapper .drawer__close-button').trigger('click');
    }
  }

  if($('.pattern_campaignblock').length > 0){
    var width1 = $('.campaign_blockwrap').width();
    var width2 = $('#product__slider img').width();
    var total_width = width1 - width2 - 50;
    var maxwidth = total_width;
    $('.pattern_campaignblock').width(maxwidth);
  }

  function product(){
    /** added js again bcz tippy not defined error in product page **/
    (function(e,t){'object'==typeof exports&&'undefined'!=typeof module?module.exports=t():'function'==typeof define&&define.amd?define(t):e.tippy=t()})(this,function(){'use strict';function e(e){return e&&'[object Function]'==={}.toString.call(e)}function t(e,t){if(1!==e.nodeType)return[];var r=e.ownerDocument.defaultView,a=r.getComputedStyle(e,null);return t?a[t]:a}function r(e){return'HTML'===e.nodeName?e:e.parentNode||e.host}function a(e){if(!e)return document.body;switch(e.nodeName){case'HTML':case'BODY':return e.ownerDocument.body;case'#document':return e.body;}var p=t(e),o=p.overflow,i=p.overflowX,n=p.overflowY;return /(auto|scroll|overlay)/.test(o+n+i)?e:a(r(e))}function p(e){return 11===e?bt:10===e?yt:bt||yt}function o(e){if(!e)return document.documentElement;for(var r=p(10)?document.body:null,a=e.offsetParent||null;a===r&&e.nextElementSibling;)a=(e=e.nextElementSibling).offsetParent;var i=a&&a.nodeName;return i&&'BODY'!==i&&'HTML'!==i?-1!==['TH','TD','TABLE'].indexOf(a.nodeName)&&'static'===t(a,'position')?o(a):a:e?e.ownerDocument.documentElement:document.documentElement}function n(e){var t=e.nodeName;return'BODY'!==t&&('HTML'===t||o(e.firstElementChild)===e)}function s(e){return null===e.parentNode?e:s(e.parentNode)}function l(e,t){if(!e||!e.nodeType||!t||!t.nodeType)return document.documentElement;var r=e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_FOLLOWING,a=r?e:t,p=r?t:e,i=document.createRange();i.setStart(a,0),i.setEnd(p,0);var d=i.commonAncestorContainer;if(e!==d&&t!==d||a.contains(p))return n(d)?d:o(d);var c=s(e);return c.host?l(c.host,t):l(e,s(t).host)}function d(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:'top',r='top'===t?'scrollTop':'scrollLeft',a=e.nodeName;if('BODY'===a||'HTML'===a){var p=e.ownerDocument.documentElement,o=e.ownerDocument.scrollingElement||p;return o[r]}return e[r]}function c(e,t){var r=!!(2<arguments.length&&void 0!==arguments[2])&&arguments[2],a=d(t,'top'),p=d(t,'left'),o=r?-1:1;return e.top+=a*o,e.bottom+=a*o,e.left+=p*o,e.right+=p*o,e}function m(e,t){var r='x'===t?'Left':'Top',a='Left'===r?'Right':'Bottom';return parseFloat(e['border'+r+'Width'],10)+parseFloat(e['border'+a+'Width'],10)}function f(e,t,r,a){return Ze(t['offset'+e],t['scroll'+e],r['client'+e],r['offset'+e],r['scroll'+e],p(10)?parseInt(r['offset'+e])+parseInt(a['margin'+('Height'===e?'Top':'Left')])+parseInt(a['margin'+('Height'===e?'Bottom':'Right')]):0)}function h(e){var t=e.body,r=e.documentElement,a=p(10)&&getComputedStyle(r);return{height:f('Height',t,r,a),width:f('Width',t,r,a)}}function b(e){return wt({},e,{right:e.left+e.width,bottom:e.top+e.height})}function u(e){var r={};try{if(p(10)){r=e.getBoundingClientRect();var a=d(e,'top'),o=d(e,'left');r.top+=a,r.left+=o,r.bottom+=a,r.right+=o}else r=e.getBoundingClientRect()}catch(t){}var i={left:r.left,top:r.top,width:r.right-r.left,height:r.bottom-r.top},n='HTML'===e.nodeName?h(e.ownerDocument):{},s=n.width||e.clientWidth||i.right-i.left,l=n.height||e.clientHeight||i.bottom-i.top,c=e.offsetWidth-s,f=e.offsetHeight-l;if(c||f){var y=t(e);c-=m(y,'x'),f-=m(y,'y'),i.width-=c,i.height-=f}return b(i)}function y(e,r){var o=!!(2<arguments.length&&void 0!==arguments[2])&&arguments[2],i=p(10),n='HTML'===r.nodeName,s=u(e),l=u(r),d=a(e),m=t(r),f=parseFloat(m.borderTopWidth,10),h=parseFloat(m.borderLeftWidth,10);o&&n&&(l.top=Ze(l.top,0),l.left=Ze(l.left,0));var y=b({top:s.top-l.top-f,left:s.left-l.left-h,width:s.width,height:s.height});if(y.marginTop=0,y.marginLeft=0,!i&&n){var g=parseFloat(m.marginTop,10),x=parseFloat(m.marginLeft,10);y.top-=f-g,y.bottom-=f-g,y.left-=h-x,y.right-=h-x,y.marginTop=g,y.marginLeft=x}return(i&&!o?r.contains(d):r===d&&'BODY'!==d.nodeName)&&(y=c(y,r)),y}function g(e){var t=!!(1<arguments.length&&void 0!==arguments[1])&&arguments[1],r=e.ownerDocument.documentElement,a=y(e,r),p=Ze(r.clientWidth,window.innerWidth||0),o=Ze(r.clientHeight,window.innerHeight||0),i=t?0:d(r),n=t?0:d(r,'left'),s={top:i-a.top+a.marginTop,left:n-a.left+a.marginLeft,width:p,height:o};return b(s)}function x(e){var a=e.nodeName;return'BODY'!==a&&'HTML'!==a&&('fixed'===t(e,'position')||x(r(e)))}function w(e){if(!e||!e.parentElement||p())return document.documentElement;for(var r=e.parentElement;r&&'none'===t(r,'transform');)r=r.parentElement;return r||document.documentElement}function v(e,t,p,o){var i=!!(4<arguments.length&&void 0!==arguments[4])&&arguments[4],n={top:0,left:0},s=i?w(e):l(e,t);if('viewport'===o)n=g(s,i);else{var d;'scrollParent'===o?(d=a(r(t)),'BODY'===d.nodeName&&(d=e.ownerDocument.documentElement)):'window'===o?d=e.ownerDocument.documentElement:d=o;var c=y(d,s,i);if('HTML'===d.nodeName&&!x(s)){var m=h(e.ownerDocument),f=m.height,b=m.width;n.top+=c.top-c.marginTop,n.bottom=f+c.top,n.left+=c.left-c.marginLeft,n.right=b+c.left}else n=c}p=p||0;var u='number'==typeof p;return n.left+=u?p:p.left||0,n.top+=u?p:p.top||0,n.right-=u?p:p.right||0,n.bottom-=u?p:p.bottom||0,n}function k(e){var t=e.width,r=e.height;return t*r}function E(e,t,r,a,p){var o=5<arguments.length&&void 0!==arguments[5]?arguments[5]:0;if(-1===e.indexOf('auto'))return e;var i=v(r,a,o,p),n={top:{width:i.width,height:t.top-i.top},right:{width:i.right-t.right,height:i.height},bottom:{width:i.width,height:i.bottom-t.bottom},left:{width:t.left-i.left,height:i.height}},s=Object.keys(n).map(function(e){return wt({key:e},n[e],{area:k(n[e])})}).sort(function(e,t){return t.area-e.area}),l=s.filter(function(e){var t=e.width,a=e.height;return t>=r.clientWidth&&a>=r.clientHeight}),d=0<l.length?l[0].key:s[0].key,c=e.split('-')[1];return d+(c?'-'+c:'')}function C(e,t,r){var a=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null,p=a?w(t):l(t,r);return y(r,p,a)}function L(e){var t=e.ownerDocument.defaultView,r=t.getComputedStyle(e),a=parseFloat(r.marginTop||0)+parseFloat(r.marginBottom||0),p=parseFloat(r.marginLeft||0)+parseFloat(r.marginRight||0),o={width:e.offsetWidth+p,height:e.offsetHeight+a};return o}function O(e){var t={left:'right',right:'left',bottom:'top',top:'bottom'};return e.replace(/left|right|bottom|top/g,function(e){return t[e]})}function T(e,t,r){r=r.split('-')[0];var a=L(e),p={width:a.width,height:a.height},o=-1!==['right','left'].indexOf(r),i=o?'top':'left',n=o?'left':'top',s=o?'height':'width',l=o?'width':'height';return p[i]=t[i]+t[s]/2-a[s]/2,p[n]=r===n?t[n]-a[l]:t[O(n)],p}function S(e,t){return Array.prototype.find?e.find(t):e.filter(t)[0]}function A(e,t,r){if(Array.prototype.findIndex)return e.findIndex(function(e){return e[t]===r});var a=S(e,function(e){return e[t]===r});return e.indexOf(a)}function Y(t,r,a){var p=void 0===a?t:t.slice(0,A(t,'name',a));return p.forEach(function(t){t['function']&&console.warn('`modifier.function` is deprecated, use `modifier.fn`!');var a=t['function']||t.fn;t.enabled&&e(a)&&(r.offsets.popper=b(r.offsets.popper),r.offsets.reference=b(r.offsets.reference),r=a(r,t))}),r}function P(){if(!this.state.isDestroyed){var e={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};e.offsets.reference=C(this.state,this.popper,this.reference,this.options.positionFixed),e.placement=E(this.options.placement,e.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),e.originalPlacement=e.placement,e.positionFixed=this.options.positionFixed,e.offsets.popper=T(this.popper,e.offsets.reference,e.placement),e.offsets.popper.position=this.options.positionFixed?'fixed':'absolute',e=Y(this.modifiers,e),this.state.isCreated?this.options.onUpdate(e):(this.state.isCreated=!0,this.options.onCreate(e))}}function D(e,t){return e.some(function(e){var r=e.name,a=e.enabled;return a&&r===t})}function X(e){for(var t=[!1,'ms','Webkit','Moz','O'],r=e.charAt(0).toUpperCase()+e.slice(1),a=0;a<t.length;a++){var p=t[a],o=p?''+p+r:e;if('undefined'!=typeof document.body.style[o])return o}return null}function I(){return this.state.isDestroyed=!0,D(this.modifiers,'applyStyle')&&(this.popper.removeAttribute('x-placement'),this.popper.style.position='',this.popper.style.top='',this.popper.style.left='',this.popper.style.right='',this.popper.style.bottom='',this.popper.style.willChange='',this.popper.style[X('transform')]=''),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function N(e){var t=e.ownerDocument;return t?t.defaultView:window}function H(e,t,r,p){var o='BODY'===e.nodeName,i=o?e.ownerDocument.defaultView:e;i.addEventListener(t,r,{passive:!0}),o||H(a(i.parentNode),t,r,p),p.push(i)}function W(e,t,r,p){r.updateBound=p,N(e).addEventListener('resize',r.updateBound,{passive:!0});var o=a(e);return H(o,'scroll',r.updateBound,r.scrollParents),r.scrollElement=o,r.eventsEnabled=!0,r}function M(){this.state.eventsEnabled||(this.state=W(this.reference,this.options,this.state,this.scheduleUpdate))}function B(e,t){return N(e).removeEventListener('resize',t.updateBound),t.scrollParents.forEach(function(e){e.removeEventListener('scroll',t.updateBound)}),t.updateBound=null,t.scrollParents=[],t.scrollElement=null,t.eventsEnabled=!1,t}function R(){this.state.eventsEnabled&&(cancelAnimationFrame(this.scheduleUpdate),this.state=B(this.reference,this.state))}function z(e){return''!==e&&!isNaN(parseFloat(e))&&isFinite(e)}function F(e,t){Object.keys(t).forEach(function(r){var a='';-1!==['width','height','top','right','bottom','left'].indexOf(r)&&z(t[r])&&(a='px'),e.style[r]=t[r]+a})}function _(e,t){Object.keys(t).forEach(function(r){var a=t[r];!1===a?e.removeAttribute(r):e.setAttribute(r,t[r])})}function U(e,t){var r=e.offsets,a=r.popper,p=r.reference,o=Qe,i=function(e){return e},n=o(a.width),s=o(p.width),l=-1!==['left','right'].indexOf(e.placement),d=-1!==e.placement.indexOf('-'),c=t?l||d||s%2==n%2?o:Je:i,m=t?o:i;return{left:c(1==s%2&&1==n%2&&!d&&t?a.left-1:a.left),top:m(a.top),bottom:m(a.bottom),right:c(a.right)}}function V(e,t,r){var a=S(e,function(e){var r=e.name;return r===t}),p=!!a&&e.some(function(e){return e.name===r&&e.enabled&&e.order<a.order});if(!p){var o='`'+t+'`';console.warn('`'+r+'`'+' modifier is required by '+o+' modifier in order to work, be sure to include it before '+o+'!')}return p}function q(e){return'end'===e?'start':'start'===e?'end':e}function j(e){var t=!!(1<arguments.length&&void 0!==arguments[1])&&arguments[1],r=Et.indexOf(e),a=Et.slice(r+1).concat(Et.slice(0,r));return t?a.reverse():a}function K(e,t,r,a){var p=e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),o=+p[1],i=p[2];if(!o)return e;if(0===i.indexOf('%')){var n;switch(i){case'%p':n=r;break;case'%':case'%r':default:n=a;}var s=b(n);return s[t]/100*o}if('vh'===i||'vw'===i){var l;return l='vh'===i?Ze(document.documentElement.clientHeight,window.innerHeight||0):Ze(document.documentElement.clientWidth,window.innerWidth||0),l/100*o}return o}function G(e,t,r,a){var p=[0,0],o=-1!==['right','left'].indexOf(a),i=e.split(/(\+|\-)/).map(function(e){return e.trim()}),n=i.indexOf(S(i,function(e){return-1!==e.search(/,|\s/)}));i[n]&&-1===i[n].indexOf(',')&&console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');var s=/\s*,\s*|\s+/,l=-1===n?[i]:[i.slice(0,n).concat([i[n].split(s)[0]]),[i[n].split(s)[1]].concat(i.slice(n+1))];return l=l.map(function(e,a){var p=(1===a?!o:o)?'height':'width',i=!1;return e.reduce(function(e,t){return''===e[e.length-1]&&-1!==['+','-'].indexOf(t)?(e[e.length-1]=t,i=!0,e):i?(e[e.length-1]+=t,i=!1,e):e.concat(t)},[]).map(function(e){return K(e,p,t,r)})}),l.forEach(function(e,t){e.forEach(function(r,a){z(r)&&(p[t]+=r*('-'===e[a-1]?-1:1))})}),p}function J(e,t){var r=t.offset,a=e.placement,p=e.offsets,o=p.popper,i=p.reference,n=a.split('-')[0],s=void 0;return s=z(+r)?[+r,0]:G(r,o,i,n),'left'===n?(o.top+=s[0],o.left-=s[1]):'right'===n?(o.top+=s[0],o.left+=s[1]):'top'===n?(o.left+=s[0],o.top-=s[1]):'bottom'===n&&(o.left+=s[0],o.top+=s[1]),e.popper=o,e}function Q(e){return[].slice.call(e)}function Z(e,t){return(Tt.closest||function(e){for(var t=this;t;){if(St.call(t,e))return t;t=t.parentElement}}).call(e,t)}function $(e,t){for(;e;){if(t(e))return e;e=e.parentElement}}function ee(){return document.createElement('div')}function te(e,t){e[Yt.x&&'innerHTML']=t instanceof Element?t[Yt.x&&'innerHTML']:t}function re(e,t){t.content instanceof Element?(te(e,''),e.appendChild(t.content)):e[t.allowHTML?'innerHTML':'textContent']=t.content}function ae(e){return{tooltip:e.querySelector(Ot.TOOLTIP),backdrop:e.querySelector(Ot.BACKDROP),content:e.querySelector(Ot.CONTENT),arrow:e.querySelector(Ot.ARROW)||e.querySelector(Ot.ROUND_ARROW)}}function pe(e){e.setAttribute('data-inertia','')}function oe(e){e.removeAttribute('data-inertia')}function ie(e){var t=ee();return'round'===e?(t.className='tippy-roundarrow',te(t,'<svg viewBox="0 0 24 8" xmlns="http://www.w3.org/2000/svg"><path d="M3 8s2.021-.015 5.253-4.218C9.584 2.051 10.797 1.007 12 1c1.203-.007 2.416 1.035 3.761 2.782C19.012 8.005 21 8 21 8H3z"/></svg>')):t.className='tippy-arrow',t}function ne(){var e=ee();return e.className='tippy-backdrop',e.setAttribute('data-state','hidden'),e}function se(e,t){e.setAttribute('tabindex','-1'),t.setAttribute('data-interactive','')}function le(e,t){e.removeAttribute('tabindex'),t.removeAttribute('data-interactive')}function de(e,t){e.forEach(function(e){e&&(e.style.transitionDuration=t+'ms')})}function ce(e,t,r){e[t+'EventListener']('transitionend',r)}function me(e){var t=e.getAttribute('x-placement');return t?t.split('-')[0]:''}function fe(e,t){e.forEach(function(e){e&&e.setAttribute('data-state',t)})}function he(e){void e.offsetHeight}function be(e,t){var r=ee();r.className='tippy-popper',r.setAttribute('role','tooltip'),r.id='tippy-'+e,r.style.zIndex=t.zIndex;var a=ee();a.className='tippy-tooltip',a.style.maxWidth=t.maxWidth+('number'==typeof t.maxWidth?'px':''),a.setAttribute('data-size',t.size),a.setAttribute('data-animation',t.animation),a.setAttribute('data-state','hidden'),t.theme.split(' ').forEach(function(e){a.classList.add(e+'-theme')});var p=ee();return p.className='tippy-content',p.setAttribute('data-state','hidden'),t.interactive&&se(r,a),t.arrow&&a.appendChild(ie(t.arrowType)),t.animateFill&&(a.appendChild(ne()),a.setAttribute('data-animatefill','')),t.inertia&&pe(a),re(p,t),a.appendChild(p),r.appendChild(a),r.addEventListener('focusout',function(t){t.relatedTarget&&r._tippy&&!$(t.relatedTarget,function(e){return e===r})&&t.relatedTarget!==r._tippy.reference&&r._tippy.props.shouldPopperHideOnBlur(t)&&r._tippy.hide()}),r}function ye(e,t,r){var a=ae(e),p=a.tooltip,o=a.content,i=a.backdrop,n=a.arrow;e.style.zIndex=r.zIndex,p.setAttribute('data-size',r.size),p.setAttribute('data-animation',r.animation),p.style.maxWidth=r.maxWidth+('number'==typeof r.maxWidth?'px':''),t.content!==r.content&&re(o,r),!t.animateFill&&r.animateFill?(p.appendChild(ne()),p.setAttribute('data-animatefill','')):t.animateFill&&!r.animateFill&&(p.removeChild(i),p.removeAttribute('data-animatefill')),!t.arrow&&r.arrow?p.appendChild(ie(r.arrowType)):t.arrow&&!r.arrow&&p.removeChild(n),t.arrow&&r.arrow&&t.arrowType!==r.arrowType&&p.replaceChild(ie(r.arrowType),n),!t.interactive&&r.interactive?se(e,p):t.interactive&&!r.interactive&&le(e,p),!t.inertia&&r.inertia?pe(p):t.inertia&&!r.inertia&&oe(p),t.theme!==r.theme&&(t.theme.split(' ').forEach(function(e){p.classList.remove(e+'-theme')}),r.theme.split(' ').forEach(function(e){p.classList.add(e+'-theme')}))}function ue(e,t){var r=e.popper,a=e.options,p=a.onCreate,o=a.onUpdate;a.onCreate=a.onUpdate=function(){he(r),t(),o(),a.onCreate=p,a.onUpdate=o}}function ge(e){Q(document.querySelectorAll(Ot.POPPER)).forEach(function(t){var r=t._tippy;r&&!0===r.props.hideOnClick&&(!e||t!==e.popper)&&r.hide()})}function xe(e,t,r,a){if(!e)return!0;var p=r.clientX,o=r.clientY,i=a.interactiveBorder,n=a.distance,s=t.top-o>('top'===e?i+n:i),l=o-t.bottom>('bottom'===e?i+n:i),d=t.left-p>('left'===e?i+n:i),c=p-t.right>('right'===e?i+n:i);return s||l||d||c}function we(e,t){return-(e-t)+'px'}function ve(e){return'[object Object]'==={}.toString.call(e)}function ke(e,t){return{}.hasOwnProperty.call(e,t)}function Ee(e){return!isNaN(e)&&!isNaN(parseFloat(e))}function Ce(e){if(e instanceof Element||ve(e))return[e];if(e instanceof NodeList)return Q(e);if(Array.isArray(e))return e;try{return Q(document.querySelectorAll(e))}catch(t){return[]}}function Le(e,t,r){if(Array.isArray(e)){var a=e[t];return null==a?r:a}return e}function Oe(e){var t=window.scrollX||window.pageXOffset,r=window.scrollY||window.pageYOffset;e.focus(),scroll(t,r)}function Te(e){setTimeout(e,1)}function Se(e,t){var r;return function(){var a=this,p=arguments;clearTimeout(r),r=setTimeout(function(){return e.apply(a,p)},t)}}function Ae(e,t){return e&&e.modifiers&&e.modifiers[t]}function Ye(e,t){return-1<e.indexOf(t)}function Pe(){Pt||(Pt=!0,it&&document.body.classList.add('tippy-iOS'),window.performance&&document.addEventListener('mousemove',De))}function De(){var e=performance.now();20>e-Dt&&(Pt=!1,document.removeEventListener('mousemove',De),!it&&document.body.classList.remove('tippy-iOS')),Dt=e}function Xe(e){var t=e.target;if(!(t instanceof Element))return ge();var r=Z(t,Ot.POPPER);if(!(r&&r._tippy&&r._tippy.props.interactive)){var a=$(t,function(e){return e._tippy&&e._tippy.reference===e});if(a){var p=a._tippy,o=Ye(p.props.trigger,'click');if(Pt||o)return ge(p);if(!0!==p.props.hideOnClick||o)return;p.clearDelayTimeouts()}ge()}}function Ie(){var e=document,t=e.activeElement;t&&t.blur&&t._tippy&&t.blur()}function Ne(){Q(document.querySelectorAll(Ot.POPPER)).forEach(function(e){var t=e._tippy;t.props.livePlacement||t.popperInstance.scheduleUpdate()})}function He(){document.addEventListener('click',Xe,!0),document.addEventListener('touchstart',Pe,At),window.addEventListener('blur',Ie),window.addEventListener('resize',Ne),!nt&&(navigator.maxTouchPoints||navigator.msMaxTouchPoints)&&document.addEventListener('pointerdown',Pe)}function We(e){return!(e instanceof Element)||St.call(e,'a[href],area[href],button,details,input,textarea,select,iframe,[tabindex]')&&!e.hasAttribute('disabled')}function Me(e){return Xt.reduce(function(t,r){var a=(e.getAttribute('data-tippy-'+r)||'').trim();return a?(t[r]='content'===r?a:'true'===a||'false'!==a&&(Ee(a)?+a:'['===a[0]||'{'===a[0]?JSON.parse(a):a),t):t},{})}function Be(e){var t={isVirtual:!0,attributes:e.attributes||{},setAttribute:function(t,r){e.attributes[t]=r},getAttribute:function(t){return e.attributes[t]},removeAttribute:function(t){delete e.attributes[t]},hasAttribute:function(t){return t in e.attributes},addEventListener:function(){},removeEventListener:function(){},classList:{classNames:{},add:function(t){e.classList.classNames[t]=!0},remove:function(t){delete e.classList.classNames[t]},contains:function(t){return t in e.classList.classNames}}};for(var r in t)e[r]=t[r]}function Re(e,t){var r=It({},t,t.performance?{}:Me(e));return r.arrow&&(r.animateFill=!1),'function'==typeof r.appendTo&&(r.appendTo=t.appendTo(e)),'function'==typeof r.content&&(r.content=t.content(e)),r}function ze(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},t=arguments[1];Object.keys(e).forEach(function(e){if(!ke(t,e))throw new Error('[tippy]: `'+e+'` is not a valid option')})}function Fe(e,t){return(t?e:{X:'Y',Y:'X'}[e])||''}function _e(e,t,r,p){var o=t[0],i=t[1];if(!o&&!i)return'';var n={scale:function(){return i?r?o+', '+i:i+', '+o:''+o}(),translate:function(){return i?r?p?o+'px, '+-i+'px':o+'px, '+i+'px':p?-i+'px, '+o+'px':i+'px, '+o+'px':p?-o+'px':o+'px'}()};return n[e]}function Ue(e,t){var r=e.match(new RegExp(t+'([XY])'));return r?r[1]:''}function Ve(e,t){var r=e.match(t);return r?r[1].split(',').map(function(e){return parseFloat(e,10)}):[]}function qe(e,t){var r=me(Z(e,Ot.POPPER)),a=Ye(['top','bottom'],r),p=Ye(['right','bottom'],r),o={translate:{axis:Ue(t,'translate'),numbers:Ve(t,Nt.translate)},scale:{axis:Ue(t,'scale'),numbers:Ve(t,Nt.scale)}},i=t.replace(Nt.translate,'translate'+Fe(o.translate.axis,a)+'('+_e('translate',o.translate.numbers,a,p)+')').replace(Nt.scale,'scale'+Fe(o.scale.axis,a)+'('+_e('scale',o.scale.numbers,a,p)+')');e.style['undefined'==typeof document.body.style.transform?'webkitTransform':'transform']=i}function je(e,t){function r(){Te(function(){z=!1})}function a(){X=new MutationObserver(function(){q.popperInstance.update()}),X.observe(U,{childList:!0,subtree:!0,characterData:!0})}function p(e){var t=N=e,r=t.clientX,a=t.clientY;if(q.popperInstance){var p=me(q.popper),o=q.popperChildren.arrow?20:5,i=Ye(['top','bottom'],p),n=Ye(['left','right'],p),l=i?Ze(o,r):r,d=n?Ze(o,a):a;i&&l>o&&(l=Ge(r,window.innerWidth-o)),n&&d>o&&(d=Ge(a,window.innerHeight-o));var c=q.reference.getBoundingClientRect(),m=q.props.followCursor,f='horizontal'===m,h='vertical'===m;q.popperInstance.reference={getBoundingClientRect:function(){return{width:0,height:0,top:f?c.top:d,bottom:f?c.bottom:d,left:h?c.left:l,right:h?c.right:l}},clientWidth:0,clientHeight:0},q.popperInstance.scheduleUpdate(),'initial'===m&&q.state.isVisible&&s()}}function o(e){var t=Z(e.target,q.props.target);t&&!t._tippy&&(je(t,It({},q.props,{target:'',showOnInit:!0})),i(e))}function i(e){if(T(),!q.state.isVisible){if(q.props.target)return o(e);if(M=!0,q.props.wait)return q.props.wait(q,e);x()&&!q.state.isMounted&&document.addEventListener('mousemove',p);var t=Le(q.props.delay,0,st.delay);t?H=setTimeout(function(){A()},t):A()}}function n(){if(T(),!q.state.isVisible)return s();M=!1;var e=Le(q.props.delay,1,st.delay);e?W=setTimeout(function(){q.state.isVisible&&Y()},e):Y()}function s(){document.removeEventListener('mousemove',p),N=null}function l(){document.body.removeEventListener('mouseleave',n),document.removeEventListener('mousemove',F)}function d(e){!q.state.isEnabled||y(e)||(!q.state.isVisible&&(I=e),'click'===e.type&&!1!==q.props.hideOnClick&&q.state.isVisible?n():i(e))}function c(e){var t=$(e.target,function(e){return e._tippy}),r=Z(e.target,Ot.POPPER)===q.popper,a=t===q.reference;r||a||xe(me(q.popper),q.popper.getBoundingClientRect(),e,q.props)&&(l(),n())}function m(e){return y(e)?void 0:q.props.interactive?(document.body.addEventListener('mouseleave',n),void document.addEventListener('mousemove',F)):void n()}function f(e){if(e.target===q.reference){if(q.props.interactive){if(!e.relatedTarget)return;if(Z(e.relatedTarget,Ot.POPPER))return}n()}}function h(e){Z(e.target,q.props.target)&&i(e)}function b(e){Z(e.target,q.props.target)&&n()}function y(e){var t=Ye(e.type,'touch'),r=nt&&Pt&&q.props.touchHold&&!t,a=Pt&&!q.props.touchHold&&t;return r||a}function u(){var e=q.props.popperOptions,t=q.popperChildren,r=t.tooltip,a=t.arrow;return new Lt(q.reference,q.popper,It({placement:q.props.placement},e,{modifiers:It({},e?e.modifiers:{},{preventOverflow:It({boundariesElement:q.props.boundary},Ae(e,'preventOverflow')),arrow:It({element:a,enabled:!!a},Ae(e,'arrow')),flip:It({enabled:q.props.flip,padding:q.props.distance+5,behavior:q.props.flipBehavior},Ae(e,'flip')),offset:It({offset:q.props.offset},Ae(e,'offset'))}),onCreate:function(){r.style[me(q.popper)]=we(q.props.distance,st.distance),a&&q.props.arrowTransform&&qe(a,q.props.arrowTransform)},onUpdate:function(){var e=r.style;e.top='',e.bottom='',e.left='',e.right='',e[me(q.popper)]=we(q.props.distance,st.distance),a&&q.props.arrowTransform&&qe(a,q.props.arrowTransform)}}))}function g(e){q.popperInstance?!x()&&(q.popperInstance.scheduleUpdate(),q.props.livePlacement&&q.popperInstance.enableEventListeners()):(q.popperInstance=u(),a(),(!q.props.livePlacement||x())&&q.popperInstance.disableEventListeners()),q.popperInstance.reference=q.reference;var t=q.popperChildren.arrow;if(x()){t&&(t.style.margin='0');var r=Le(q.props.delay,0,st.delay);I.type&&p(r&&N?N:I)}else t&&(t.style.margin='');ue(q.popperInstance,e),q.props.appendTo.contains(q.popper)||(q.props.appendTo.appendChild(q.popper),q.props.onMount(q),q.state.isMounted=!0)}function x(){return q.props.followCursor&&!Pt&&'focus'!==I.type}function w(){de([q.popper],ot?0:q.props.updateDuration);(function e(){q.popperInstance&&q.popperInstance.scheduleUpdate(),q.state.isMounted?requestAnimationFrame(e):de([q.popper],0)})()}function v(e,t){E(e,function(){!q.state.isVisible&&q.props.appendTo.contains(q.popper)&&t()})}function k(e,t){E(e,t)}function E(e,t){if(0===e)return t();var r=q.popperChildren.tooltip,a=function a(p){p.target===r&&(ce(r,'remove',a),t())};ce(r,'remove',B),ce(r,'add',a),B=a}function C(e,t){var r=!!(2<arguments.length&&void 0!==arguments[2])&&arguments[2];q.reference.addEventListener(e,t,r),R.push({eventType:e,handler:t,options:r})}function L(){q.props.touchHold&&!q.props.target&&(C('touchstart',d,At),C('touchend',m,At)),q.props.trigger.trim().split(' ').forEach(function(e){'manual'===e||(q.props.target?'mouseenter'===e?(C('mouseover',h),C('mouseout',b)):'focus'===e?(C('focusin',h),C('focusout',b)):'click'===e?C(e,h):void 0:(C(e,d),'mouseenter'===e?C('mouseleave',m):'focus'===e?C(ot?'focusout':'blur',f):void 0))})}function O(){R.forEach(function(e){var t=e.eventType,r=e.handler,a=e.options;q.reference.removeEventListener(t,r,a)}),R=[]}function T(){clearTimeout(H),clearTimeout(W)}function S(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};ze(e,st);var t=q.props,r=Re(q.reference,It({},q.props,e,{performance:!0}));r.performance=ke(e,'performance')?e.performance:t.performance,q.props=r,(ke(e,'trigger')||ke(e,'touchHold'))&&(O(),L()),ke(e,'interactiveDebounce')&&(l(),F=Se(c,e.interactiveDebounce)),ye(q.popper,t,r),q.popperChildren=ae(q.popper),q.popperInstance&&lt.some(function(t){return ke(e,t)})&&(q.popperInstance.destroy(),q.popperInstance=u(),!q.state.isVisible&&q.popperInstance.disableEventListeners(),q.props.followCursor&&N&&p(N))}function A(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:Le(q.props.duration,0,st.duration[0]);return q.state.isDestroyed||!q.state.isEnabled||Pt&&!q.props.touch?void 0:q.reference.isVirtual||document.documentElement.contains(q.reference)?q.reference.hasAttribute('disabled')?void 0:z?void(z=!1):void(!1===q.props.onShow(q)||(q.popper.style.visibility='visible',q.state.isVisible=!0,de([q.popper,q.popperChildren.tooltip,q.popperChildren.backdrop],0),g(function(){q.state.isVisible&&(!x()&&q.popperInstance.update(),de([q.popperChildren.tooltip,q.popperChildren.backdrop,q.popperChildren.content],e),q.popperChildren.backdrop&&(q.popperChildren.content.style.transitionDelay=Qe(e/6)+'ms'),q.props.interactive&&q.reference.classList.add('tippy-active'),q.props.sticky&&w(),fe([q.popperChildren.tooltip,q.popperChildren.backdrop,q.popperChildren.content],'visible'),k(e,function(){0===q.props.updateDuration&&q.popperChildren.tooltip.classList.add('tippy-notransition'),q.props.autoFocus&&q.props.interactive&&Ye(['focus','click'],I.type)&&Oe(q.popper),q.props.aria&&q.reference.setAttribute('aria-'+q.props.aria,q.popper.id),q.props.onShown(q),q.state.isShown=!0}))}))):P()}function Y(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:Le(q.props.duration,1,st.duration[1]);q.state.isDestroyed||!q.state.isEnabled||!1===q.props.onHide(q)||(0===q.props.updateDuration&&q.popperChildren.tooltip.classList.remove('tippy-notransition'),q.props.interactive&&q.reference.classList.remove('tippy-active'),q.popper.style.visibility='hidden',q.state.isVisible=!1,q.state.isShown=!1,de([q.popperChildren.tooltip,q.popperChildren.backdrop,q.popperChildren.content],e),fe([q.popperChildren.tooltip,q.popperChildren.backdrop,q.popperChildren.content],'hidden'),q.props.autoFocus&&q.props.interactive&&!z&&Ye(['focus','click'],I.type)&&('focus'===I.type&&(z=!0),Oe(q.reference)),v(e,function(){M||s(),q.props.aria&&q.reference.removeAttribute('aria-'+q.props.aria),q.popperInstance.disableEventListeners(),q.props.appendTo.removeChild(q.popper),q.state.isMounted=!1,q.props.onHidden(q)}))}function P(e){q.state.isDestroyed||(q.state.isMounted&&Y(0),O(),q.reference.removeEventListener('click',r),delete q.reference._tippy,q.props.target&&e&&Q(q.reference.querySelectorAll(q.props.target)).forEach(function(e){return e._tippy&&e._tippy.destroy()}),q.popperInstance&&q.popperInstance.destroy(),X&&X.disconnect(),q.state.isDestroyed=!0)}var D=Re(e,t);if(!D.multiple&&e._tippy)return null;var X=null,I={},N=null,H=0,W=0,M=!1,B=function(){},R=[],z=!1,F=0<D.interactiveDebounce?Se(c,D.interactiveDebounce):c,_=Ht++,U=be(_,D);U.addEventListener('mouseenter',function(e){q.props.interactive&&q.state.isVisible&&'mouseenter'===I.type&&i(e)}),U.addEventListener('mouseleave',function(e){q.props.interactive&&'mouseenter'===I.type&&0===q.props.interactiveDebounce&&xe(me(U),U.getBoundingClientRect(),e,q.props)&&n()});var V=ae(U),q={id:_,reference:e,popper:U,popperChildren:V,popperInstance:null,props:D,state:{isEnabled:!0,isVisible:!1,isDestroyed:!1,isMounted:!1,isShown:!1},clearDelayTimeouts:T,set:S,setContent:function(e){S({content:e})},show:A,hide:Y,enable:function(){q.state.isEnabled=!0},disable:function(){q.state.isEnabled=!1},destroy:P};return L(),e.addEventListener('click',r),D.lazy||(q.popperInstance=u(),q.popperInstance.disableEventListeners()),D.showOnInit&&i(),!D.a11y||D.target||We(e)||e.setAttribute('tabindex','0'),e._tippy=q,U._tippy=q,q}function Ke(e,t,r){ze(t,st),Wt||(He(),Wt=!0);var a=It({},st,t);ve(e)&&Be(e);var p=Ce(e),o=p[0],i=(r&&o?[o]:p).reduce(function(e,t){var r=t&&je(t,a);return r&&e.push(r),e},[]),n={targets:e,props:a,instances:i,destroyAll:function(){n.instances.forEach(function(e){e.destroy()}),n.instances=[]}};return n}for(var Ge=Math.min,Je=Math.floor,Qe=Math.round,Ze=Math.max,$e='.tippy-iOS{cursor:pointer!important}.tippy-notransition{transition:none!important}.tippy-popper{-webkit-perspective:700px;perspective:700px;z-index:9999;outline:0;transition-timing-function:cubic-bezier(.165,.84,.44,1);pointer-events:none;line-height:1.4;max-width:calc(100% - 10px)}.tippy-popper[x-placement^=top] .tippy-backdrop{border-radius:40% 40% 0 0}.tippy-popper[x-placement^=top] .tippy-roundarrow{bottom:-8px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.tippy-popper[x-placement^=top] .tippy-arrow{border-top:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;bottom:-7px;margin:0 6px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-backdrop{-webkit-transform-origin:0 25%;transform-origin:0 25%}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-55%);transform:scale(1) translate(-50%,-55%)}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%,-45%);transform:scale(.2) translate(-50%,-45%);opacity:0}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(-20px);transform:translateY(-20px)}.tippy-popper[x-placement^=top] [data-animation=perspective]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=visible]{-webkit-transform:translateY(-10px) rotateX(0);transform:translateY(-10px) rotateX(0)}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) rotateX(60deg);transform:translateY(0) rotateX(60deg)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(-10px) scale(1);transform:translateY(-10px) scale(1)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) scale(.5);transform:translateY(0) scale(.5)}.tippy-popper[x-placement^=bottom] .tippy-backdrop{border-radius:0 0 30% 30%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow{top:-8px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(0);transform:rotate(0)}.tippy-popper[x-placement^=bottom] .tippy-arrow{border-bottom:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;top:-7px;margin:0 6px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-backdrop{-webkit-transform-origin:0 -50%;transform-origin:0 -50%}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-45%);transform:scale(1) translate(-50%,-45%)}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%);transform:scale(.2) translate(-50%);opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=visible]{-webkit-transform:translateY(10px) rotateX(0);transform:translateY(10px) rotateX(0)}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) rotateX(-60deg);transform:translateY(0) rotateX(-60deg)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(10px) scale(1);transform:translateY(10px) scale(1)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) scale(.5);transform:translateY(0) scale(.5)}.tippy-popper[x-placement^=left] .tippy-backdrop{border-radius:50% 0 0 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow{right:-16px;-webkit-transform-origin:33.33333333% 50%;transform-origin:33.33333333% 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.tippy-popper[x-placement^=left] .tippy-arrow{border-left:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;right:-7px;margin:3px 0;-webkit-transform-origin:0 50%;transform-origin:0 50%}.tippy-popper[x-placement^=left] .tippy-backdrop{-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-75%,-50%);transform:scale(.2) translate(-75%,-50%);opacity:0}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(-20px);transform:translateX(-20px)}.tippy-popper[x-placement^=left] [data-animation=perspective]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=visible]{-webkit-transform:translateX(-10px) rotateY(0);transform:translateX(-10px) rotateY(0)}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) rotateY(-60deg);transform:translateX(0) rotateY(-60deg)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(-10px) scale(1);transform:translateX(-10px) scale(1)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) scale(.5);transform:translateX(0) scale(.5)}.tippy-popper[x-placement^=right] .tippy-backdrop{border-radius:0 50% 50% 0}.tippy-popper[x-placement^=right] .tippy-roundarrow{left:-16px;-webkit-transform-origin:66.66666666% 50%;transform-origin:66.66666666% 50%}.tippy-popper[x-placement^=right] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.tippy-popper[x-placement^=right] .tippy-arrow{border-right:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;left:-7px;margin:3px 0;-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.tippy-popper[x-placement^=right] .tippy-backdrop{-webkit-transform-origin:-50% 0;transform-origin:-50% 0}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-25%,-50%);transform:scale(.2) translate(-25%,-50%);opacity:0}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(20px);transform:translateX(20px)}.tippy-popper[x-placement^=right] [data-animation=perspective]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=visible]{-webkit-transform:translateX(10px) rotateY(0);transform:translateX(10px) rotateY(0)}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) rotateY(60deg);transform:translateX(0) rotateY(60deg)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(10px) scale(1);transform:translateX(10px) scale(1)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) scale(.5);transform:translateX(0) scale(.5)}.tippy-tooltip{position:relative;color:#fff;border-radius:4px;font-size:.9rem;padding:.3rem .6rem;max-width:350px;text-align:center;will-change:transform;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#333}.tippy-tooltip[data-size=small]{padding:.2rem .4rem;font-size:.75rem}.tippy-tooltip[data-size=large]{padding:.4rem .8rem;font-size:1rem}.tippy-tooltip[data-animatefill]{overflow:hidden;background-color:transparent}.tippy-tooltip[data-interactive],.tippy-tooltip[data-interactive] path{pointer-events:auto}.tippy-tooltip[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-tooltip[data-inertia][data-state=hidden]{transition-timing-function:ease}.tippy-arrow,.tippy-roundarrow{position:absolute;width:0;height:0}.tippy-roundarrow{width:24px;height:8px;fill:#333;pointer-events:none}.tippy-backdrop{position:absolute;will-change:transform;background-color:#333;border-radius:50%;width:calc(110% + 2rem);left:50%;top:50%;z-index:-1;transition:all cubic-bezier(.46,.1,.52,.98);-webkit-backface-visibility:hidden;backface-visibility:hidden}.tippy-backdrop:after{content:"";float:left;padding-top:100%}.tippy-backdrop+.tippy-content{transition-property:opacity;will-change:opacity}.tippy-backdrop+.tippy-content[data-state=visible]{opacity:1}.tippy-backdrop+.tippy-content[data-state=hidden]{opacity:0}',et='3.4.1',tt='undefined'!=typeof window,rt=tt?navigator:{},at=tt?window:{},pt=('MutationObserver'in at),ot=/MSIE |Trident\//.test(rt.userAgent),it=/iPhone|iPad|iPod/.test(rt.platform)&&!at.MSStream,nt=('ontouchstart'in at),st={a11y:!0,allowHTML:!0,animateFill:!0,animation:'shift-away',appendTo:function(){return document.body},aria:'describedby',arrow:!1,arrowTransform:'',arrowType:'sharp',autoFocus:!0,boundary:'scrollParent',content:'',delay:[0,20],distance:10,duration:[325,275],flip:!0,flipBehavior:'flip',followCursor:!1,hideOnClick:!0,inertia:!1,interactive:!1,interactiveBorder:2,interactiveDebounce:0,lazy:!0,livePlacement:!0,maxWidth:'',multiple:!1,offset:0,onHidden:function(){},onHide:function(){},onMount:function(){},onShow:function(){},onShown:function(){},performance:!1,placement:'top',popperOptions:{},shouldPopperHideOnBlur:function(){return!0},showOnInit:!1,size:'regular',sticky:!1,target:'',theme:'dark',touch:!0,touchHold:!1,trigger:'mouseenter focus',updateDuration:200,wait:null,zIndex:9999},lt=['arrow','arrowType','distance','flip','flipBehavior','offset','placement','popperOptions'],dt='undefined'!=typeof window&&'undefined'!=typeof document,ct=['Edge','Trident','Firefox'],mt=0,ft=0;ft<ct.length;ft+=1)if(dt&&0<=navigator.userAgent.indexOf(ct[ft])){mt=1;break}var i=dt&&window.Promise,ht=i?function(e){var t=!1;return function(){t||(t=!0,window.Promise.resolve().then(function(){t=!1,e()}))}}:function(e){var t=!1;return function(){t||(t=!0,setTimeout(function(){t=!1,e()},mt))}},bt=dt&&!!(window.MSInputMethodContext&&document.documentMode),yt=dt&&/MSIE 10/.test(navigator.userAgent),ut=function(e,t){if(!(e instanceof t))throw new TypeError('Cannot call a class as a function')},gt=function(){function e(e,t){for(var r,a=0;a<t.length;a++)r=t[a],r.enumerable=r.enumerable||!1,r.configurable=!0,'value'in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}return function(t,r,a){return r&&e(t.prototype,r),a&&e(t,a),t}}(),xt=function(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e},wt=Object.assign||function(e){for(var t,r=1;r<arguments.length;r++)for(var a in t=arguments[r],t)Object.prototype.hasOwnProperty.call(t,a)&&(e[a]=t[a]);return e},vt=dt&&/Firefox/i.test(navigator.userAgent),kt=['auto-start','auto','auto-end','top-start','top','top-end','right-start','right','right-end','bottom-end','bottom','bottom-start','left-end','left','left-start'],Et=kt.slice(3),Ct={FLIP:'flip',CLOCKWISE:'clockwise',COUNTERCLOCKWISE:'counterclockwise'},Lt=function(){function t(r,a){var p=this,o=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};ut(this,t),this.scheduleUpdate=function(){return requestAnimationFrame(p.update)},this.update=ht(this.update.bind(this)),this.options=wt({},t.Defaults,o),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=r&&r.jquery?r[0]:r,this.popper=a&&a.jquery?a[0]:a,this.options.modifiers={},Object.keys(wt({},t.Defaults.modifiers,o.modifiers)).forEach(function(e){p.options.modifiers[e]=wt({},t.Defaults.modifiers[e]||{},o.modifiers?o.modifiers[e]:{})}),this.modifiers=Object.keys(this.options.modifiers).map(function(e){return wt({name:e},p.options.modifiers[e])}).sort(function(e,t){return e.order-t.order}),this.modifiers.forEach(function(t){t.enabled&&e(t.onLoad)&&t.onLoad(p.reference,p.popper,p.options,t,p.state)}),this.update();var i=this.options.eventsEnabled;i&&this.enableEventListeners(),this.state.eventsEnabled=i}return gt(t,[{key:'update',value:function(){return P.call(this)}},{key:'destroy',value:function(){return I.call(this)}},{key:'enableEventListeners',value:function(){return M.call(this)}},{key:'disableEventListeners',value:function(){return R.call(this)}}]),t}();Lt.Utils=('undefined'==typeof window?global:window).PopperUtils,Lt.placements=kt,Lt.Defaults={placement:'bottom',positionFixed:!1,eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:{shift:{order:100,enabled:!0,fn:function(e){var t=e.placement,r=t.split('-')[0],a=t.split('-')[1];if(a){var p=e.offsets,o=p.reference,i=p.popper,n=-1!==['bottom','top'].indexOf(r),s=n?'left':'top',l=n?'width':'height',d={start:xt({},s,o[s]),end:xt({},s,o[s]+o[l]-i[l])};e.offsets.popper=wt({},i,d[a])}return e}},offset:{order:200,enabled:!0,fn:J,offset:0},preventOverflow:{order:300,enabled:!0,fn:function(e,t){var r=t.boundariesElement||o(e.instance.popper);e.instance.reference===r&&(r=o(r));var a=X('transform'),p=e.instance.popper.style,i=p.top,n=p.left,s=p[a];p.top='',p.left='',p[a]='';var l=v(e.instance.popper,e.instance.reference,t.padding,r,e.positionFixed);p.top=i,p.left=n,p[a]=s,t.boundaries=l;var d=t.priority,c=e.offsets.popper,m={primary:function(e){var r=c[e];return c[e]<l[e]&&!t.escapeWithReference&&(r=Ze(c[e],l[e])),xt({},e,r)},secondary:function(e){var r='right'===e?'left':'top',a=c[r];return c[e]>l[e]&&!t.escapeWithReference&&(a=Ge(c[r],l[e]-('right'===e?c.width:c.height))),xt({},r,a)}};return d.forEach(function(e){var t=-1===['left','top'].indexOf(e)?'secondary':'primary';c=wt({},c,m[t](e))}),e.offsets.popper=c,e},priority:['left','right','top','bottom'],padding:5,boundariesElement:'scrollParent'},keepTogether:{order:400,enabled:!0,fn:function(e){var t=e.offsets,r=t.popper,a=t.reference,p=e.placement.split('-')[0],o=Je,i=-1!==['top','bottom'].indexOf(p),n=i?'right':'bottom',s=i?'left':'top',l=i?'width':'height';return r[n]<o(a[s])&&(e.offsets.popper[s]=o(a[s])-r[l]),r[s]>o(a[n])&&(e.offsets.popper[s]=o(a[n])),e}},arrow:{order:500,enabled:!0,fn:function(e,r){var a;if(!V(e.instance.modifiers,'arrow','keepTogether'))return e;var p=r.element;if('string'==typeof p){if(p=e.instance.popper.querySelector(p),!p)return e;}else if(!e.instance.popper.contains(p))return console.warn('WARNING: `arrow.element` must be child of its popper element!'),e;var o=e.placement.split('-')[0],i=e.offsets,n=i.popper,s=i.reference,l=-1!==['left','right'].indexOf(o),d=l?'height':'width',c=l?'Top':'Left',m=c.toLowerCase(),f=l?'left':'top',h=l?'bottom':'right',y=L(p)[d];s[h]-y<n[m]&&(e.offsets.popper[m]-=n[m]-(s[h]-y)),s[m]+y>n[h]&&(e.offsets.popper[m]+=s[m]+y-n[h]),e.offsets.popper=b(e.offsets.popper);var u=s[m]+s[d]/2-y/2,g=t(e.instance.popper),x=parseFloat(g['margin'+c],10),w=parseFloat(g['border'+c+'Width'],10),v=u-e.offsets.popper[m]-x-w;return v=Ze(Ge(n[d]-y,v),0),e.arrowElement=p,e.offsets.arrow=(a={},xt(a,m,Qe(v)),xt(a,f,''),a),e},element:'[x-arrow]'},flip:{order:600,enabled:!0,fn:function(e,t){if(D(e.instance.modifiers,'inner'))return e;if(e.flipped&&e.placement===e.originalPlacement)return e;var r=v(e.instance.popper,e.instance.reference,t.padding,t.boundariesElement,e.positionFixed),a=e.placement.split('-')[0],p=O(a),o=e.placement.split('-')[1]||'',i=[];switch(t.behavior){case Ct.FLIP:i=[a,p];break;case Ct.CLOCKWISE:i=j(a);break;case Ct.COUNTERCLOCKWISE:i=j(a,!0);break;default:i=t.behavior;}return i.forEach(function(n,s){if(a!==n||i.length===s+1)return e;a=e.placement.split('-')[0],p=O(a);var l=e.offsets.popper,d=e.offsets.reference,c=Je,m='left'===a&&c(l.right)>c(d.left)||'right'===a&&c(l.left)<c(d.right)||'top'===a&&c(l.bottom)>c(d.top)||'bottom'===a&&c(l.top)<c(d.bottom),f=c(l.left)<c(r.left),h=c(l.right)>c(r.right),b=c(l.top)<c(r.top),y=c(l.bottom)>c(r.bottom),u='left'===a&&f||'right'===a&&h||'top'===a&&b||'bottom'===a&&y,g=-1!==['top','bottom'].indexOf(a),x=!!t.flipVariations&&(g&&'start'===o&&f||g&&'end'===o&&h||!g&&'start'===o&&b||!g&&'end'===o&&y);(m||u||x)&&(e.flipped=!0,(m||u)&&(a=i[s+1]),x&&(o=q(o)),e.placement=a+(o?'-'+o:''),e.offsets.popper=wt({},e.offsets.popper,T(e.instance.popper,e.offsets.reference,e.placement)),e=Y(e.instance.modifiers,e,'flip'))}),e},behavior:'flip',padding:5,boundariesElement:'viewport'},inner:{order:700,enabled:!1,fn:function(e){var t=e.placement,r=t.split('-')[0],a=e.offsets,p=a.popper,o=a.reference,i=-1!==['left','right'].indexOf(r),n=-1===['top','left'].indexOf(r);return p[i?'left':'top']=o[r]-(n?p[i?'width':'height']:0),e.placement=O(t),e.offsets.popper=b(p),e}},hide:{order:800,enabled:!0,fn:function(e){if(!V(e.instance.modifiers,'hide','preventOverflow'))return e;var t=e.offsets.reference,r=S(e.instance.modifiers,function(e){return'preventOverflow'===e.name}).boundaries;if(t.bottom<r.top||t.left>r.right||t.top>r.bottom||t.right<r.left){if(!0===e.hide)return e;e.hide=!0,e.attributes['x-out-of-boundaries']=''}else{if(!1===e.hide)return e;e.hide=!1,e.attributes['x-out-of-boundaries']=!1}return e}},computeStyle:{order:850,enabled:!0,fn:function(e,t){var r=t.x,a=t.y,p=e.offsets.popper,i=S(e.instance.modifiers,function(e){return'applyStyle'===e.name}).gpuAcceleration;void 0!==i&&console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');var n=void 0===i?t.gpuAcceleration:i,s=o(e.instance.popper),l=u(s),d={position:p.position},c=U(e,2>window.devicePixelRatio||!vt),m='bottom'===r?'top':'bottom',f='right'===a?'left':'right',h=X('transform'),b=void 0,y=void 0;if(y='bottom'==m?'HTML'===s.nodeName?-s.clientHeight+c.bottom:-l.height+c.bottom:c.top,b='right'==f?'HTML'===s.nodeName?-s.clientWidth+c.right:-l.width+c.right:c.left,n&&h)d[h]='translate3d('+b+'px, '+y+'px, 0)',d[m]=0,d[f]=0,d.willChange='transform';else{var g='bottom'==m?-1:1,x='right'==f?-1:1;d[m]=y*g,d[f]=b*x,d.willChange=m+', '+f}var w={"x-placement":e.placement};return e.attributes=wt({},w,e.attributes),e.styles=wt({},d,e.styles),e.arrowStyles=wt({},e.offsets.arrow,e.arrowStyles),e},gpuAcceleration:!0,x:'bottom',y:'right'},applyStyle:{order:900,enabled:!0,fn:function(e){return F(e.instance.popper,e.styles),_(e.instance.popper,e.attributes),e.arrowElement&&Object.keys(e.arrowStyles).length&&F(e.arrowElement,e.arrowStyles),e},onLoad:function(e,t,r,a,p){var o=C(p,t,e,r.positionFixed),i=E(r.placement,o,t,e,r.modifiers.flip.boundariesElement,r.modifiers.flip.padding);return t.setAttribute('x-placement',i),F(t,{position:r.positionFixed?'fixed':'absolute'}),r},gpuAcceleration:void 0}}};var Ot={POPPER:'.tippy-popper',TOOLTIP:'.tippy-tooltip',CONTENT:'.tippy-content',BACKDROP:'.tippy-backdrop',ARROW:'.tippy-arrow',ROUND_ARROW:'.tippy-roundarrow'},Tt=tt?Element.prototype:{},St=Tt.matches||Tt.matchesSelector||Tt.webkitMatchesSelector||Tt.mozMatchesSelector||Tt.msMatchesSelector,At={passive:!0},Yt={x:!0},Pt=!1,Dt=0,Xt=Object.keys(st),It=Object.assign||function(e){for(var t,r=1;r<arguments.length;r++)for(var a in t=arguments[r],t)Object.prototype.hasOwnProperty.call(t,a)&&(e[a]=t[a]);return e},Nt={translate:/translateX?Y?\(([^)]+)\)/,scale:/scaleX?Y?\(([^)]+)\)/},Ht=1,Wt=!1;Ke.version=et,Ke.defaults=st,Ke.one=function(e,t){return Ke(e,t,!0).instances[0]},Ke.setDefaults=function(e){Object.keys(e).forEach(function(t){st[t]=e[t]})},Ke.disableAnimations=function(){Ke.setDefaults({duration:0,updateDuration:0,animateFill:!1})},Ke.hideAllPoppers=ge,Ke.useCapture=function(){};return tt&&setTimeout(function(){Q(document.querySelectorAll('[data-tippy]')).forEach(function(e){var t=e.getAttribute('data-tippy');t&&Ke(e,{content:t})})}),function(e){if(pt){var t=document.createElement('style');t.type='text/css',t.textContent=e,document.head.insertBefore(t,document.head.firstChild)}}($e),Ke});
    $('.form_product_section').clone().appendTo('.product_drawer');    
    $('.customize_sectionwrapper .form_product_section .mw-product-options > div').removeClass('mw-options-container');
    $('.customize_sectionwrapper .form_product_section .mw-product-options > div').addClass('mw-options1-container');    
    /****** STARTS JS FOR SHOW CHECKBOX IN FRONT OF LABEL IN PRODUCT COFIGURATOR ********/
    $('.customize_sectionwrapper .mw-option').each(function(){
      $(this).find('.mw_product_option_label').before('<input type="checkbox" class="label_check"></input>');
    });

    $('.customize_sectionwrapper .label_check').iCheck({
      checkboxClass: 'icheckbox_square first_check'
    });
    /****** ENDS JS FOR SHOW CHECKBOX IN FRONT OF LABEL IN PRODUCT COFIGURATOR ********/
    enableButton(); 
    


	
    /****** STARTS JS FOR ADD COLLAPSE/EXPAND SECTION ********/
    $('.customize_sectionwrapper #product_drawerform .mw-option').each(function(){
      $(this).prepend('<div class="mw_optionlink"></div>');
      var location = $(this).find('.mw_optionlink');
      $(this).find('.first_check ').appendTo(location);
      $(this).find('.mw_product_option_label ').appendTo(location);
      //       $(this).find('.mw-option-tooltip ').appendTo(location);

      $(this).append('<div class="mw_optiondesc"></div>');
      var locationdesc = $(this).find('.mw_optiondesc');
      if($(this).find('.mw_options_list').length > 0){
        $(this).find('.mw_options_list').appendTo(locationdesc);
      }else if($(this).find('.swatch-option').length > 0){
        $(this).find('.swatch-option').appendTo(locationdesc);
      }else if($(this).find('.button-option').length > 0){
        $(this).find('.button-option').appendTo(locationdesc);
        $(this).addClass('valid');
        $(this).find('.first_check').addClass('checked');
        $(this).find('input').trigger('change');
      }else if($(this).hasClass('mw-option-select')){
        $(this).find('select').appendTo(locationdesc);
      }else if($(this).hasClass('mw-option-textarea')){
        $(this).find('textarea').appendTo(locationdesc);
      }

      /*** JS FOR IF LABEL IS BLANK THEN REMOVE EXAPND/COLLAPSE ***/
      if ($(this).find('.mw_product_option_label').is(':empty')){
        $(this).find('.mw_optionlink').addClass('block_wrap');
        $(this).find('.mw_optiondesc').addClass('block_wrap');

      }
      /*** END JS FOR IF LABEL IS BLANK THEN REMOVE EXAPND/COLLAPSE ***/
    });

    //$('.customize_sectionwrapper .mw-options1-container ul li').matchHeight();



    $('.customize_sectionwrapper .mw_optionlink').on('click' , function(e){
      if($(this).hasClass('block_wrap')){
      }else{
        e.preventDefault();
        $(this).parents('.mw-option').toggleClass('section_active');
        $(this).parents('.mw-option').find('.mw_optiondesc').slideToggle(300);

        var val_id = $(this).find('.mw_product_option_label').attr('for');

        if($(this).parents('.mw-option').hasClass('mw-validate-required-option')){
        }else{
          if($(this).parents('.mw-option').hasClass('section_active')){
            $('.product-single__form label[for="'+ val_id +'"]').parents('.mw-option').addClass('open');
          }else{
            $('.product-single__form label[for="'+ val_id +'"]').parents('.mw-option').removeClass('open');
          }
        }
      }
    });
    setTimeout(function(){
      $('.customize_sectionwrapper #product_drawerform .mw-option-swatch').each(function(){
        $(this).find('.swatch-value-container').eq(0).trigger('click');
      });

      $('.customize_sectionwrapper #product_drawerform .mw-option-radio').each(function(){
        if($(this).hasClass('mw-validate-required-option')){
          if($(this).find('.first_check').hasClass('checked')){
            $(this).addClass('valid');
          }
        }	
      });
    },2000);


    $('.product-single__form .mw-option .button-value-container').each(function(){
      if($(this).find('.button-value').attr('style').indexOf('2px solid rgb(0, 0, 0)') > 1) {
      /*if( $(this).find('.button-value').css('border') == '2px solid rgb(0, 0, 0)' ) {*/
        var data_id = $(this).attr('data-value-id');
        $('.customize_sectionwrapper').find('[data-value-id='+ data_id +']').addClass('active');
      }
      checkButton();
    });

    $('.customize_sectionwrapper #product_drawerform .mw-validate-required-option').each(function(){
      if( $(this).css('display') == 'none' ) {
        $(this).removeClass('mw-validate-required-option');
      }
    });
    /****** Add Price To button ********/
    $('.customize_sectionwrapper .button-value-container').each(function() {
        var target = $(this).attr('data-value-price');         
       if($(this).attr('data-value-price'))
       {
        if( $(this).attr('data-value-price') == 0)
          {			    
						 console.log('No Price');
    			}
        else
          {
					  $(this).find('.button-value').append('<br><span class="price"> (+$' + target + ') </span>');
			    }

       }
    });

    /****** ENDS JS FOR ADD COLLAPSE/EXPAND SECTION ********/

    /****** STARTS JS FOR ON HOVER BUTTON SHOW TOOLTIP ********/
    $('.customize_sectionwrapper .button-value').each(function() {
      var target = $(this).attr('aria-describedby');
      var content = $('#'+target).find('.qtip-content').text();
      $(this).attr('data-content',content);
      $(this).attr('data-tippy-content',content);
    });

    $('.customize_sectionwrapper .button-value').each(function() {
      var target = $(this).attr('aria-describedby');
      if($(this).attr('data-content')) {
        if($(this).attr('data-content').trim()) {
          /*
          $(this).attr('data-tippy-content',$(this).attr('data-content'));
          $(this).addClass('tippy-02');
          */
          $(this).append('<span class="mw-option-tooltip"></span>');
          $(this).find(".mw-option-tooltip").attr('data-tippy-content',$(this).attr('data-content'));
          $(this).find(".mw-option-tooltip").addClass('tippy-02');
        } else {
          $(this).removeAttr('data-tippy-content');
        }
      }
    });

    tippy('.tippy-02', {
      delay: 100,
      arrow: false,
      arrowType: 'round',
      size: 'large',
      duration: 500,
      animation: 'scale',
      theme: 'honeybee'
    });
    if ($(window).width() < 1200) {
      /*
      $( ".drawer--has-fixed-footer .drawer__inner" ).scroll(function() {
        $('*').qtip('hide');
      });
      */

      window.addEventListener('scroll', tippy.hideAllPoppers)
    }

    /****** ENDS JS FOR ON HOVER BUTTON SHOW TOOLTIP ********/


    /*****STARTS JS FOR EXAPND/COLLAPSE BTN *****/
    $('.customize_sectionwrapper .collapse_btn').on('click' , function(e){
      e.preventDefault();
      $('.customize_sectionwrapper .mw-option').each(function(){
        if($(this).hasClass('section_active')){
          $(this).find('.mw_optionlink').trigger('click');
        }
      });
      //       $('.customize_sectionwrapper #product_drawerform').slideUp('slow');
    });
    $('.customize_sectionwrapper .expand_btn').on('click' , function(e){
      e.preventDefault();
      $('.customize_sectionwrapper .mw-option').each(function(){
        if($(this).hasClass('section_active')){
        }else{
          $(this).find('.mw_optionlink').trigger('click');
        }
      });
      //       $('.customize_sectionwrapper #product_drawerform').slideDown('slow');
    });

    /****** STARTS JS FOR ON HOVER ICON SHOW TOOLTIP ********/
    $('.customize_sectionwrapper .mw-option-tooltip').each(function() {
      var target = $(this).attr('aria-describedby');
      var content = $('#'+target).find('.qtip-content').text();
      $(this).attr('data-content',content);
    });

    $('.customize_sectionwrapper .mw-option-tooltip').each(function() {
      var target = $(this).attr('aria-describedby');
      if($(this).attr('data-content').trim()) {
        $(this).attr('data-tippy-content',$(this).attr('data-content'));
        $(this).addClass('tippy-01');
      } else {
        $(this).removeAttr('data-tippy-content');
      }
    });
    tippy('.tippy-01', {
      delay: 100,
      arrow: false,
      arrowType: 'round',
      size: 'large',
      duration: 500,
      animation: 'scale',
      theme: 'honeybee'
    });
    /****** ENDS JS FOR ON HOVER ICON SHOW TOOLTIP ********/

    setTimeout(function(){
      checkFunction();
    },1000);

    /****** STARTS JS FOR APPLY ICHECK ********/
    $('.customize_sectionwrapper .mw_options_list li input').iCheck({
      checkboxClass: 'icheckbox_square',
      radioClass: 'iradio_square'
    });
    /****** ENDS JS FOR APPLY ICHECK ********/


    /****** STARTS JS FOR ON CLICK RADIO SELECT RADIO BUTTON FROM ORIGINAL FORM ********/
    $('.customize_sectionwrapper .iradio_square .iCheck-helper').on('click' , function(){
      $(this).parents('li').trigger('click');
    });
    /****** ENDS JS FOR ON CLICK RADIO SELECT RADIO BUTTON FROM ORIGINAL FORM ********/

    /****** STARTS JS FOR ON CHANGE PRICE PRINT PRICE ********/
    $('#ProductPrice-product-template').on("DOMSubtreeModified",function(){
      var content = $(this).find('.money').html();
      $('.customize_botttomtitle .product__price').html(content);
    });
    /****** ENDS JS FOR ON CHANGE PRICE PRINT PRICE ********/

    /****** STARTS JS FOR ON CLICK ICHECK SELECT ICHECK BUTTON FROM ORIGINAL FORM ********/
    $('.icheckbox_square .iCheck-helper').on('click' , function(){
      $(this).parents('li').trigger('click');
    });
    /****** ENDS JS FOR ON CLICK ICHECK SELECT ICHECK BUTTON FROM ORIGINAL FORM ********/


//     $('.customize_addcart').on('click' , function(e){

//       $('#mwAddToCart').trigger('click');
//     });

    $('.customize_sectionwrapper .swatch-value-container').on('click' , function(e){
      e.preventDefault();
      var data_value = $(this).attr('data-value-id');
      $('.swatch-option').find('.swatch-value-container').removeClass('swatch-selected');
      $('.customize_sectionwrapper .swatch-value-container[data-value-id="'+ data_value +'"]').addClass('swatch-selected');
      $('#AddToCartForm-product-template .swatch-value-container[data-value-id="'+ data_value +'"]').trigger('click');
      checkSwatch();

      if($(this).parents('.mw-option').hasClass('mw-validate-required-option')){
        if($(this).parents('.mw-option').find('.first_check').hasClass('checked')){
          $(this).parents('.mw-validate-required-option').addClass('valid');
        }
      }
      enableButton()
    });

    checkButton();
    checkSwatch();
    /*
    $('#AddToCartForm-product-template .mw-option-swatch').on("DOMSubtreeModified",function(){
      var content = $(this).find('.option-label-value').html();
      $('#product_drawerform .mw-option-swatch').find('.option-label-value').html(content);
    });

    $('#AddToCartForm-product-template .mw-option-button').on("DOMSubtreeModified",function(e){
      var content = $(this).find('.mw_product_option_label').html();
      $('#product_drawerform .mw-option-radio').find('.mw_product_option_label').html(content);
    });
    $('#AddToCartForm-product-template .mw-option-button').on("DOMSubtreeModified",function(e){
      var content = $(this).find('.mw_product_option_label').html();
      $('#product_drawerform .mw-option-button').find('.mw_product_option_label').html(content);
    });
    */


//     $('.customizing_cartbtn a').on('click' , function(e){
//       e.preventDefault();
//       $('.customize_addcart').trigger('click');
//     });

    /********* STARTS JS FOR REQUIRED SECTION OPEN ON READY DOCUMENT **********/
    $('.mw-validate-required-option').each(function(){
      $(this).find('.mw_product_option_label').trigger('click');
    });
    /********* ENDS JS FOR REQUIRED SECTION OPEN ON READY DOCUMENT **********/

    $("#AddToCartForm-product-template").find('select').each(function(ix,em){
      var $this = em;
      var current_id = $($this).attr('id');
      var current_value = $($this).val();
      if(current_value != ""){
        $(".product_drawer").find("#"+current_id).val(current_value);
        var $$this = $(".product_drawer").find("#"+current_id);
        $($$this).parents('.mw-option').find('.mw_optionlink .icheckbox_square').addClass('checked');
        $($$this).parents('.mw-validate-required-option').addClass('active');
        $($$this).parents('.mw-validate-required-option').addClass('valid');
        //console.log(774);
      }
    });
    $(".mw_optionlink").find('label').each(function(ix,em){
      if($(em).text() != "") {

      } else {   
        $(em).parents(".mw_optionlink").find('.icheckbox_square').fadeOut(0);
      }
    });

    $(".product_drawer").find("input[type='number'][disabled]").each(function(ix,em){
      $(em).removeAttr('disabled');
      $(em).attr('readonly','readonly');      
    });
   
    
    // Price summary customise 
    if($('#quote-form').find("#get-product-quote-form").length){
      $('.cart_properties').empty();
      var html = '';

      $.each($("#AddToCartForm-product-template").serializeArray(), function(i, item) {
        // console.log(item);
        if(item.name != 'id' && item.value) {
          var multiple = false;
          var multiplevalues = [];
          if(item.value.indexOf('),') !== -1) {
            multiple = true;
            multiplevalues = item.value.split('),');
          }

          var nName = item.name.replace("properties[", "");
          html += '<li>'+(nName.replace("]", ""))+': ';

          if(multiple) {
            var item_count = 0;
            $.each(multiplevalues, function (key, val) {
              if(item_count == 0) {
                val = val + ')';
              }
              var propertyValue = "input[value='" + val.trim() + "']";
              var itemPrice = $(propertyValue).eq(0).attr('data-value-price');
              if(typeof itemPrice === 'undefined') {
                var itemPrice = $(propertyValue).eq(1).attr('data-value-price');
              }

              if(parseInt(itemPrice) == 0) {
                html += '<br />' + val + ' <b>(Included)</b>';
              } else {
                html += '<br />' + val + " <b>(+$" + itemPrice +')</b>';
              }
              item_count++;
            });
            html += '</li>';
          } else {
            var propertyValue = 'input[value="' + item.value + '"]';
            var itemPrice = $(propertyValue).eq(0).attr('data-value-price');
            if(typeof itemPrice === 'undefined') {
              var itemPrice = $(propertyValue).eq(1).attr('data-value-price');
            }

            if(parseInt(itemPrice) == 0) {
              html += item.value + ' <b>(Included)</b></li>';
            } else {
              html += item.value + " <b>(+$" + itemPrice +')</b></li>';
            }
          }
        }            
      });

      if(html != '' || html != null) {
        setTimeout(function(){
          var product_updated_price = $("#ProductPrice-product-template").find('span.money').text();
          html += '<li class= '+"total-p" +'><b>Subtotal: </b><span>'+product_updated_price+'</span></li>';
          $('.cart_properties').html(html);
        }, 1000);
      } else {
        $('.cart_properties').html('<li>No Customized Data</li>');
      }
    }

    $('.customize_sectionwrapper .label_check').iCheck('disable');
    
  } /* function product() ends */
  
  
waitForEl('.mw-product-options .mw-options-container', function() {
  var drawer_show = 0;
  $('#AddToCartForm-product-template .mw-options-container').each(function(){
  	drawer_show = drawer_show + 1;
  });
  if(drawer_show == 0) {
      console.log('No Products');      
  } else {
    $('.blocks_productbtn .customize_wrapper .customize_btn').text('CUSTOMIZE & BUY');
    product();
    $(document).on("click touchstart", ".customize_sectionwrapper .button-value-container", function (e) {
      var $this = e.target;
      if($($this).hasClass("mw-option-tooltip")) {
        console.log("tool-tip-clicked");
      } else {
        var data_value = $(this).attr('data-value-id');
        $('#AddToCartForm-product-template .button-value-container[data-value-id="'+ data_value +'"]').find('.button-value').trigger('click');
        $('#AddToCartForm-product-template .button-value-container[data-value-id="'+ data_value +'"]').find('.button-value').trigger('touchend');
        $('.product_drawer').html('');
        //$(this).find('.button-value').each(function() {
        //  var target = $(this).attr('aria-describedby');
        //  $('#' + target).remove();
        //});
        product();
        $('.product-single__form .mw-option .button-value-container').each(function(){
          if($(this).find('.button-value').attr('style').indexOf('2px solid rgb(0, 0, 0)') > 1) {
          /*if( $(this).find('.button-value').css('border') == '2px solid rgb(0, 0, 0)' ) {*/
            var data_id = $(this).attr('data-value-id');
            $('.customize_sectionwrapper').find('[data-value-id='+ data_id +']').addClass('active');
          }
          checkButton();
        });
      }
      console.log('740'); 
      
    });

    function advanceDrawer(){
      var scroll = $(".customize_sectionwrapper .drawer__inner").scrollTop();

      setTimeout(function(){
        $('.product_drawer').html('');
        product();
        setTimeout(function(){
          $('.mw-option.open').each(function() {
            $(this).find('.mw_optionlink').trigger('click');
          });
        },100);
        setTimeout(function(){
          $('.customize_sectionwrapper .drawer__inner').animate({ scrollTop: scroll }, 0);
          $('.product_draweroverlay').removeClass('active');
          check();
        },1000);
        setTimeout(function(){
          enableButton();
        },3000);
      },100);
    }

    $(document).on("click", ".customize_sectionwrapper .mw-option-radio .mw_options_list li", function(e) {
      var $this = e.target;
      console.log('785');
      if($($this).hasClass('mw-option-tooltip')) {
        var descBy = $($this).attr("aria-describedby");
        console.log(descBy);
        //$('.mw-option-tooltip[aria-describedby="'+descBy+'"]').qtip('toggle');
        //var tip = $('.mw-option-tooltip')._tippy;
        //tip.show();
        //$($this).qtip('toggle', true);
      } else {
          $('.product_draweroverlay').addClass('active');
          var val_id = $(this).find('.iradio_square').find('input[type="radio"]').attr('data-value-id');
          $('.product-single__form input[data-value-id="'+ val_id +'"]').trigger('click');
          var data_id = $(this).find('.iradio_square input').attr('data-value-id');
          $(this).parents('.mw_options_list').find('li').removeClass('active');
          $(this).addClass('active');
          $('.product-single__form input[data-value-id="'+ data_id +'"]').parents('.mw_options_list').find('li').removeClass('active');
          $('.product-single__form input[data-value-id="'+ data_id +'"]').parents('li').addClass('active');
          advanceDrawer();
      }
    });

    $(document).on("click", ".customize_sectionwrapper .mw-option-checkbox .mw_options_list li", function(e) {
      var $this = e.target;
      //console.log('806');
      if($($this).hasClass('mw-option-tooltip')) {
        var descBy = $($this).attr("aria-describedby");
        //console.log(descBy);
        //$('.mw-option-tooltip[aria-describedby="'+descBy+'"]').qtip('toggle');
        //var tip = $('.mw-option-tooltip')._tippy;
        //tip.show();
        //$($this).qtip('toggle', true);
      /*} else if ($($this).attr('type') == 'number' && $($this).attr('disabled') != 'disabled') {*/
      } else if ($($this).attr('type') == 'number' && $($this).attr('readonly') != 'readonly') {
        //console.log('clicked number - new');
      } else {
        $('.product_draweroverlay').addClass('active');
        var val_id = $(this).find('.icheckbox_square').find('input[type="checkbox"]').attr('data-value-id');
        $('.product-single__form input[data-value-id="'+ val_id +'"]').trigger('click');
        var data_id = $(this).find('.icheckbox_square input').attr('data-value-id');

        $(this).parents('.mw_options_list').find('li').removeClass('active');
        $(this).addClass('active');
        $('.product-single__form input[data-value-id="'+ data_id +'"]').parents('li').toggleClass('active');
        advanceDrawer();
      }
    });

    $(document).on('change',".drawer__inner .mw-input input",function(e){
      $this = e.target;
      var id_to_target = $($this).attr('data-qty-input-for-value-id');
      var value_to_update = $($this).val();
      
      $("#AddToCartForm-product-template .mw-input input[data-qty-input-for-value-id='"+id_to_target+"']").val(value_to_update).trigger('change');
      advanceDrawer();
    });

    $(document).on('change',".mw_optiondesc select",function(e){
      $this = e.target;
      var id_to_target = $($this).attr('id');
      var value_to_update = $($this).val();
      
      $("#AddToCartForm-product-template #"+id_to_target).val(value_to_update).trigger('change');
      $($this).parents('.mw-option').find('.mw_optionlink .icheckbox_square').addClass('checked');
      $($this).parents('.mw-validate-required-option').addClass('active');
      $($this).parents('.mw-validate-required-option').addClass('valid');
      advanceDrawer();
    });
    
    /*
    $(document).on("change", ".customize_sectionwrapper select", function () {
      var selected_id = $(this).find(":selected").attr('data-value-id');
      var selected_element = $(this).attr('id');
      var attr = $(this).find(":selected").attr('data-hidden');
      if (typeof attr !== typeof undefined && attr !== false) {
        $('.product-single__form').find('[id='+ selected_element +']').find('option').attr('selected', false);
        $('.product-single__form').find('[id='+ selected_element +']').find('option[value=""]').attr('selected', 'selected');

        //         $(this).parents('.mw-option').find('.mw_optionlink .icheckbox_square').removeClass('checked');
        //         $(this).parents('.mw-option').find('input').trigger('change');
        //         $(this).parents('.mw-validate-required-option').removeClass('valid');
        $('.product-single__form').find('[id='+ selected_element +']').parents('.mw-validate-required-option').removeClass('valid');
      }else{
        $('.product-single__form').find('[id='+ selected_element +']').find('option').attr('selected', false);
        $('.product-single__form').find('[id='+ selected_element +']').find('option[data-value-id="'+ selected_id +'"]').attr('selected', 'selected');
        $('.product-single__form').find('[id='+ selected_element +']').parents('.mw-validate-required-option').addClass('valid');

        //         $(this).parents('.mw-option').find('input').trigger('change');
        //         $(this).parents('.mw-option').find('.mw_optionlink .icheckbox_square').addClass('checked');
        //         $(this).parents('.mw-validate-required-option').addClass('active');
        //         $(this).parents('.mw-validate-required-option').addClass('valid');
      }
      //       $('.product-single__form').find('[id='+ selected_element +']').find('option[data-value-id="'+ selected_id +'"]').attr('selected', 'selected');
      //       $('.product-single__form').find('[id='+ selected_element +']').trigger('change');
      advanceDrawer();

    });
    */

  
  }
});      
  




  waitForEl('.sd_Sizechart .sd_size_innerpop', function() {
    
    var sizeguide = 0;
    $('.sd_Sizechart .main-chart-table').each(function(){
    	sizeguide = sizeguide +1;
    });
    if(sizeguide == 0){
    }else{
      	$('.size_guideblock .product_wrap').removeClass('hide_wrap');
    	if($('.Sd_sizechartmodel').length>0){
        }else{
          $('.size_productcaption.sizeguide_btn').parents('.product_wrap').hide();
        }
        $('.sd_Sizechart .sd_size_innerpop .Sd_popfirst_panel').clone().appendTo('.size_toptitle');
        $('.sd_Sizechart .sd_size_innerpop .main-chart-table').clone().appendTo('.sizeguide_drawer');
        $('.sizeguide_btn').on('click' , function(e){
          e.preventDefault();
          $('body').addClass('js-drawer-open');
          $('#sizeguide_drawer').addClass('drawer--is-open');
        });
        $('.size_drawer .drawer__close-button').on('click' , function(){

          $('body').removeClass('js-drawer-open');
          $('body').addClass('js-drawer-closing');
          $('#sizeguide_drawer').removeClass('drawer--is-open');

          setTimeout(function(){
            $('body').removeClass('js-drawer-closing');
          },1000);

        });
    }
    
  });
  
  /******** STARTS JS FOR SEARCH PAGE FOR TAGS ********/
  waitForEl('.snize-filters-sidebar.snize-product-filters .snize-product-filters-list', function() {
  	$('.snize-filters-sidebar.snize-product-filters .snize-product-filters-list').find('li').each(function(){
    	var str1 = $(this).find('label span').text();
        var str2 = "_";
        if(str1.indexOf(str2) != -1){
            $(this).remove();
        }
    });
  });
  /******** ENDS JS FOR SEARCH PAGE FOR TAGS ********/


  /******** STARTS JS FOR COLLECTION PAGE ********/
  if($('.collection_bannertabs').length > 0){
    $('.collection_bannertabs li a').on('click' , function(e){
      e.preventDefault();
      var href = $(this).attr('href');
      $('.collection_bannertabs li').removeClass('active');
      $(this).parent('li').addClass('active');
      $('.blocks_product').fadeOut(500);
      $(href).fadeIn(500);

      $('.product_featuresslider').slick('unslick');
      $('.product_featuresslider').each(function(key, item) {
        var sliderIdName = 'slider' + key;
        this.id = sliderIdName;

        var sliderId = '#' + sliderIdName;
        $(sliderId).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: false,
          adaptiveHeight:true,
          dots:true
        });
      });
    });
  }


  $('.product_featuresslider').each(function(key, item) {

    var sliderIdName = 'slider' + key;
    this.id = sliderIdName;

    var sliderId = '#' + sliderIdName;
    $(sliderId).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    });

  });

  $('.product_filteroption li span a').on('click' , function(e){
    e.preventDefault();
    var href = $(this).attr('href');

    if($(this).parent('li').hasClass('active')){
      $('.filter_section').slideUp(500);  
      $('.product_filteroption li').removeClass('active');
      $('.transition-body').removeClass('body_overlay');

    }else{
      $('.product_filteroption li').removeClass('active');
      $(this).parent('li').addClass('active');
      $('.filter_section').slideUp(500);
      $(href).slideDown(500);
      $('.transition-body').addClass('body_overlay');
    }

  });
  $('.brand_block li input').iCheck({
    radioClass: 'radio_brand'
  });

  $('.sidebar_filter li input').iCheck({
    checkboxClass: 'filter_check'
  });

  $('.promo_closewrapper a').on('click' , function(e){
    e.preventDefault();
    $('.promocode_strap').slideUp(100);
  });

  $('.filter_selectionclose a').on('click' , function(e){
    e.preventDefault();
    $(this).parents('.filter_section').slideUp(500);
    $('.product_filteroption li').removeClass('active');
    $('.transition-body').removeClass('body_overlay');
  });

  $('.color_blockwrap li a').on('click' , function(e){
    e.preventDefault();
    $(this).parents('.color_blockwrap').find('li').removeClass('active');
    $(this).parent('li').addClass('active');

    if($(this).parents('#color_block').length > 0){
      $('#color_block').find('.selected_option').html('');
      $('#color_block .color_blockwrap .active').each(function(){
        var content = $('#color_block').find('li.active').find('span').text();
        $('#color_block').find('.selected_option').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');

                                                          $('.selected_option li span').on('click' , function(){
          $(this).parents('li').remove();
        });
      });
    }
  });
  $('.selected_option li span').on('click' , function(){
    $(this).parents('li').remove();
  });

  $('.brand_block li .full_block').on('click' , function(e){
    e.preventDefault();
    $(this).parents('.brand_block').find('li').removeClass('active');
    $(this).parents('.brand_block').find('li input').iCheck('uncheck');
    $(this).parent('li').addClass('active');
    $(this).parent('li').find('input').iCheck('check');
    

    var value = $(this).parent('li').find('label').attr('value');
    $('#sort-by option').each(function(){
      var option_value = $(this).attr('value');
      if(value == option_value){
        $(this).attr('selected', 'selected');
        $(this).parents('#sort-by').trigger('change');
      }
    });

    
    

    if($(this).parents('#feature_block').length > 0){
      $('#feature_block').find('.selected_option').html('');
      $('#feature_block .brand_block .active').each(function(){
        var content = $('#feature_block').find('li.active').find('label').text();
        $('#feature_block').find('.selected_option').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');
		$('.filter_resultblock').find('.result_blocksection').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');
                                                            
      });
   }

                                                    if($(this).parents('#brand_block').length > 0){
        $('#brand_block').find('.selected_option').html('');
        $('#brand_block .brand_block .active').each(function(){
          var content = $('#brand_block').find('li.active').find('label').text();
          $('#brand_block').find('.selected_option').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');
          });
          
        }

                                                    if($(this).parents('#size_block').length > 0){
          $('#size_block').find('.selected_option').html('');
          $('#size_block .brand_block .active').each(function(){
            var content = $('#size_block').find('li.active').find('label').text();
            $('#size_block').find('.selected_option').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');
                                                             });
          }
                                                     $('.selected_option li span').on('click' , function(){
            $(this).parents('li').remove();
          });
        }); 


        $('.sidebar_filter .sidebar_top label').on('click' , function(){
          if($(this).parents('li').find('.submenu_filter').length > 0){
            if($(this).parent('.sidebar_top').hasClass('active')){
              $(this).parent('.sidebar_top').removeClass('active');
              $(this).parents('li').find('.submenu_filter').slideUp(500);  
            }else{
              $(this).parent('.sidebar_top').addClass('active');
              $(this).parents('li').find('.submenu_filter').slideDown(500);  
            }
          }else{
            if($(this).parents('li').find('.filter_check').hasClass('checked')){
              $(this).parents('li').find('input').iCheck('uncheck');
            }else{
              $(this).parents('li').find('input').iCheck('check');      
            }
          }
        });
        
        $(document).on("click", ".filter_selectionblock .select_option span", function (){
            var text2 = $(this).parent('li').text();
            if($(this).parents('#brand_block').hasClass('filter_section')){
              $('#brand_block .brand_block li').each(function(){
                  var text = $(this).find('label a').html();
                  if(text2.indexOf(text) != -1){
                    $(this).find('a').trigger('click');
                  }
              });
            }
          
          	if($(this).parents('#color_block').hasClass('filter_section')){
              $('#color_block .color_blockwrap li').each(function(){
                  var text = $(this).find('span').html();
                  if(text2.indexOf(text) != -1){
                    $(this).find('a').trigger('click');
                  }
              });
            }
          
          if($(this).parents('#size_block').hasClass('filter_section')){
              $('#size_block .brand_block li').each(function(){
                  var text = $(this).find('label a').html();
                  if(text2.indexOf(text) != -1){
                    $(this).find('a').trigger('click');
                  }
              });
            }
          
	       if($(this).parents('#feature_block').hasClass('filter_section')){
              $('#feature_block .brand_block li').each(function(){
                  var text = $(this).find('label a').html();
                  if(text2.indexOf(text) != -1){
                    $(this).find('a').trigger('click');
                  }
              });
            }
          
            $(this).parent('li').remove(); 
          });
        
        $(document).on("click", ".result_blocksection .select_option span", function (){
            var text2 = $(this).parent('li').text();
          console.log(text2);
          var counter = 0;
          $('.filter_areawrapper .filter_section').each(function(){
            console.log(counter++);
          	
            $('#brand_block .brand_block li').each(function(){
              var text = $(this).find('label a').html();
              console.log(text);
              if(text2.indexOf(text) != -1){
                $(this).find('a').trigger('click');
              }
            });
            
            
            
              $('#color_block .color_blockwrap li').each(function(){
                  var text = $(this).find('span').html();
                  if(text2.indexOf(text) != -1){
                    $(this).find('a').trigger('click');
                  }
              });
            
            
            
              $('#size_block .brand_block li').each(function(){
                  var text = $(this).find('label a').html();
                  if(text2.indexOf(text) != -1){
                    $(this).find('a').trigger('click');
                  }
              });
            
            
              $('#feature_block .brand_block li').each(function(){
                  var text = $(this).find('label a').html();
                  if(text2.indexOf(text) != -1){
                    $(this).find('a').trigger('click');
                  }
              });
            
            
          });  
          $(this).parent('li').remove(); 
        });

        $('.submenu_filter').each(function(){
          if($(this).find('.filter_check').hasClass('checked')){
            $(this).parents('.sidebar_filter').find('li').eq(0).find('input').iCheck('uncheck');
          }
        });

        $('.submenu_filter li label').on('click' , function(){
          if($(this).parents('.submenu_filter').find('li .filter_check').hasClass('checked')){
            $(this).parents('.submenu_filter').parents('li').find('.sidebar_top').find('input').iCheck('check');
          }else{
            $(this).parents('.submenu_filter').parents('li').find('.sidebar_top').find('input').iCheck('uncheck');
          }
        });
        $('.submenu_filter li .filter_check .iCheck-helper').on('click' , function(){
          if($(this).parents('.submenu_filter').find('li .filter_check').hasClass('checked')){
            $(this).parents('.submenu_filter').parents('li').find('.sidebar_top').find('input').iCheck('check');
          }else{
            $(this).parents('.submenu_filter').parents('li').find('.sidebar_top').find('input').iCheck('uncheck');
          }
        });

        if($(window).width() < 768){
          if($('.filter_strapwrapper').length > 0){
            $('.filter_strapwrapper li a').on('click' , function(e){
              e.preventDefault();
              var href = $(this).attr('href');
              $(href).addClass('drawer--is-open');
              $('body').addClass('js-drawer-open');
            });
            $('.filter_drawer .drawer__close').on('click' , function(){
              $(this).parents('.filter_drawer').removeClass('drawer--is-open');
              $('body').removeClass('js-drawer-open');
            });
          }

          $('.filter_sectiontitle a').on('click' , function(e){
            e.preventDefault();

            if($(this).parent('.filter_sectiontitle').hasClass('active')){
              $('.filter_mob_section').find('.filter_toggleblock').slideUp(500);
              $('.filter_mob_section').find('.filter_sectiontitle').removeClass('active');
            }else{
              $('.filter_mob_section').find('.filter_toggleblock').slideUp(500);
              $('.filter_mob_section').find('.filter_sectiontitle').removeClass('active');
              $(this).parent('.filter_sectiontitle').addClass('active');
              $(this).parents('.filter_sectionblocks').find('.filter_toggleblock').slideToggle(500);
            }
          });
        }

        if (window.location.href.indexOf("sort_by=manual") > -1) { 
          $('.brand_block.sort_filter').find('li').eq(0).addClass('active');
          $('.brand_block.sort_filter').find('li').eq(0).find('input').iCheck('check');
        }
        if (window.location.href.indexOf("sort_by=best-selling") > -1) { 
          $('.brand_block.sort_filter').find('li').eq(1).addClass('active');
          $('.brand_block.sort_filter').find('li').eq(1).find('input').iCheck('check');
        }
        if (window.location.href.indexOf("sort_by=created-ascending") > -1) { 
          $('.brand_block.sort_filter').find('li').eq(2).addClass('active');
          $('.brand_block.sort_filter').find('li').eq(2).find('input').iCheck('check');
        }
        if (window.location.href.indexOf("sort_by=created-descending") > -1) { 
          $('.brand_block.sort_filter').find('li').eq(3).addClass('active');
          $('.brand_block.sort_filter').find('li').eq(3).find('input').iCheck('check');
        }
        if (window.location.href.indexOf("sort_by=price-ascending") > -1) { 
          $('.brand_block.sort_filter').find('li').eq(4).addClass('active');
          $('.brand_block.sort_filter').find('li').eq(4).find('input').iCheck('check');
        }
        if (window.location.href.indexOf("sort_by=price-descending") > -1) { 
          $('.brand_block.sort_filter').find('li').eq(5).addClass('active');
          $('.brand_block.sort_filter').find('li').eq(5).find('input').iCheck('check');
        }


        /********** STARTS JS FOR MOBILITY FUNDER *************/
        $('.getstarted_btn a').on('click' , function(e){
          e.preventDefault();
          $(this).parents('#product_funder').addClass('overflow_wrap');
          $(this).parents('.mobilityfunder_block').fadeOut(100);
          $('.profile_blockwrapper').fadeIn(120);
          $('.profile_blockwrapper .match_height').matchHeight();
        });

        var count = 0;
        $(document).on("click", ".add_filebtn", function (e) {
          e.preventDefault();
          if($('.profile_advancewrapper').hasClass('active')){
          }else{
            $('.profile_advancewrapper').addClass('active'); 
          }
          var file_html = '<div class="clearfix appended_wrap"><div class="form-group"><div class="box filebox_wrapper file_groupwrapper"><input type="file" name="file_upload[]" id="file-upload'+count+'" class="inputfile inputfile-4" data-multiple-caption="{count} files selected" multiple /><label for="file-upload'+count+'" class="filebox_label"><figure><blockquote>Choose file</blockquote></figure> <span class="file_caption">No File Selected</span></label><span class="remove_picturebtn"><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close-redbtn.png?v=45059754807939044651757629299" alt="" /></span></div></div></div>';
          $('.profile_advancewrapper').append(file_html);      
          count++;


          $('.match_height').matchHeight();
          $('.remove_picturebtn').on('click' , function(){
            var length = $('.appended_wrap').length;
            if(length == 0){
              $('.profile_advancewrapper').removeClass('active'); 
            }
            $(this).parents('.appended_wrap').remove();


          });

          /*** STARTS JS FOR FILE INPUT ***/       
          ( function ( document, window, index )
           {
            var inputs = document.querySelectorAll( '.inputfile' );
            Array.prototype.forEach.call( inputs, function( input )
                                         {
              var label	 = input.nextElementSibling,
                  labelVal = label.innerHTML;

              input.addEventListener( 'change', function( e )
                                     {
                var fileName = '';
                if( this.files && this.files.length > 1 )
                  fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
                else
                  fileName = e.target.value.split( '\\' ).pop();

                if( fileName )
                  label.querySelector( 'span' ).innerHTML = fileName;
                else
                  label.innerHTML = labelVal;
              });

              // Firefox bug fix
              input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
              input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
            });
          }( document, window, 0 ));
          /*** ENDS JS FOR FILE INPUT ***/
        });

        if($('#product_funder').length > 0){

          $('#ProductPrice-product-template').on("DOMSubtreeModified",function(){
            var content = $(this).find('.money').html();
            $('.product_pricefunder').html(content);
            $('.productNewPrice').val(content);
          });
        }


        jQuery.validator.setDefaults({
          debug: true,
          success: "valid"
        });
        $( "#myform1 form" ).validate({
          rules: {
            "fname": "required",
            "lname": "required",
            "email": {
              required: true,
              email: true
            },
            confirm_email: {
              equalTo: "#form_email"
            },
            "campaign_name": "required"
          },
          invalidHandler: function(form, validator) {
            $('.match_height').matchHeight();
          }
        });

        $( "#myform5 form" ).validate({
          ignore: ".ignore",
          rules: {
            "term_check": "required",
            hiddenRecaptcha: {
              required: function () {
                if (grecaptcha.getResponse(html_dvCaptcha_campaign) == '') {
                  return true;
                } else {
                  return false;
                }
              }
            }
          },
          invalidHandler: function(form, validator) {
            $('.match_height').matchHeight();
          }
        });
        $('.close_productfunder a').on('click' , function(e){
          e.preventDefault();
          $.fancybox.close();
        });


        $('.crowdfundbtn').on('click' , function(e){
          e.preventDefault();
          var href = $(this).attr('href');
          $(href).fadeIn(100);
          $('.mainpage_wrapper').addClass('open_modal');
          $(href).addClass('active');
          if($(window).width() < 769){
            $('.funder_shopsection').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              autoplay: false,
              dots:true,
              infinite: false,
              swipe: true
            });
          }
        });
        $('#close_modalwrapper').on('click' , function(){
          $('#myModal').fadeOut(100);
          $('.mainpage_wrapper').removeClass('open_modal');
          $('#myModal').removeClass('active');
        });
        $('.back_page').on('click' , function(e){
          e.preventDefault();
          var current_page = window.location.href;
          window.location.href = current_page;
          $('#myModal').fadeOut(100);
          $('.mainpage_wrapper').removeClass('open_modal');
          $('#myModal').removeClass('active');
        });


        /*** STARTS JS FOR FILE INPUT ***/       

        'use strict';

        ;( function ( document, window, index )
          {
          var inputs = document.querySelectorAll( '.inputfile' );
          Array.prototype.forEach.call( inputs, function( input )
                                       {
            var label	 = input.nextElementSibling,
                labelVal = label.innerHTML;

            input.addEventListener( 'change', function( e )
                                   {
              var fileName = '';
              if( this.files && this.files.length > 1 )
                fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
              else
                fileName = e.target.value.split( '\\' ).pop();

              if( fileName )
                label.querySelector( 'span' ).innerHTML = fileName;
              else
                label.innerHTML = labelVal;
            });

            // Firefox bug fix
            input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
            input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
          });
        }( document, window, 0 ));
        /*** ENDS JS FOR FILE INPUT ***/
        //           $('#summernote').summernote({
        //             height: 300,
        //            toolbar: [
        //         ['font', ['bold', 'italic', 'list']],
        //              ['insert', ['link']],
        //              ['para', ['ul']]
        //              ]
        //              });


        var demoBaseConfig = {
          selector: "#textwrapper",
          menubar: false,
          height: 500,
          statusbar: false,
          resize: false,
          codesample_dialog_width: 600,
          codesample_dialog_height: 425,
          template_popup_width: 600,
          template_popup_height: 450,
          plugins: [
            "link lists"
          ], //removed:  charmap insertdatetime print
          toolbar:
          'bold italic link bullist',
          setup: function (ed) {
            ed.on('init', function() {
              $('.match_height').matchHeight();
            });
          }
        };


        $('.step1_submitwrapper input[type="submit"]').on('click' , function(){

          if($("#myform1 form").valid()) {  
            $('#myform1').slideUp(500);
            $('#myform1').parents('.profile_steps').removeClass('active');
            $(this).parents('.profile_steps').addClass('filled_wrap');

            $('#myform2').slideDown(500 , function(){
              setTimeout(function(){
                $('.match_height').matchHeight();
              },2000);
            });



            $('#myform2').parents('.profile_steps').addClass('active');

            if($('#myform2').parents('.profile_steps').hasClass('active')){



              tinymce.init(demoBaseConfig);
              //                 tinymce.init({
              //                   selector: 'textarea',
              //                   height: 500,
              //                   theme: 'modern',
              //                   plugins: 'print preview fullpage powerpaste searchreplace autolink directionality advcode visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount tinymcespellchecker a11ychecker imagetools mediaembed  linkchecker contextmenu colorpicker textpattern help',
              //                   //                 toolbar: ' bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat',
              //                   toolbar: [
              //                     'bold italic link bullist'
              //                   ],
              //                   branding: false,
              //                   menubar: false,
              //                   max_height: 330,
              //                    height : "330",
              //                   statusbar: false,
              //                   resize: false ,
              //                   selection_toolbar: 'bold italic quicklink h2 h3 blockquote',
              //                   setup: function (ed) {
              //                       ed.on('init', function() {
              //                           $('.match_height').matchHeight();
              //                       });
              //                   }
              //                 });
            }

            $('.profile_sidebar').find('.tips_block').removeClass('active');
            $('.profile_sidebar').find('.tips2_block').addClass('active');
          }
        });

        $( "#myform2 form" ).validate({
          rules: {
            "text_story": "required",
          },
          invalidHandler: function(form, validator) {
            $('.match_height').matchHeight();
          }
        });


        $("#fname").keyup(function(){
          var val = $(this).val();
          $("#reciver_fname").val(val);
        });
        $("#lname").keyup(function(){
          var val = $(this).val();
          $("#receiver_lname").val(val);
        });
        $("#form_email").keyup(function(){
          var val = $(this).val();
          $("#receiver_mail").val(val);
        });

        $('.donateamount input').iCheck({
          radioClass: 'iradio'
        });
        $('.campaign_checkblock input').iCheck({
          checkboxClass: 'filter_check'
        });
        $('.singleproductbottom .btnlgmax.addtocart').on('click' , function(){
          $('html, body').animate({
            scrollTop: ($('#contribute_amountsection').offset().top - 40)
          },500);
        });          


        $('.step2_submitwrapper input[type="submit"]').on('click' , function(){
          if ($("#myform2 form").valid()) {  
            $('#myform2').slideUp(500);
            $(this).parents('.profile_steps').addClass('filled_wrap');
            $('#myform2').parents('.profile_steps').removeClass('active');
            $('#myform3').slideDown(500 , function(){
              setTimeout(function(){
                $('.match_height').matchHeight();
              },1000);
            });
            $('#myform3').parents('.profile_steps').addClass('active');

            $('.profile_sidebar').find('.tips_block').removeClass('active');
            $('.profile_sidebar').find('.tips3_block').addClass('active');
          }
        });


        $( "#myform3 form" ).validate({
          rules: {
            "file_upload": "required"
            //               "profile_video": {
            //                   required: true,
            //                   url: true
            //                 }
          },
          messages: {
            file_upload: "This field is required"
          },
          invalidHandler: function(form, validator) {
            $('.match_height').matchHeight();
          }
        });

        $('.step3_submitwrapper input[type="submit"]').on('click' , function(){
          if($("#myform3 form").valid()) {  
            $('#myform3').slideUp(500);
            $('#myform3').parents('.profile_steps').removeClass('active');
            $(this).parents('.profile_steps').addClass('filled_wrap');
            $('#myform4').slideDown(500 , function(){
              setTimeout(function(){
                $('.match_height').matchHeight();
              },1000);
            });
            $('#myform4').parents('.profile_steps').addClass('active');

            $('.profile_sidebar').find('.tips_block').removeClass('active');
            $('.profile_sidebar').find('.tips4_block').addClass('active');
          }
        });

        $( "#myform4 form" ).validate({
          rules: {
            "reciver_fname": "required" ,
            "receiver_lname": "required",
            "receiver_mail": "required",
            "phone_number": "required",
            "receiver_address": "required",
            "receiver_city": "required",
            "receiver_state": "required",
            "receiver_code": "required",
            "receiver_country": "required" 
          },
          invalidHandler: function(form, validator) {
            $('.match_height').matchHeight();
          }
        });
        $('.step4_submitwrapper input[type="submit"]').on('click' , function(){
          if($("#myform4 form").valid()) {  
            $('#myform4').slideUp(500);
            $('#myform4').parents('.profile_steps').removeClass('active');
            $(this).parents('.profile_steps').addClass('filled_wrap');
            $('#myform5').slideDown(500 , function(){
              setTimeout(function(){
                $('.match_height').matchHeight();
              },1000);
            });
            $('#myform5').parents('.profile_steps').addClass('active');

            $('.profile_sidebar').find('.tips_block').removeClass('active');
            $('.profile_sidebar').find('.tips5_block').addClass('active');
          }
        });
        $('.submit_campaignform').on('click' , function(){
          if($("#myform5 form").valid()) {

            // START TO SUBMIT FORM DATA
            var form_datas = [];


            var formData = new FormData($('#picture_video_form')[0]);

            $.each($("#AddToCartForm-product-template").serializeArray(), function(i, item) {
              form_datas.push({name: item.name, value: item.value});
            });
            formData.append('extra_properties',JSON.stringify(form_datas));
            $.each($("#new_profile_form").serializeArray(), function(i, item) {
              formData.append(item.name, item.value);
            });
            $.each($("#story_form").serializeArray(), function(i, item) {
              formData.append(item.name, item.value);
            });
            $.each($("#picture_video_form").serializeArray(), function(i, item) {
              formData.append(item.name, item.value);
            });
            $.each($("#receiver_form").serializeArray(), function(i, item) {
              formData.append(item.name, item.value);
            });

            $.ajax({
              url: "https://shopify.tadpoleadaptive.com/productapp/app/add_campaign",
              type: "POST",
              contentType: false,
              cache: false,
              processData:false,
              //data: $("#get-quote-form, #AddToCartForm-product-template").serializeArray(),
              data: formData,
              success: function(result) {
                grecaptcha.reset(html_dvCaptcha_campaign);
                var data = JSON.parse(result);                  
                $( '#new_profile_form' ).each(function(){
                  this.reset();
                });
                $( '#story_form' ).each(function(){
                  this.reset();
                });
                $( '#picture_video_form' ).each(function(){
                  this.reset();
                });
                $( '#receiver_form' ).each(function(){
                  this.reset();
                });

                
              }
            });
            // END OF SUBMIT FORM DATA
            $(this).parents('#product_funder').removeClass('overflow_wrap');
            $(this).parents('.profile_blockwrapper').fadeOut(100);
            $('.successform_block').fadeIn(120);
          }
        });

        $('.tips_toptitle').on('click' , function(e){
          e.preventDefault();
          if($(this).hasClass('active')){
            $(this).removeClass('active');
            $(this).parents('.tips_accordionwrapper').find('.tips_infowrapper').slideUp(500);
          }else{
            $(this).parents('.tips_accordionwrapper').find('.tips_toptitle').removeClass('active');
            $(this).addClass('active');
            $(this).parents('.tips_accordionwrapper').find('.tips_infowrapper').slideUp(500);
            $(this).parents('.tips_blocktitle').find('.tips_infowrapper').slideDown(500);
          }
        });

        $('.tips_blockwrap a').on('click' , function(e){
          e.preventDefault();
          $(this).parents('.profile_sidebar').addClass('open_sidebar');
        });

        $('.tips_innerblockwrap a').on('click' , function(e){
          e.preventDefault();
          $(this).parents('.profile_sidebar').removeClass('open_sidebar');
        });

        $('.product_collectionslider').on('init', function(event, ){
          setTimeout(function(){
            if($('.match_productheight').length>0){
              if ($(window).width() > 768) {
                $('.match_productheight').matchHeight();
              }
            }
            $('.product_collectionslider').addClass('ready_section');
          },1000);
        });

        $('.product_collectionslider').each(function(key, item) {
      //<!-- Dhara 21/5/19 -->  
          <!-- Comment  this Code for close collection page product slider -->
          // var sliderIdName = 'slider' + key;
            //             var sliderNavIdName = 'sliderNav' + key;

          //this.id = sliderIdName;
            //             $('.product_collectionnav')[key].id = sliderNavIdName;

          //var sliderId = '#' + sliderIdName;
            //             var sliderNavId = '#' + sliderNavIdName;

          //$(sliderId).slick({
          // slidesToShow: 1,
          // slidesToScroll: 1,
          // arrows: false,
          //dots:true,
          //fade: true
          //               asNavFor: sliderNavId
          //});
           
        
        // $(sliderId).on('init', function(event, slick){
          //setTimeout(function(){
          //  $('.product_collectionslider').addClass('ready_section');
          //},1000);
        //});

          //             $(sliderNavId).slick({
          //               slidesToShow: 2,
          //               slidesToScroll: 1,
          //               asNavFor: sliderId,
          //               dots: false,
          //               arrows: false,
          //               focusOnSelect: true
          //             });



          // Remove active class from all thumbnail slides
          //             $(sliderNavId).find('.slick-slide').removeClass('slick-active');

          // Set active class to first thumbnail slides
          //             $(sliderNavId).find('.slick-slide').eq(0).addClass('slick-active');

          // On before slide change match active thumbnail to current slide
          //             $(sliderId).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          //               var mySlideNumber = nextSlide;
          //               $(sliderNavId).find('.slick-slide').removeClass('slick-active');
          //               $(sliderNavId).find('.slick-slide').eq(mySlideNumber).addClass('slick-active');
          //             });

        });


      });

      $(window).on('load' , function(){
        setTimeout(function(){
          if($('.maxproduct-single__slider').length > 0){
            var divs = $('.images_singlewrapper img');

            var smallest;
            var smallestarea = null;

            $('.images_singlewrapper img').each(function () {
              var thisarea = $(this).height() * $(this).width();
              if (smallestarea === null || thisarea < smallestarea) {
                smallest = $(this);
                smallestarea = thisarea;
              }
            });
            var maxheight = $(smallest).height();
            $(".images_singlewrapper").each(function(){
              $(this).css({"height": maxheight });
            });
          }
        },1500)



        $(document).on("click", ".filled_wrap .profile_title", function (){

          if($(this).parents('.filled_wrap').hasClass('active')){
          }else{
            $('.profile_rightcontent_block').find('.profile_steps').removeClass('active');
            $(this).parents('.profile_steps').addClass('active');
            var href = $(this).parents('.profile_steps').attr('href');
            $('.profile_sidebar .tips_block').removeClass('active');
            $(href).addClass('active');
            $('.profile_formblock').slideUp(500);
            $(this).parents('.profile_steps').find('.profile_formblock').slideDown(500);
            setTimeout(function(){
              $('.match_height').matchHeight();
            },1000);
          }
        });
        $('.sidebar_filter li').each(function(){
          if($(this).find('.submenu_filter').length > 0){
            var $this = $(this);
            setTimeout(function(){
              if($this.find('.sidebar_top').find('.filter_check').hasClass('checked')){
                $this.find('.sidebar_top').find('label').trigger('click');
              }
            }, 1000);
            
            $(this).find('.submenu_filter li').each(function(){
              if($(this).hasClass('active')){
                $(this).find('input').iCheck('check');
                $(this).parents('.submenu_filter').parents('li').find('.sidebar_top').find('input').iCheck('check');
              }
            });

            setTimeout(function(){
              $('.sidebar_filter li input').on('ifChecked', function(event){
                var href = $(this).parents('.filter_check').siblings('label').find('a').attr('href');
                if(typeof href !== "undefined") {
                  window.location = href;
                }
              });
            }, 10000);
          }
        });

       	 if($('#brand_block').length > 0){
          	$('#brand_block').find('.selected_option').html('');
            $('li.active').find('input').iCheck('check');
            $('#brand_block .brand_block .active').each(function(){
              var content = $(this).find('label').text();
              $('#brand_block').find('.selected_option').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');
              $('.filter_resultblock').find('.result_blocksection').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');                                         
            });
          }

           if($('#color_block').length > 0){
              $('#color_block').find('.selected_option').html('');
              $('#color_block .color_blockwrap .active').each(function(){
                var content = $(this).find('span').text();
                $('#color_block').find('.selected_option').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');
                $('.filter_resultblock').find('.result_blocksection').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');                                         
              });
            }

            if($('#size_block').length > 0){
              $('#size_block').find('.selected_option').html('');
              $('li.active').find('input').iCheck('check');
              $('#size_block .brand_block .active').each(function(){
                var content = $(this).find('label').text();
                $('#size_block').find('.selected_option').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');
                $('.filter_resultblock').find('.result_blocksection').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');                                         
              });
            }

             if($('#feature_block').length > 0){
                $('#feature_block').find('.selected_option').html('');
                $('li.active').find('input').iCheck('check');
                $('#feature_block .brand_block .active').each(function(){
                  var content = $(this).find('label').text();
                  $('#feature_block').find('.selected_option').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');
                  $('.filter_resultblock').find('.result_blocksection').append('<li class="select_option">'+ content +'<span><img src="//tadpoleadaptive.com/cdn/shop/t/40/assets/close_btn.png?v=10090520002818819741757629300" alt="" /></span></li>');                                         
             	});
             }                                                     

    });

             $(".drawer__inner").on('scroll',function(e){
                if($(window).width() <= 1024) {
                  tippy.hideAllPoppers();
                }
              });      
//dhara js                                                         

$('#homepage_blog').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  arrows:true,
  dots:true,
  responsive: [   
    {
      breakpoint: 768,
      settings: {
        slidesToShow:1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 340,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

                
/* common.js */
// Accrodian function js
  $(document).ready(function() {
    $('.accordion').accordion({
    defaultOpen: 'section1',
    cookieName: 'accordion_nav'
    });
  });

//input type file

  var getFile = new selectFile;
    getFile.targets('choose', 'selected');
    

  // Add Append Function
  $("#addNew").click(function () {
    $(".file-input-section").append('<input type="file" name="picture[]" required/>');
  });

  $("#add-order-one").on("click", function () {
    $(".select-item").eq(0).clone().appendTo(".quote-list");
  });

  $("#add-item-getquote").on("click", function () {
    $("#get-product-quote-form .quote-list").append('<input type="text" placeholder="Item Name" class="select-item" name="properties[item][]" data-validation="required" />');
  });

  $("#add-item-purchaseorder").on("click", function () {
    $(".purchase-list").append('<div class="contact-form-dist"><div class="item-width"><div class="input_fields_wrap"><input type="text" placeholder="Item Name" class="select-item" name="purchase_items[]" data-validation="required" /></div></div><div class="destination qty-width"><input class="destination right" type="text" name="qty[]" value="1"></div><div class="clr"></div></div>');
  });

  $("#add-order").on("click", function () {
    $(".purchase-list").append('<div class="contact-form-dist"><div class="item-width"><div class="input_fields_wrap"><input type="text" id="add-order-row" class="select-item" name="purchase-item" data-validation="required" /></div></div><div class="destination qty-width"><input class="destination right" type="text" name="qty" value="1"></div><div class="clr"></div></div>');
  });


  // checkbox js
  $('#blr').on('click', function(){
    var $$ = $(this)
    if( !$$.is('.checked')){
        $$.addClass('checked');
        $('#imgCheck').prop('checked', true);
    } else {
        $$.removeClass('checked');
        $('#imgCheck').prop('checked', false);
    }
  });


  // form reset function
  $("[data-fancybox]").fancybox({
    afterClose : function() {
      if($(document).find("#contact").length){
        $("#contact")[0].reset();
      }
      
      if($(document).find("#form-reset").length){
        $("#form-reset")[0].reset();
      }
        
      if($(document).find("#product-form").length){
        $("#product-form")[0].reset();
      }
      
      if($(document).find("#contact").length > 0) {
        if($(document).find("form#get-quote-form").length){
          $("form#get-quote-form")[0].reset();
        }
      }

      if($(document).find("#purchse-form").length){
        $("#purchse-form")[0].reset();
      }

      if(jQuery(document).find("#internationalOrderForm").length) {
        jQuery("#internationalOrderForm")[0].reset();
        jQuery("#internationalOrderForm .hideElementWrap").removeAttr('style');
        if(jQuery("#internationalOrderForm .formSingleInputElement input[type=radio]"))
          {
              jQuery('#internationalOrderForm .formSingleInputElement input[type=radio]').iCheck({
                  radioClass: 'iradio_square'
              });
          }
          if(jQuery("#internationalOrderForm .formSingleInputElement input[type=checkbox]"))
          {
              jQuery('#internationalOrderForm .formSingleInputElement input[type=checkbox]').iCheck({
                  checkboxClass: 'icheckbox_square'
              });
          }
      }
      if(jQuery(document).find("#cartQuoteForm").length) {
        jQuery("#cartQuoteForm")[0].reset();
      }
      if(jQuery(document).find("#cartPurchaseOrder").length) {
        jQuery("#cartPurchaseOrder")[0].reset();
      }
      if(jQuery(document).find("#cartContactForm").length) {
        jQuery("#cartContactForm")[0].reset();
      }
    }
  });

	
	$(".add-to-quote-btn").fancybox({
      afterLoad: function() {
        var product_name = $("#quote-form").find('.quote-list').find('input[type="text"]').val();
        var product_updated_price = $("#ProductPrice-product-template").find('span.money').text();
        //$("#quote-form").find('.quote-list').find('input[type="text"]').val(product_name+' '+product_updated_price);
        if($('#quote-form').find("#get-quote-form").length){
          $('.cart_properties').empty();
          var html = '';
          $.each($("#AddToCartForm-product-template").serializeArray(), function(i, item) {
            if(item.name != 'id') {
              var nName = item.name.replace("properties[", "");
              html += '<li><b>'+(nName.replace("]", ""))+': </b>'+item.value+'</li>';
            }
          });
          if(html != '' || html != null) {
            html += "<li><b>Total: </b>"+product_updated_price+"</li>";
          	$('.cart_properties').html(html);
          } else {
          	$('.cart_properties').html('<li>No Customized Data</li>');
          }
        }
      }
  });

  function resetFunction() {
    document.getElementById("form-reset").reset();
  }

  // pop up blur JS
  $(document).ready(function(){
    
      

    // form validator JS
      $("#contact").validate({
        rules: {
          "name": "required",
          "email": {
            required: true,
            email: true
          },
          "contact-via": "required"
        }
      });

      $("#purchse-form").validate({
        rules: {
          "name": "required",
          "email": {
            required: true,
            email: true
          },
          "order-number": "required",
          "bill-address": "required",
          "ship-address": "required"
        }
      });

      $("#form-reset").validate({
        rules: {
          "name": "required",
          "email": {
            required: true,
            email: true
          },
          "profile": "required",
          "picture": "required"
        }
      });

      $("#shipping-form").validate({
        rules: {
          "name": "required",
          "email": {
            required: true,
            email: true       
          }
        }
      });
		
<!-- New js start -->
  
        if($('.accessoryqoteformbtn').length > 0){

      $('.accessoryqoteformbtn').unbind('click');
      $('.accessoryqoteformbtn').click(function(e) {
        e.preventDefault();
        $("#accessory-quote-enquireform").validate({

            rules: {
                'userName': "required",
                'userEmail': "required",
                'userPhone': "required",
                'comments':  "required",
                'serialNumber':"required"    
            },
            messages: {
                'userName': "Contact Name is required.",
                'userEmail': "Email is required.",
                'userPhone': "Your Phone number is required.",
                'comments': "Comment box is required."
            }
            });      

        $captcha = $('#dvCaptcha_accessories');
        response = grecaptcha.getResponse(html_dvCaptcha_accessories);

        if (!$captcha.hasClass("error")) {
          $captcha.addClass("error");
        } else {
          $('.msg-error').text('');
          $captcha.removeClass("error");
        }
        if (response.length === 0) {
          $('.msg-error').show();
          $('.msg-error').text("Please check the captcha form.");
        } else {
          $('.msg-error').hide();
        }

        if($("#accessory-quote-enquireform").valid()) {
          if (response.length === 0) {
            $('.msg-error').show();
            $('.msg-error').text("Please check the captcha form.");
            return;
          }
          
          var formData = new FormData($('#accessory-quote-enquireform')[0]);
          
          $.each($("#accessory-quote-enquireform").serializeArray(), function(i, item) {
            formData.append(item.name, item.value);
          });
          
          $.ajax({
            url: "https://shopify.tadpoleadaptive.com/productapp/app/add_accessories_quote",
            type: "POST",
            contentType: false,
            cache: false,
            processData:false,
            data: formData,
            success: function(result) {
              grecaptcha.reset(html_dvCaptcha_accessories);
              var data = JSON.parse(result);
              $( '#accessory-quote-enquireform' ).each(function(){
                this.reset();
              });
              swal({
                  type: (data.success == 'true' ? 'success' : 'error'),
                  html: data.message
              });
            }
          });

        }
      });
    }

<!-- New js end -->

 

    
    if($('.sendQuestion').length > 0){
      
      $('.sendQuestion').unbind('click');
      $('.sendQuestion').click(function(e) {
        e.preventDefault();
        $("#product-form").validate({
          rules: {
            'userName': "required",
            'userEmail': "required",
            'respondBy[]': "required"
          },
          messages: {
            'userName': "Name is required.",
            'userEmail': "Email is required.",
            'respondBy[]': "Choose respose by."
          }
        });      

        $captcha = $('#dvCaptcha_pc');
        response = grecaptcha.getResponse(html_element_pc);

        if (!$captcha.hasClass("error")) {
          $captcha.addClass("error");
        } else {
          $('.msg-error').text('');
          $captcha.removeClass("error");
        }
        if (response.length === 0) {
          $('.msg-error').show();
          $('.msg-error').text("Please check the captcha form.");
        } else {
          $('.msg-error').hide();
        }

        if($("#product-form").valid()) {
          if (response.length === 0) {
            $('.msg-error').show();
            $('.msg-error').text("Please check the captcha form.");
            return;
          }
          $.ajax({
            url: "https://shopify.tadpoleadaptive.com/productapp/app/add_product_question",
            type: "POST",
            data: $("#product-form").serialize(),
            success: function(result) {
              grecaptcha.reset(html_element_pc);
              var data = JSON.parse(result);
              $( '#product-form' ).each(function(){
                this.reset();
              });
              swal({
                  type: (data.success == 'true' ? 'success' : 'error'),
                  html: data.message
              });
            }
          });
        }
      });
    }
    
    
    if($('.sendPriceMatch').length > 0){
      $('.sendPriceMatch').unbind('click');
      $('.sendPriceMatch').click(function(e) {
        e.preventDefault();
        $("#price-form").validate({
          rules: {
            'userName': "required",
            'userEmail': "required",
            'competitorProductLink': "required",
            'competitorPrice': "required",
            'likeToPay': "required"          
          },
          messages: {
            'userName': "Name is required.",
            'userEmail': "Email is required.",
            'competitorProductLink': "Insert competitor product link.",
            'competitorPrice': "Insert competitor price.",
            'likeToPay': "Insert price you want to pay for this product."
          }
        });      

        $captcha = $('#dvCaptcha_pm');
        response = grecaptcha.getResponse(html_element_pm);

        if (!$captcha.hasClass("error")) {
          $captcha.addClass("error");
        } else {
          $('.msg-error').text('');
          $captcha.removeClass("error");
        }
        if (response.length === 0) {
          $('.msg-error').show();
          $('.msg-error').text("Please check the captcha form.");
        } else {
          $('.msg-error').hide();
        }

        if($("#price-form").valid()) {
          if (response.length === 0) {
            $('.msg-error').show();
            $('.msg-error').text("Please check the captcha form.");
            return;
          }
          $.ajax({
            url: "https://shopify.tadpoleadaptive.com/productapp/app/add_price_match",
            type: "POST",
            data: $("#price-form").serialize(),
            success: function(result) {
              grecaptcha.reset(html_element_pm);
              var data = JSON.parse(result);
              $( '#price-form' ).each(function(){
                this.reset();
              });
              swal({
                  type: (data.success == 'true' ? 'success' : 'error'),
                  text: data.message
              });
            }
          });
        }
      });
    }

    
    
    if($('.worldwide_submitbtn').length > 0){
      $('.worldwide_submitbtn').unbind('click');
      $('.worldwide_submitbtn').click(function(e) {
        e.preventDefault();
        $("#worldwide-form").validate({
          rules: {
            'userName': "required",
            'userEmail': "required"          
          },
          messages: {
            'userName': "Name is required.",
            'userEmail': "Email is required."
          }
        });      

        $captcha = $('#dvCaptcha_worldship');
        response = grecaptcha.getResponse(html_element_worldwide);

        if (!$captcha.hasClass("error")) {
          $captcha.addClass("error");
        } else {
          $('.msg-error').text('');
          $captcha.removeClass("error");
        }
        if (response.length === 0) {
          $('.msg-error').show();
          $('.msg-error').text("Please check the captcha form.");
        } else {
          $('.msg-error').hide();
        }

        if($("#worldwide-form").valid()) {
          if (response.length === 0) {
            $('.msg-error').show();
            $('.msg-error').text("Please check the captcha form.");
            return;
          }
          $.ajax({
            url: "https://shopify.tadpoleadaptive.com/productapp/app/add_worldwide_delivery",
            type: "POST",
            data: $("#worldwide-form").serialize(),
            success: function(result) {
              grecaptcha.reset(html_element_worldwide);
              var data = JSON.parse(result);
              $( '#worldwide-form' ).each(function(){
                this.reset();
              });
              swal({
                  type: (data.success == 'true' ? 'success' : 'error'),
                  text: data.message
              });
            }
          });

        }
      });
    }
    
    if($('.submitQuote').length > 0){
    $('.submitQuote').unbind('click');
    $('.submitQuote').click(function(e) {
      e.preventDefault();
      $("#get-product-quote-form").validate({
        rules: {
          'userEmail': "required",
          'userName': "required",
          'street': "required",
          'zipcode': "required",
          'city': "required",
          'state': "required",
          'userPhone': "required",
          'userMobile': { 
             required: '#canWeText1[value="1"]:checked'
           },
          'items': "required"
        },
        messages: {
          'userEmail': "Email address is required.",
          'userName': "Name is required.",
          'street': "Street address is required.",
          'zipcode': "Zip code/postal code is required.",
          'city': "City is required.",
          'state': "State is required.",
          'userPhone': "Phone number is required.",
          'userMobile': {
              required: "Mobile Number is required."
           },
          'items': "Choose at least one option."
        }
      });      
      
      $captcha = $('#dvCaptcha_quote');
      response = grecaptcha.getResponse(html_element_quote);
	
      if (!$captcha.hasClass("error")) {
        $captcha.addClass("error");
      } else {
        $('.msg-error').text('');
        $captcha.removeClass("error");
      }
      if (response.length === 0) {
        $('.msg-error').show();
        $('.msg-error').text("Please check the captcha form.");
      } else {
        $('.msg-error').hide();
      }

      if($("#get-product-quote-form").valid()) {
        if (response.length === 0) {
          $('.msg-error').show();
          $('.msg-error').text("Please check the captcha form.");
          return;
        }
        
        var properties = [];
        $.each($("#AddToCartForm-product-template").serializeArray(), function(i, item) {
          properties.push({name: item.name, value: item.value});
        });
        var hasItems = false;
        $.each($("#get-product-quote-form").serializeArray(), function(i, item) {
          var str1 = item.name;
          if(str1.indexOf("properties[item]") != -1)
          {
            hasItems = true;
          }
          else
          {
            properties.push({name: item.name, value: item.value});
          }
          
        });
        if(hasItems)
        {
          var items = [];
          $.each($("#get-product-quote-form").serializeArray(), function(i, item) {
            var str1 = item.name;
            if(str1.indexOf("properties[item]") != -1)
            {
              items.push(item.value);
            }
          });
          if(typeof items != "undefined" && items != null && items != "" && items.length > 0)
          {
            var arrayToString = items.join(", ");
            properties.push({name: "items", value: arrayToString});
          }
        }
        if($("#get-product-quote-form .field-wrapper ul.cart_properties").length > 0)
        {
          var customEmailHtml = '<ul class="cart_properties">'+$.trim($("#get-product-quote-form .field-wrapper ul.cart_properties").html())+'</ul>';
          properties.push({name: 'customEmailHtml', value: customEmailHtml});
        }
        $.ajax({
          url: "https://shopify.tadpoleadaptive.com/productapp/app/add_quote",
          type: "POST",
          //data: $("#get-product-quote-form, #AddToCartForm-product-template").serializeArray(),
          data: {properties: properties},
          success: function(result) {
            grecaptcha.reset(html_element_quote);
            var data = JSON.parse(result);
            console.log(data.html);
            $( '#get-product-quote-form' ).each(function(){
              this.reset();
            });
            swal({
                type: (data.success == 'true' ? 'success' : 'error'),
                text: data.message
            });
          }
        });
      }
    });
    }

    if($('.sendContactUs').length > 0){
      
      $('.sendContactUs').unbind('click');
      $('.sendContactUs').click(function(e) {
        e.preventDefault();
        $("#send_contact_form").validate({
          rules: {
            'userName': "required",
            'userEmail': "required",
            'respondBy[]': "required"
          },
          messages: {
            'userName': "Name is required.",
            'userEmail': "Email is required.",
            'respondBy[]': "Choose respose by."
          }
        });      

        $captcha = $('#dvCaptcha_contact');
        response = grecaptcha.getResponse(html_contact_form);

        if (!$captcha.hasClass("error")) {
          $captcha.addClass("error");
        } else {
          $('.msg-error').text('');
          $captcha.removeClass("error");
        }
        if (response.length === 0) {
          $('.msg-error').show();
          $('.msg-error').text("Please check the captcha form.");
        } else {
          $('.msg-error').hide();
        }

        if($("#send_contact_form").valid()) {
          if (response.length === 0) {
            $('.msg-error').show();
            $('.msg-error').text("Please check the captcha form.");
            return;
          }
          $.ajax({
            url: "https://shopify.tadpoleadaptive.com/productapp/app/add_contact_us",
            type: "POST",
            data: $("#send_contact_form").serialize(),
            success: function(result) {
              grecaptcha.reset(html_contact_form);
              var data = JSON.parse(result);
              $( '#send_contact_form' ).each(function(){
                this.reset();
              });
              swal({
                  type: (data.success == 'true' ? 'success' : 'error'),
                  html: data.message
              });
            }
          });
        }
      });
    }


    if($('.submit_one_on_one_form').length > 0){

      $('.submit_one_on_one_form').unbind('click');
      $('.submit_one_on_one_form').click(function(e) {
        e.preventDefault();
        $("#form-reset").validate({

            rules: {
                'userName': "required",
                'userEmail': "required",
                'userPhone': "required",
                'funding_sources': "required",
                'information': "required",
                'picture': "required"
            },
            messages: {
                'userName': "Contact Name is required.",
                'userEmail': "Email is required.",
                'userPhone': "Your Phone number is required.",
                'funding_sources': "Select at least one funding source.",
                'information': "Information is required.",
                'picture': "Select at least one picture."
            }
            });      

        $captcha = $('#dvCaptcha_tp');
        response = grecaptcha.getResponse(html_dvCaptcha_tp);

        if (!$captcha.hasClass("error")) {
          $captcha.addClass("error");
        } else {
          $('.msg-error').text('');
          $captcha.removeClass("error");
        }
        if (response.length === 0) {
          $('.msg-error').show();
          $('.msg-error').text("Please check the captcha form.");
        } else {
          $('.msg-error').hide();
        }

        if($("#form-reset").valid()) {
          if (response.length === 0) {
            $('.msg-error').show();
            $('.msg-error').text("Please check the captcha form.");
            return;
          }
          
          var formData = new FormData($('#form-reset')[0]);
          
          $.each($("#accessory-quote-enquireform").serializeArray(), function(i, item) {
            formData.append(item.name, item.value);
          });
          
          $.ajax({
            url: "https://shopify.tadpoleadaptive.com/productapp/app/add_one_on_one",
            type: "POST",
            contentType: false,
            cache: false,
            processData:false,
            data: formData,
            success: function(result) {
              grecaptcha.reset(html_dvCaptcha_tp);
              var data = JSON.parse(result);
              $( '#form-reset' ).each(function(){
                this.reset();
              });
              swal({
                  type: (data.success == 'true' ? 'success' : 'error'),
                  html: data.message
              });
            }
          });

        }
      });
    }
    	
  });
                
                
/* Crowdfund.js */
//PS JS
 
  jQuery('.multiple-items').slick({
    dots: true,
    prevArrow: false,
    nextArrow: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

// social share toggle
  $(document).ready(function(){
    $(".mobilityFunderSearchButton").on('click',function(e){
      e.preventDefault();
      var searchValue = $("input[name='searchName']").val();
      if(typeof searchValue != "undefined" && searchValue != "" && searchValue != null)
      {
        var formData = $(".mobilityFunderSearchForm").serialize();
        $('body').append("<div class='customLoader'></div>");
        $(document).find('.customLoader').show();
        $.ajax({
        url: 'https://shopify.tadpoleadaptive.com/productapp/app/moblity_funder_search',
        type: 'POST',
        data: formData,
        dataType: 'json',
        success: function(result) {
          if(result.success == 'true')
          {
            $(".resultsData").html("");
            $(".resultsData").html("<h2>"+result.totalResults+" results</h2>"+result.html);
            if($(window).width() > 768) {
              setTimeout(function(){
              $('.match_productheight').matchHeight();
              },2400);
              setTimeout(function(){
              $('.grid__item.collection_productcol').matchHeight();
              },3000);
            }
            setTimeout(function(){
            $('body,html').animate({scrollTop: $(".resultsData").offset().top}, 1000);
            },3000);
          }
          else
          {
            if(result.success == 'false')
            {
              $(".resultsData").html("");
              $(".resultsData").html("<h2>"+result.message+"</h2>");
            }
          }
          setTimeout(function(){
          $(document).find('.customLoader').remove();
          },3000);
        }
      });
      }
    });
    $(".sharebutton").click(function(e){
      e.preventDefault();
        var href= $(this).attr('href');
        $(href).slideToggle();
    });
    
    // CONTRIBUTE RADIO BUTTON AMOUNT SELECT CHANGE EVENT
    $('input[name="donateamountradio"]').on('ifChecked', function() {
      	var contribute_amount = Math.trunc($(this).val().replace(/,/g, ''));
      	contribute_amount_array = [];
      	setVariantData(contribute_amount.toString());
      	$('.text_amountblock').val(contribute_amount);
    });
    
    // SUBMIT FORM ON CLICK OF CONTRIBUTE NOW BUTTON
    $('.contribute_btn span').unbind('click');
    $('.contribute_btn span').click(function(e) {
      e.preventDefault();
      if($(".text_amountblock").val() == '' || $(".text_amountblock").val() == null) {
        $('.amount-error').show();
        return false;
      }
      $('.cart_submit_btn').trigger('click');
    });
    
    // CHECK IF ENTERED AMOUNT IS MULTIPLES OF 5
    $(".text_amountblock").focusout(function(){
      var number = Math.trunc($(this).val().replace(/,/g, ''));
      var result = number % 5;
      var result_amount = number;
      if(number > 500 && ($.inArray(number, contribute_amount_array) === -1)) {
        alert('You can contribute a max of 500 or the entire remaining amount, not in between');
        result_amount = 500;
        $('#radio5').iCheck('check');
      } else {
        $('input[name="donateamountradio"]').iCheck('uncheck');
      }
      
      if (number % 5 !== 0 && ($.inArray(number, contribute_amount_array) === -1)) {
        result_amount = (number - result);
      }  
      
      if(result_amount == 0 || isNaN(result_amount)) {
        result_amount = 5;
      }
      $('.text_amountblock').val(result_amount);
      
      contribute_amount_array = [];
      setVariantData(result_amount.toString());
    });
    
    // SET COOKIE
    var c_time = (new Date().getTime());
    if(!$.cookie("heart_id")) {
      $.cookie("heart_id", c_time, { expires: 30 });
    }

    $(document).unbind('click', '#wishlist_icon');
    $(document).on('click', '#wishlist_icon', function() {
      var productID = $(this).parent().parent().data('productid');
      var cookieID = '';
      if(!$.cookie("heart_id")) {
        cookieID = c_time;
      } else {
        cookieID = $.cookie("heart_id");
      }
      var action = '';
      if($(this).hasClass('fa-heart-o')) {
        action = 'unlike';
      } else {
        action = 'like';
      }

      $.ajax({
        url: "https://shopify.tadpoleadaptive.com/productapp/app/add_product_like",
        type: "POST",
        data: {productID: productID, cookieID: cookieID, action: action},
        success: function(result) {
          var data = JSON.parse(result);
        }
      });

      
    });
});



var contribute_amount_array = [];
function setVariantData(contribute_amount) {
  $('.amount-error').hide();
  $('.contribute-amount').each(function(index, element) {
    var c_amount = Math.trunc($(this).val().replace(/,/g, ''));
    contribute_amount_array.push(c_amount);
    if(c_amount == Math.trunc(contribute_amount.replace(/,/g, ''))) {
      var variant_id = $(this).attr('id');
      var variant_title = $(this).attr("data-variant_title");
      $('.product-select').val(variant_id);
      $('.product-select').attr('data-variant_title', variant_title);
    }
  });
  
  if($.inArray((Math.trunc(contribute_amount.replace(/,/g, ''))), contribute_amount_array) === -1) {
    $('.product-select').val('');
    $('.product-select').attr('data-variant_title', '');
  }
}
$(document).ready(function(){
  if($('.measurementsForm').length > 0) {
    $(".measurementsClearBtn").on("click", function(){
      if($(".other-input").length > 0)
      {
        $(".other-input").removeClass("active");
        $(".other-input").find("input").val("");
      }
    });
    $("#UserRelationship").on("change", function(){
      var currentValue = $.trim($(this).val());
      if(typeof currentValue != "undefined" && currentValue != null && currentValue != "")
      {
        if(currentValue == "Other")
        {
          if($(".other-input").length > 0)
          {
            $(".other-input").addClass("active");
          }
        }
        else
        {
          if($(".other-input").length > 0)
          {
            $(".other-input").removeClass("active");
            $(".other-input").find("input").val("");
          }
        }
      }
    });
    $(".measurementsForm").validate({
      rules: {
        'FloorToButtocks': "required",
        'FloorToElbow': "required",
        'Inseam': "required",
        'FloorToArmpit': "required",
        'FloorToWrist': "required",
        'StandingHeight': "required",
        'ChestWidth': "required",
        'HipWidth': "required",
        'WidthAtKnees': "required",
        'KneeToHeel': "required",
        'SeatToTopOfHead': "required",
        'SeatDepth': "required",
        'SeatToShoulder': "required",
        'UserHeight': "required",
        'UserWeight': "required",
        'UserAge': "required",
        'Username': "required",
        'UserRelationship': "required",
        'OtherRelationship': { 
           required: function (el) {
                return $(el).closest('form').find('#UserRelationship').val() == 'Other';
            }
        },
        'UserEmail': {
          required: true,
          email: true
        },
        'EquipmentConsideration': "required"
      },
      messages: {
        'FloorToButtocks': "Floor to Buttocks is required.",
        'FloorToElbow': "Floor to Elbow or Bent Arm is required.",
        'Inseam': "Inseam is required.",
        'FloorToArmpit': "Floor to Armpit is required.",
        'FloorToWrist': "Floor to Wrist is required.",
        'StandingHeight': "Standing Height is required.",
        'ChestWidth': "Chest Width is required.",
        'HipWidth': "Hip Width is required.",
        'WidthAtKnees': "Width at Knees is required.",
        'KneeToHeel': "Knee to Heel is required.",
        'SeatToTopOfHead': "Seat to Top of Head is required.",
        'SeatDepth': "Seat Depth is required.",
        'SeatToShoulder': "Seat to Shoulder is required.",
        'UserHeight': "User height is required.",
        'UserWeight': "User weight is required.",
        'UserAge': "User age is required.",
        'Username': "User name is required.",
        'UserRelationship': "User relationship is required.",
        'OtherRelationship': {
            required: "Other relationship is required."
         },
        'UserEmail': {
          required: "Email address is required.",
          email: "Enter valid email address."
        },
        'EquipmentConsideration': "Equipment Being Considered is required.",
      }
    });  
    $('.measurementsSubmitBtn').unbind('click');
    $('.measurementsSubmitBtn').on("click", function(e) {
      e.preventDefault();
      if($(".measurementsForm").valid()) {
        jQuery('body').append("<div class='customFormLoader'></div>");
        jQuery(document).find('.customFormLoader').show();
        var formData = new FormData(jQuery('.measurementsForm')[0]);
        jQuery.ajax({
          url: "https://shopify.tadpoleadaptive.com/productapp/app/add_measurements",
          type: "POST",
          contentType: false,
          cache: false,
          processData:false,
          data: formData,
          success: function(result) {
            var data = JSON.parse(result);
            jQuery(document).find('.customFormLoader').remove();
            swal({
              type: (data.success == 'true' ? 'success' : 'error'),
              html: data.message
            });
          }
        });
      }
    });
  }
});